/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.5.0.0 (NJsonSchema v10.1.15.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';

export class B2BProvajderiProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    vratiB2BProvajdere(tip: number | null): Promise<B2BProvajder[] | null> {
        let url_ = this.baseUrl + "/api/B2BProvajderi?";
        if (tip === undefined)
            throw new Error("The parameter 'tip' must be defined.");
        else if(tip !== null)
            url_ += "tip=" + encodeURIComponent("" + tip) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiB2BProvajdere(_response);
        });
    }

    protected processVratiB2BProvajdere(response: AxiosResponse): Promise<B2BProvajder[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(B2BProvajder.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<B2BProvajder[] | null>(<any>null);
    }
}

export class PodesavanjeSistemaProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    vratiPodesavanjeSistema(): Promise<PodesavanjeSistema | null> {
        let url_ = this.baseUrl + "/api/PodesavanjeSistema";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiPodesavanjeSistema(_response);
        });
    }

    protected processVratiPodesavanjeSistema(response: AxiosResponse): Promise<PodesavanjeSistema | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PodesavanjeSistema.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PodesavanjeSistema | null>(<any>null);
    }

    sacuvajPodesavanjeSistema(podesavanjeSistema: PodesavanjeSistema | null): Promise<PodesavanjeSistema | null> {
        let url_ = this.baseUrl + "/api/PodesavanjeSistema";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(podesavanjeSistema);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSacuvajPodesavanjeSistema(_response);
        });
    }

    protected processSacuvajPodesavanjeSistema(response: AxiosResponse): Promise<PodesavanjeSistema | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PodesavanjeSistema.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PodesavanjeSistema | null>(<any>null);
    }
}

export class PodsetniciProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    sacuvajPodsetnikVozila(podsetnikVozila: PodsetnikVozila | null): Promise<PodsetnikVozila | null> {
        let url_ = this.baseUrl + "/api/Podsetnici/SacuvajPodsetnikVozila";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(podsetnikVozila);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSacuvajPodsetnikVozila(_response);
        });
    }

    protected processSacuvajPodsetnikVozila(response: AxiosResponse): Promise<PodsetnikVozila | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PodsetnikVozila.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PodsetnikVozila | null>(<any>null);
    }

    vratiPodsetnikePoVozilu(idVozila: number): Promise<PodsetnikVozila[] | null> {
        let url_ = this.baseUrl + "/api/Podsetnici/VratiPodsetnikePoVozilu/{idVozila}";
        if (idVozila === undefined || idVozila === null)
            throw new Error("The parameter 'idVozila' must be defined.");
        url_ = url_.replace("{idVozila}", encodeURIComponent("" + idVozila));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiPodsetnikePoVozilu(_response);
        });
    }

    protected processVratiPodsetnikePoVozilu(response: AxiosResponse): Promise<PodsetnikVozila[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PodsetnikVozila.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PodsetnikVozila[] | null>(<any>null);
    }

    vratiPodsetnikVozilaPoId(id: number): Promise<PodsetnikVozila | null> {
        let url_ = this.baseUrl + "/api/Podsetnici/VratiPodsetnikVozilaPoId/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiPodsetnikVozilaPoId(_response);
        });
    }

    protected processVratiPodsetnikVozilaPoId(response: AxiosResponse): Promise<PodsetnikVozila | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PodsetnikVozila.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PodsetnikVozila | null>(<any>null);
    }

    vratiPodsetnikeVozila(): Promise<PodsetnikVozila[] | null> {
        let url_ = this.baseUrl + "/api/Podsetnici/VratiPodsetnikeVozila";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiPodsetnikeVozila(_response);
        });
    }

    protected processVratiPodsetnikeVozila(response: AxiosResponse): Promise<PodsetnikVozila[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PodsetnikVozila.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PodsetnikVozila[] | null>(<any>null);
    }

    sacuvajPodsetnikOsobe(podsetnikOsobe: PodsetnikOsobe | null): Promise<PodsetnikOsobe | null> {
        let url_ = this.baseUrl + "/api/Podsetnici/SacuvajPodsetnikOsobe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(podsetnikOsobe);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSacuvajPodsetnikOsobe(_response);
        });
    }

    protected processSacuvajPodsetnikOsobe(response: AxiosResponse): Promise<PodsetnikOsobe | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PodsetnikOsobe.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PodsetnikOsobe | null>(<any>null);
    }

    vratiPodsetnikeOsobe(idOsobe: number): Promise<PodsetnikOsobe[] | null> {
        let url_ = this.baseUrl + "/api/Podsetnici/VratiPodsetnikeOsobe/{idOsobe}";
        if (idOsobe === undefined || idOsobe === null)
            throw new Error("The parameter 'idOsobe' must be defined.");
        url_ = url_.replace("{idOsobe}", encodeURIComponent("" + idOsobe));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiPodsetnikeOsobe(_response);
        });
    }

    protected processVratiPodsetnikeOsobe(response: AxiosResponse): Promise<PodsetnikOsobe[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PodsetnikOsobe.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PodsetnikOsobe[] | null>(<any>null);
    }

    vratiPodsetnikOsobePoId(id: number): Promise<PodsetnikOsobe | null> {
        let url_ = this.baseUrl + "/api/Podsetnici/VratiPodsetnikOsobePoId/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiPodsetnikOsobePoId(_response);
        });
    }

    protected processVratiPodsetnikOsobePoId(response: AxiosResponse): Promise<PodsetnikOsobe | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PodsetnikOsobe.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PodsetnikOsobe | null>(<any>null);
    }

    vratiPodsetnikeOsoba(): Promise<PodsetnikOsobe[] | null> {
        let url_ = this.baseUrl + "/api/Podsetnici/VratiPodsetnikeOsoba";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiPodsetnikeOsoba(_response);
        });
    }

    protected processVratiPodsetnikeOsoba(response: AxiosResponse): Promise<PodsetnikOsobe[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PodsetnikOsobe.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PodsetnikOsobe[] | null>(<any>null);
    }

    vratiOpisePodsetnikaVozila(term: string): Promise<string[] | null> {
        let url_ = this.baseUrl + "/api/Podsetnici/VratiOpisePodsetnikaVozila/{term}";
        if (term === undefined || term === null)
            throw new Error("The parameter 'term' must be defined.");
        url_ = url_.replace("{term}", encodeURIComponent("" + term));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiOpisePodsetnikaVozila(_response);
        });
    }

    protected processVratiOpisePodsetnikaVozila(response: AxiosResponse): Promise<string[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[] | null>(<any>null);
    }

    vratiOpisePodsetnikaOsoba(term: string): Promise<string[] | null> {
        let url_ = this.baseUrl + "/api/Podsetnici/VratiOpisePodsetnikaOsoba/{term}";
        if (term === undefined || term === null)
            throw new Error("The parameter 'term' must be defined.");
        url_ = url_.replace("{term}", encodeURIComponent("" + term));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiOpisePodsetnikaOsoba(_response);
        });
    }

    protected processVratiOpisePodsetnikaOsoba(response: AxiosResponse): Promise<string[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[] | null>(<any>null);
    }

    obradiPodsetnike(): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Podsetnici/ObradiPodsetnike";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processObradiPodsetnike(_response);
        });
    }

    protected processObradiPodsetnike(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    obrisiPodsetnik(id: number): Promise<any | null> {
        let url_ = this.baseUrl + "/api/Podsetnici/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processObrisiPodsetnik(_response);
        });
    }

    protected processObrisiPodsetnik(response: AxiosResponse): Promise<any | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any | null>(<any>null);
    }
}

export class TransakcijeProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    sacuvajTransakcijeKorisnika(transakcijeKorisnika: TransakcijeKorisnika | null): Promise<TransakcijeKorisnika | null> {
        let url_ = this.baseUrl + "/api/Transakcije";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(transakcijeKorisnika);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSacuvajTransakcijeKorisnika(_response);
        });
    }

    protected processSacuvajTransakcijeKorisnika(response: AxiosResponse): Promise<TransakcijeKorisnika | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? TransakcijeKorisnika.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TransakcijeKorisnika | null>(<any>null);
    }

    vratiTransakcijeKorisika(id: number): Promise<TransakcijeKorisnika | null> {
        let url_ = this.baseUrl + "/api/Transakcije/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiTransakcijeKorisika(_response);
        });
    }

    protected processVratiTransakcijeKorisika(response: AxiosResponse): Promise<TransakcijeKorisnika | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? TransakcijeKorisnika.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TransakcijeKorisnika | null>(<any>null);
    }
}

export class DashboardProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    pripremiDashboard(): Promise<void> {
        let url_ = this.baseUrl + "/api/Dashboard/PripremiDashboard";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "PUT",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPripremiDashboard(_response);
        });
    }

    protected processPripremiDashboard(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    vratiDashboard(): Promise<Dashboard | null> {
        let url_ = this.baseUrl + "/api/Dashboard";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiDashboard(_response);
        });
    }

    protected processVratiDashboard(response: AxiosResponse): Promise<Dashboard | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? Dashboard.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Dashboard | null>(<any>null);
    }
}

export class FirmaProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    vratiFirmu(): Promise<Firma | null> {
        let url_ = this.baseUrl + "/api/Firma";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiFirmu(_response);
        });
    }

    protected processVratiFirmu(response: AxiosResponse): Promise<Firma | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? Firma.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Firma | null>(<any>null);
    }

    sacuvajFirmu(firma: Firma | null): Promise<number> {
        let url_ = this.baseUrl + "/api/Firma";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(firma);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSacuvajFirmu(_response);
        });
    }

    protected processSacuvajFirmu(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 ? ValidationException.fromJS(resultData400) : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(<any>null);
    }
}

export class IzvestajiProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    vratiIzvestajPredjenihKilometaraIPotrosnjeGorivaPoGrupamaVozila(godina: number): Promise<PredjeniKilometriIPotrosnjaGoriva | null> {
        let url_ = this.baseUrl + "/api/Izvestaji/VratiIzvestajPredjenihKilometaraIPotrosnjeGorivaPoGrupamaVozila?";
        if (godina === undefined || godina === null)
            throw new Error("The parameter 'godina' must be defined and cannot be null.");
        else
            url_ += "godina=" + encodeURIComponent("" + godina) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiIzvestajPredjenihKilometaraIPotrosnjeGorivaPoGrupamaVozila(_response);
        });
    }

    protected processVratiIzvestajPredjenihKilometaraIPotrosnjeGorivaPoGrupamaVozila(response: AxiosResponse): Promise<PredjeniKilometriIPotrosnjaGoriva | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PredjeniKilometriIPotrosnjaGoriva.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PredjeniKilometriIPotrosnjaGoriva | null>(<any>null);
    }

    vratiTroskovePoVozilima(): Promise<F_izv_TroskoviVozila[] | null> {
        let url_ = this.baseUrl + "/api/Izvestaji/VratiTroskovePoVozilima";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiTroskovePoVozilima(_response);
        });
    }

    protected processVratiTroskovePoVozilima(response: AxiosResponse): Promise<F_izv_TroskoviVozila[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(F_izv_TroskoviVozila.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<F_izv_TroskoviVozila[] | null>(<any>null);
    }

    vratiPrejdeneKilometreVozilaIVozaca(): Promise<F_izv_VratiPrejdeneKilometreVozilaIVozaca[] | null> {
        let url_ = this.baseUrl + "/api/Izvestaji/VratiPrejdeneKilometreVozilaIVozaca";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiPrejdeneKilometreVozilaIVozaca(_response);
        });
    }

    protected processVratiPrejdeneKilometreVozilaIVozaca(response: AxiosResponse): Promise<F_izv_VratiPrejdeneKilometreVozilaIVozaca[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(F_izv_VratiPrejdeneKilometreVozilaIVozaca.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<F_izv_VratiPrejdeneKilometreVozilaIVozaca[] | null>(<any>null);
    }

    vratiPregledKretanjaVozila(odDatuma: Date, doDatuma: Date, vozilo: number): Promise<PregledKretanja[] | null> {
        let url_ = this.baseUrl + "/api/Izvestaji/VratiPregledKretanjaVozila?";
        if (odDatuma === undefined || odDatuma === null)
            throw new Error("The parameter 'odDatuma' must be defined and cannot be null.");
        else
            url_ += "odDatuma=" + encodeURIComponent(odDatuma ? "" + odDatuma.toJSON() : "") + "&";
        if (doDatuma === undefined || doDatuma === null)
            throw new Error("The parameter 'doDatuma' must be defined and cannot be null.");
        else
            url_ += "doDatuma=" + encodeURIComponent(doDatuma ? "" + doDatuma.toJSON() : "") + "&";
        if (vozilo === undefined || vozilo === null)
            throw new Error("The parameter 'vozilo' must be defined and cannot be null.");
        else
            url_ += "vozilo=" + encodeURIComponent("" + vozilo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiPregledKretanjaVozila(_response);
        });
    }

    protected processVratiPregledKretanjaVozila(response: AxiosResponse): Promise<PregledKretanja[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PregledKretanja.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PregledKretanja[] | null>(<any>null);
    }

    vratiPregledKretanjaVozaca(odDatuma: Date, doDatuma: Date, vozac: number): Promise<PregledKretanja[] | null> {
        let url_ = this.baseUrl + "/api/Izvestaji/VratiPregledKretanjaVozaca?";
        if (odDatuma === undefined || odDatuma === null)
            throw new Error("The parameter 'odDatuma' must be defined and cannot be null.");
        else
            url_ += "odDatuma=" + encodeURIComponent(odDatuma ? "" + odDatuma.toJSON() : "") + "&";
        if (doDatuma === undefined || doDatuma === null)
            throw new Error("The parameter 'doDatuma' must be defined and cannot be null.");
        else
            url_ += "doDatuma=" + encodeURIComponent(doDatuma ? "" + doDatuma.toJSON() : "") + "&";
        if (vozac === undefined || vozac === null)
            throw new Error("The parameter 'vozac' must be defined and cannot be null.");
        else
            url_ += "vozac=" + encodeURIComponent("" + vozac) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiPregledKretanjaVozaca(_response);
        });
    }

    protected processVratiPregledKretanjaVozaca(response: AxiosResponse): Promise<PregledKretanja[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PregledKretanja.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PregledKretanja[] | null>(<any>null);
    }
}

export class NotificationsProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    sendNotification(notificationType: NotificationType | undefined, message: string | null | undefined, payload: any | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Notifications/SendNotification?";
        if (notificationType === null)
            throw new Error("The parameter 'notificationType' cannot be null.");
        else if (notificationType !== undefined)
            url_ += "notificationType=" + encodeURIComponent("" + notificationType) + "&";
        if (message !== undefined && message !== null)
            url_ += "message=" + encodeURIComponent("" + message) + "&";
        if (payload !== undefined && payload !== null)
            url_ += "payload=" + encodeURIComponent("" + payload) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSendNotification(_response);
        });
    }

    protected processSendNotification(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }
}

export class DokumentaProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    vratiDokumentaPoBroju(broj: string): Promise<Dokument[] | null> {
        let url_ = this.baseUrl + "/api/Dokumenta/{broj}";
        if (broj === undefined || broj === null)
            throw new Error("The parameter 'broj' must be defined.");
        url_ = url_.replace("{broj}", encodeURIComponent("" + broj));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiDokumentaPoBroju(_response);
        });
    }

    protected processVratiDokumentaPoBroju(response: AxiosResponse): Promise<Dokument[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Dokument.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Dokument[] | null>(<any>null);
    }

    obrisiStavkuDokumenta(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/Dokumenta/ObrisiStavkuDokumenta/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processObrisiStavkuDokumenta(_response);
        });
    }

    protected processObrisiStavkuDokumenta(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(<any>null);
    }

    vratiStavkeServisneOperacije(id: number): Promise<StavkaDokumenta[] | null> {
        let url_ = this.baseUrl + "/api/Dokumenta/VratiStavkeServisneOperacije/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiStavkeServisneOperacije(_response);
        });
    }

    protected processVratiStavkeServisneOperacije(response: AxiosResponse): Promise<StavkaDokumenta[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StavkaDokumenta.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StavkaDokumenta[] | null>(<any>null);
    }

    vratiStavkeRezervnihDelova(id: number): Promise<StavkaDokumenta[] | null> {
        let url_ = this.baseUrl + "/api/Dokumenta/VratiStavkeRezervnihDelova/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiStavkeRezervnihDelova(_response);
        });
    }

    protected processVratiStavkeRezervnihDelova(response: AxiosResponse): Promise<StavkaDokumenta[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StavkaDokumenta.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StavkaDokumenta[] | null>(<any>null);
    }

    vratiArtikalPoOpisu(deoNaziva: string | null): Promise<Artikal[] | null> {
        let url_ = this.baseUrl + "/api/Dokumenta/VratiArtikalPoOpisu?";
        if (deoNaziva === undefined)
            throw new Error("The parameter 'deoNaziva' must be defined.");
        else if(deoNaziva !== null)
            url_ += "deoNaziva=" + encodeURIComponent("" + deoNaziva) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiArtikalPoOpisu(_response);
        });
    }

    protected processVratiArtikalPoOpisu(response: AxiosResponse): Promise<Artikal[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Artikal.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Artikal[] | null>(<any>null);
    }

    pretraziDokumente(tip: string | null | undefined, godina: number | null | undefined, vozilo: number | null | undefined, dobavljac: number | null | undefined, odDatuma: Date | null | undefined, doDatuma: Date | null | undefined, status: number | null | undefined): Promise<DokumentInfo[] | null> {
        let url_ = this.baseUrl + "/api/Dokumenta/PretraziDokumente?";
        if (tip !== undefined && tip !== null)
            url_ += "tip=" + encodeURIComponent("" + tip) + "&";
        if (godina !== undefined && godina !== null)
            url_ += "godina=" + encodeURIComponent("" + godina) + "&";
        if (vozilo !== undefined && vozilo !== null)
            url_ += "vozilo=" + encodeURIComponent("" + vozilo) + "&";
        if (dobavljac !== undefined && dobavljac !== null)
            url_ += "dobavljac=" + encodeURIComponent("" + dobavljac) + "&";
        if (odDatuma !== undefined && odDatuma !== null)
            url_ += "odDatuma=" + encodeURIComponent(odDatuma ? "" + odDatuma.toJSON() : "") + "&";
        if (doDatuma !== undefined && doDatuma !== null)
            url_ += "doDatuma=" + encodeURIComponent(doDatuma ? "" + doDatuma.toJSON() : "") + "&";
        if (status !== undefined && status !== null)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPretraziDokumente(_response);
        });
    }

    protected processPretraziDokumente(response: AxiosResponse): Promise<DokumentInfo[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DokumentInfo.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DokumentInfo[] | null>(<any>null);
    }

    vratiPregledDokumenta(tipDokumenta: string | null, id: number): Promise<DokumentInfo | null> {
        let url_ = this.baseUrl + "/api/Dokumenta/VratiPregledDokumenta?";
        if (tipDokumenta === undefined)
            throw new Error("The parameter 'tipDokumenta' must be defined.");
        else if(tipDokumenta !== null)
            url_ += "tipDokumenta=" + encodeURIComponent("" + tipDokumenta) + "&";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiPregledDokumenta(_response);
        });
    }

    protected processVratiPregledDokumenta(response: AxiosResponse): Promise<DokumentInfo | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? DokumentInfo.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DokumentInfo | null>(<any>null);
    }

    vratiPovezanaDokumenta(id: number): Promise<PovezaniDokument[] | null> {
        let url_ = this.baseUrl + "/api/Dokumenta/VratiPovezanaDokumenta/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiPovezanaDokumenta(_response);
        });
    }

    protected processVratiPovezanaDokumenta(response: AxiosResponse): Promise<PovezaniDokument[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PovezaniDokument.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PovezaniDokument[] | null>(<any>null);
    }
}

export class FaktureProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    vratiFakturuPoId(id: number): Promise<Faktura | null> {
        let url_ = this.baseUrl + "/api/Fakture/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiFakturuPoId(_response);
        });
    }

    protected processVratiFakturuPoId(response: AxiosResponse): Promise<Faktura | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? Faktura.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Faktura | null>(<any>null);
    }

    sacuvajFakturu(faktura: Faktura | null): Promise<Faktura | null> {
        let url_ = this.baseUrl + "/api/Fakture";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(faktura);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSacuvajFakturu(_response);
        });
    }

    protected processSacuvajFakturu(response: AxiosResponse): Promise<Faktura | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? Faktura.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Faktura | null>(<any>null);
    }

    zakljuciFakturu(faktura: Faktura | null): Promise<Faktura | null> {
        let url_ = this.baseUrl + "/api/Fakture/ZakljuciFakturu";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(faktura);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processZakljuciFakturu(_response);
        });
    }

    protected processZakljuciFakturu(response: AxiosResponse): Promise<Faktura | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? Faktura.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Faktura | null>(<any>null);
    }
}

export class GrupeDelovaVozilaProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    vratiGrupeDelovaVozila(): Promise<GrupeDelovaVozila[] | null> {
        let url_ = this.baseUrl + "/api/GrupeDelovaVozila";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiGrupeDelovaVozila(_response);
        });
    }

    protected processVratiGrupeDelovaVozila(response: AxiosResponse): Promise<GrupeDelovaVozila[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GrupeDelovaVozila.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GrupeDelovaVozila[] | null>(<any>null);
    }

    sacuvajGrupuDelovaVozila(grupeDelova: GrupeDelovaVozila | null): Promise<GrupeDelovaVozila | null> {
        let url_ = this.baseUrl + "/api/GrupeDelovaVozila";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(grupeDelova);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSacuvajGrupuDelovaVozila(_response);
        });
    }

    protected processSacuvajGrupuDelovaVozila(response: AxiosResponse): Promise<GrupeDelovaVozila | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? GrupeDelovaVozila.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GrupeDelovaVozila | null>(<any>null);
    }

    obrisiGrupuDelovaVozila(id: number): Promise<GrupeDelovaVozila[] | null> {
        let url_ = this.baseUrl + "/api/GrupeDelovaVozila/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processObrisiGrupuDelovaVozila(_response);
        });
    }

    protected processObrisiGrupuDelovaVozila(response: AxiosResponse): Promise<GrupeDelovaVozila[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GrupeDelovaVozila.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GrupeDelovaVozila[] | null>(<any>null);
    }
}

export class InterniRadniNaloziProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    sacuvajInterniRadniNalog(radniNalog: RadniNalog | null): Promise<RadniNalog | null> {
        let url_ = this.baseUrl + "/api/InterniRadniNalozi";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(radniNalog);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSacuvajInterniRadniNalog(_response);
        });
    }

    protected processSacuvajInterniRadniNalog(response: AxiosResponse): Promise<RadniNalog | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? RadniNalog.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RadniNalog | null>(<any>null);
    }

    vratiInterneRadneNaloge(): Promise<RadniNalog[] | null> {
        let url_ = this.baseUrl + "/api/InterniRadniNalozi";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiInterneRadneNaloge(_response);
        });
    }

    protected processVratiInterneRadneNaloge(response: AxiosResponse): Promise<RadniNalog[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RadniNalog.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RadniNalog[] | null>(<any>null);
    }

    vratiInterniRadniNalogPoId(id: number): Promise<RadniNalog | null> {
        let url_ = this.baseUrl + "/api/InterniRadniNalozi/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiInterniRadniNalogPoId(_response);
        });
    }

    protected processVratiInterniRadniNalogPoId(response: AxiosResponse): Promise<RadniNalog | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? RadniNalog.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RadniNalog | null>(<any>null);
    }

    zakljuciInterniRadniNalog(radniNalog: RadniNalog | null): Promise<number> {
        let url_ = this.baseUrl + "/api/InterniRadniNalozi/ZakljuciInterniRadniNalog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(radniNalog);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processZakljuciInterniRadniNalog(_response);
        });
    }

    protected processZakljuciInterniRadniNalog(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(<any>null);
    }

    vratiZatvoreneInterneRadneNaloge(): Promise<RadniNalog[] | null> {
        let url_ = this.baseUrl + "/api/InterniRadniNalozi/VratiZatvoreneInterneRadneNaloge";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiZatvoreneInterneRadneNaloge(_response);
        });
    }

    protected processVratiZatvoreneInterneRadneNaloge(response: AxiosResponse): Promise<RadniNalog[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RadniNalog.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RadniNalog[] | null>(<any>null);
    }

    vratiZatvorenInterniRadniNalogPoId(id: number): Promise<RadniNalog | null> {
        let url_ = this.baseUrl + "/api/InterniRadniNalozi/VratiZatvorenInterniRadniNalogPoId/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiZatvorenInterniRadniNalogPoId(_response);
        });
    }

    protected processVratiZatvorenInterniRadniNalogPoId(response: AxiosResponse): Promise<RadniNalog | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? RadniNalog.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RadniNalog | null>(<any>null);
    }

    potvrdiInterniRadniNalog(radniNalog: RadniNalog | null): Promise<RadniNalog | null> {
        let url_ = this.baseUrl + "/api/InterniRadniNalozi/PotvrdiInterniRadniNalog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(radniNalog);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPotvrdiInterniRadniNalog(_response);
        });
    }

    protected processPotvrdiInterniRadniNalog(response: AxiosResponse): Promise<RadniNalog | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? RadniNalog.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RadniNalog | null>(<any>null);
    }
}

export class IzdatniceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    sacuvajIzdatnicu(izdatnica: Izdatnica | null): Promise<Izdatnica | null> {
        let url_ = this.baseUrl + "/api/Izdatnice/SacuvajIzdatnicu";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(izdatnica);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSacuvajIzdatnicu(_response);
        });
    }

    protected processSacuvajIzdatnicu(response: AxiosResponse): Promise<Izdatnica | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? Izdatnica.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Izdatnica | null>(<any>null);
    }

    zakljuciIzdatnicu(izdatnica: Izdatnica | null): Promise<Izdatnica | null> {
        let url_ = this.baseUrl + "/api/Izdatnice/ZakljuciIzdatnicu";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(izdatnica);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processZakljuciIzdatnicu(_response);
        });
    }

    protected processZakljuciIzdatnicu(response: AxiosResponse): Promise<Izdatnica | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? Izdatnica.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Izdatnica | null>(<any>null);
    }

    vratiIzdatnicuPoId(id: number): Promise<Izdatnica | null> {
        let url_ = this.baseUrl + "/api/Izdatnice/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiIzdatnicuPoId(_response);
        });
    }

    protected processVratiIzdatnicuPoId(response: AxiosResponse): Promise<Izdatnica | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? Izdatnica.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Izdatnica | null>(<any>null);
    }
}

export class IzvestajiOdrzavanjaVozilaProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    vratiTroskoveOdrzavanjaPoMesecima(godina: number, grupaVozila: number | null, kategorijaVozila: number | null, vozilo: number | null, mesec: number | null): Promise<string[][] | null> {
        let url_ = this.baseUrl + "/api/IzvestajiOdrzavanjaVozila/VratiTroskoveOdrzavanjaPoMesecima?";
        if (godina === undefined || godina === null)
            throw new Error("The parameter 'godina' must be defined and cannot be null.");
        else
            url_ += "godina=" + encodeURIComponent("" + godina) + "&";
        if (grupaVozila === undefined)
            throw new Error("The parameter 'grupaVozila' must be defined.");
        else if(grupaVozila !== null)
            url_ += "grupaVozila=" + encodeURIComponent("" + grupaVozila) + "&";
        if (kategorijaVozila === undefined)
            throw new Error("The parameter 'kategorijaVozila' must be defined.");
        else if(kategorijaVozila !== null)
            url_ += "kategorijaVozila=" + encodeURIComponent("" + kategorijaVozila) + "&";
        if (vozilo === undefined)
            throw new Error("The parameter 'vozilo' must be defined.");
        else if(vozilo !== null)
            url_ += "vozilo=" + encodeURIComponent("" + vozilo) + "&";
        if (mesec === undefined)
            throw new Error("The parameter 'mesec' must be defined.");
        else if(mesec !== null)
            url_ += "mesec=" + encodeURIComponent("" + mesec) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiTroskoveOdrzavanjaPoMesecima(_response);
        });
    }

    protected processVratiTroskoveOdrzavanjaPoMesecima(response: AxiosResponse): Promise<string[][] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[][] | null>(<any>null);
    }

    vratiAnalitikuTroskovaOdrzavanja(godina: number | null, mesec: number | null, kategorijaVozila: number | null, grupaVozila: number | null, vozilo: number | null, vrstaOdrzavanja: number | null): Promise<F_AnalitikaTroskovaOdrzavanja[] | null> {
        let url_ = this.baseUrl + "/api/IzvestajiOdrzavanjaVozila/VratiAnalitikuTroskovaOdrzavanja?";
        if (godina === undefined)
            throw new Error("The parameter 'godina' must be defined.");
        else if(godina !== null)
            url_ += "godina=" + encodeURIComponent("" + godina) + "&";
        if (mesec === undefined)
            throw new Error("The parameter 'mesec' must be defined.");
        else if(mesec !== null)
            url_ += "mesec=" + encodeURIComponent("" + mesec) + "&";
        if (kategorijaVozila === undefined)
            throw new Error("The parameter 'kategorijaVozila' must be defined.");
        else if(kategorijaVozila !== null)
            url_ += "kategorijaVozila=" + encodeURIComponent("" + kategorijaVozila) + "&";
        if (grupaVozila === undefined)
            throw new Error("The parameter 'grupaVozila' must be defined.");
        else if(grupaVozila !== null)
            url_ += "grupaVozila=" + encodeURIComponent("" + grupaVozila) + "&";
        if (vozilo === undefined)
            throw new Error("The parameter 'vozilo' must be defined.");
        else if(vozilo !== null)
            url_ += "vozilo=" + encodeURIComponent("" + vozilo) + "&";
        if (vrstaOdrzavanja === undefined)
            throw new Error("The parameter 'vrstaOdrzavanja' must be defined.");
        else if(vrstaOdrzavanja !== null)
            url_ += "vrstaOdrzavanja=" + encodeURIComponent("" + vrstaOdrzavanja) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiAnalitikuTroskovaOdrzavanja(_response);
        });
    }

    protected processVratiAnalitikuTroskovaOdrzavanja(response: AxiosResponse): Promise<F_AnalitikaTroskovaOdrzavanja[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(F_AnalitikaTroskovaOdrzavanja.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<F_AnalitikaTroskovaOdrzavanja[] | null>(<any>null);
    }
}

export class PovratniceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    vratiPovratnicuPoId(id: number): Promise<Povratnica | null> {
        let url_ = this.baseUrl + "/api/Povratnice/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiPovratnicuPoId(_response);
        });
    }

    protected processVratiPovratnicuPoId(response: AxiosResponse): Promise<Povratnica | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? Povratnica.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Povratnica | null>(<any>null);
    }

    sacuvajPovratnicu(povratnica: Povratnica | null): Promise<Povratnica | null> {
        let url_ = this.baseUrl + "/api/Povratnice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(povratnica);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSacuvajPovratnicu(_response);
        });
    }

    protected processSacuvajPovratnicu(response: AxiosResponse): Promise<Povratnica | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? Povratnica.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Povratnica | null>(<any>null);
    }

    zakljuciPovratnicu(povratnica: Povratnica | null): Promise<Povratnica | null> {
        let url_ = this.baseUrl + "/api/Povratnice/ZakljuciPovratnicu";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(povratnica);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processZakljuciPovratnicu(_response);
        });
    }

    protected processZakljuciPovratnicu(response: AxiosResponse): Promise<Povratnica | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? Povratnica.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Povratnica | null>(<any>null);
    }
}

export class PrijaveKvaraProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    sacuvajPrijavuKvara(prijavaKvara: PrijavaKvara | null): Promise<PrijavaKvara | null> {
        let url_ = this.baseUrl + "/api/PrijaveKvara";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(prijavaKvara);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSacuvajPrijavuKvara(_response);
        });
    }

    protected processSacuvajPrijavuKvara(response: AxiosResponse): Promise<PrijavaKvara | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PrijavaKvara.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PrijavaKvara | null>(<any>null);
    }

    vratiPrijaveKvara(): Promise<PrijavaKvara[] | null> {
        let url_ = this.baseUrl + "/api/PrijaveKvara";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiPrijaveKvara(_response);
        });
    }

    protected processVratiPrijaveKvara(response: AxiosResponse): Promise<PrijavaKvara[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PrijavaKvara.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PrijavaKvara[] | null>(<any>null);
    }

    vratiPrijavuKvaraPoId(id: number): Promise<PrijavaKvara | null> {
        let url_ = this.baseUrl + "/api/PrijaveKvara/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiPrijavuKvaraPoId(_response);
        });
    }

    protected processVratiPrijavuKvaraPoId(response: AxiosResponse): Promise<PrijavaKvara | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PrijavaKvara.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PrijavaKvara | null>(<any>null);
    }

    odobriPrijavuKvara(id: number): Promise<PrijavaKvara[] | null> {
        let url_ = this.baseUrl + "/api/PrijaveKvara/{id}/odobri";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processOdobriPrijavuKvara(_response);
        });
    }

    protected processOdobriPrijavuKvara(response: AxiosResponse): Promise<PrijavaKvara[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PrijavaKvara.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PrijavaKvara[] | null>(<any>null);
    }

    odbiPrijavuKvara(id: number, razlogOdbijanja: RazlogOdbijanjaPrijaveKvara | null): Promise<PrijavaKvara[] | null> {
        let url_ = this.baseUrl + "/api/PrijaveKvara/{id}/odbi";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(razlogOdbijanja);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processOdbiPrijavuKvara(_response);
        });
    }

    protected processOdbiPrijavuKvara(response: AxiosResponse): Promise<PrijavaKvara[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PrijavaKvara.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PrijavaKvara[] | null>(<any>null);
    }

    vratiPrijaveKvaraZaVozilo(vozilo: number | null | undefined): Promise<PrijavaKvara[] | null> {
        let url_ = this.baseUrl + "/api/PrijaveKvara/VratiPrijaveKvaraZaVozilo?";
        if (vozilo !== undefined && vozilo !== null)
            url_ += "vozilo=" + encodeURIComponent("" + vozilo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiPrijaveKvaraZaVozilo(_response);
        });
    }

    protected processVratiPrijaveKvaraZaVozilo(response: AxiosResponse): Promise<PrijavaKvara[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PrijavaKvara.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PrijavaKvara[] | null>(<any>null);
    }
}

export class PrijemniceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    sacuvajPrijemnicu(prijemnica: Prijemnica | null): Promise<Prijemnica | null> {
        let url_ = this.baseUrl + "/api/Prijemnice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(prijemnica);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSacuvajPrijemnicu(_response);
        });
    }

    protected processSacuvajPrijemnicu(response: AxiosResponse): Promise<Prijemnica | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? Prijemnica.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Prijemnica | null>(<any>null);
    }

    vratiPrijemnicuPoId(id: number): Promise<Prijemnica | null> {
        let url_ = this.baseUrl + "/api/Prijemnice/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiPrijemnicuPoId(_response);
        });
    }

    protected processVratiPrijemnicuPoId(response: AxiosResponse): Promise<Prijemnica | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? Prijemnica.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Prijemnica | null>(<any>null);
    }

    zakljuciPrijemnicu(prijemnica: Prijemnica | null): Promise<Prijemnica | null> {
        let url_ = this.baseUrl + "/api/Prijemnice/ZakljuciPrijemnicu";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(prijemnica);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processZakljuciPrijemnicu(_response);
        });
    }

    protected processZakljuciPrijemnicu(response: AxiosResponse): Promise<Prijemnica | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? Prijemnica.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Prijemnica | null>(<any>null);
    }
}

export class RezervniDeloviProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    vratiRezervneDelove(): Promise<RezervniDeo[] | null> {
        let url_ = this.baseUrl + "/api/RezervniDelovi";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiRezervneDelove(_response);
        });
    }

    protected processVratiRezervneDelove(response: AxiosResponse): Promise<RezervniDeo[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RezervniDeo.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RezervniDeo[] | null>(<any>null);
    }

    sacuvajRezervniDeo(dto: RezervniDeo | null): Promise<RezervniDeo | null> {
        let url_ = this.baseUrl + "/api/RezervniDelovi";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSacuvajRezervniDeo(_response);
        });
    }

    protected processSacuvajRezervniDeo(response: AxiosResponse): Promise<RezervniDeo | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? RezervniDeo.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RezervniDeo | null>(<any>null);
    }

    obrisiRezervniDeo(id: number): Promise<RezervniDeo[] | null> {
        let url_ = this.baseUrl + "/api/RezervniDelovi/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processObrisiRezervniDeo(_response);
        });
    }

    protected processObrisiRezervniDeo(response: AxiosResponse): Promise<RezervniDeo[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RezervniDeo.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RezervniDeo[] | null>(<any>null);
    }

    vratiRezervneDelovePoKataloskomBroju(term: string | null): Promise<RezervniDeo[] | null> {
        let url_ = this.baseUrl + "/api/RezervniDelovi/VratiRezervneDelovePoKataloskomBroju?";
        if (term === undefined)
            throw new Error("The parameter 'term' must be defined.");
        else if(term !== null)
            url_ += "term=" + encodeURIComponent("" + term) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiRezervneDelovePoKataloskomBroju(_response);
        });
    }

    protected processVratiRezervneDelovePoKataloskomBroju(response: AxiosResponse): Promise<RezervniDeo[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RezervniDeo.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RezervniDeo[] | null>(<any>null);
    }

    vratiRezervneDelovePoNazivu(term: string | null): Promise<RezervniDeo[] | null> {
        let url_ = this.baseUrl + "/api/RezervniDelovi/VratiRezervneDelovePoNazivu?";
        if (term === undefined)
            throw new Error("The parameter 'term' must be defined.");
        else if(term !== null)
            url_ += "term=" + encodeURIComponent("" + term) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiRezervneDelovePoNazivu(_response);
        });
    }

    protected processVratiRezervneDelovePoNazivu(response: AxiosResponse): Promise<RezervniDeo[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RezervniDeo.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RezervniDeo[] | null>(<any>null);
    }

    vratiRezervneDeloveUSkladistu(skladiste: number): Promise<ZalihaRezervnogDela[] | null> {
        let url_ = this.baseUrl + "/api/RezervniDelovi/VratiRezervneDeloveUSkladistu/{skladiste}";
        if (skladiste === undefined || skladiste === null)
            throw new Error("The parameter 'skladiste' must be defined.");
        url_ = url_.replace("{skladiste}", encodeURIComponent("" + skladiste));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiRezervneDeloveUSkladistu(_response);
        });
    }

    protected processVratiRezervneDeloveUSkladistu(response: AxiosResponse): Promise<ZalihaRezervnogDela[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ZalihaRezervnogDela.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ZalihaRezervnogDela[] | null>(<any>null);
    }
}

export class ServisneOperacijeProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    vratiServisneOperacije(): Promise<ServisnaOperacija[] | null> {
        let url_ = this.baseUrl + "/api/ServisneOperacije";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiServisneOperacije(_response);
        });
    }

    protected processVratiServisneOperacije(response: AxiosResponse): Promise<ServisnaOperacija[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServisnaOperacija.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServisnaOperacija[] | null>(<any>null);
    }

    sacuvajServisnuOperaciju(dto: ServisnaOperacija | null): Promise<ServisnaOperacija | null> {
        let url_ = this.baseUrl + "/api/ServisneOperacije";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSacuvajServisnuOperaciju(_response);
        });
    }

    protected processSacuvajServisnuOperaciju(response: AxiosResponse): Promise<ServisnaOperacija | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServisnaOperacija.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServisnaOperacija | null>(<any>null);
    }

    vratiServisneOperacijePoNazivu(term: string | null): Promise<ServisnaOperacija[] | null> {
        let url_ = this.baseUrl + "/api/ServisneOperacije/VratiServisneOperacijePoNazivu?";
        if (term === undefined)
            throw new Error("The parameter 'term' must be defined.");
        else if(term !== null)
            url_ += "term=" + encodeURIComponent("" + term) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiServisneOperacijePoNazivu(_response);
        });
    }

    protected processVratiServisneOperacijePoNazivu(response: AxiosResponse): Promise<ServisnaOperacija[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServisnaOperacija.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServisnaOperacija[] | null>(<any>null);
    }

    obrisiServisnuOperaciju(id: number): Promise<ServisnaOperacija[] | null> {
        let url_ = this.baseUrl + "/api/ServisneOperacije/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processObrisiServisnuOperaciju(_response);
        });
    }

    protected processObrisiServisnuOperaciju(response: AxiosResponse): Promise<ServisnaOperacija[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServisnaOperacija.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServisnaOperacija[] | null>(<any>null);
    }
}

export class TrebovanjaProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    sacuvajTrebovanje(trebovanje: Trebovanje | null): Promise<Trebovanje | null> {
        let url_ = this.baseUrl + "/api/Trebovanja";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(trebovanje);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSacuvajTrebovanje(_response);
        });
    }

    protected processSacuvajTrebovanje(response: AxiosResponse): Promise<Trebovanje | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? Trebovanje.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Trebovanje | null>(<any>null);
    }

    vratiTrebovanja(skladiste: number | null | undefined): Promise<Trebovanje[] | null> {
        let url_ = this.baseUrl + "/api/Trebovanja?";
        if (skladiste !== undefined && skladiste !== null)
            url_ += "skladiste=" + encodeURIComponent("" + skladiste) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiTrebovanja(_response);
        });
    }

    protected processVratiTrebovanja(response: AxiosResponse): Promise<Trebovanje[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Trebovanje.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Trebovanje[] | null>(<any>null);
    }

    vratiTrebovanjePoId(id: number): Promise<Trebovanje | null> {
        let url_ = this.baseUrl + "/api/Trebovanja/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiTrebovanjePoId(_response);
        });
    }

    protected processVratiTrebovanjePoId(response: AxiosResponse): Promise<Trebovanje | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? Trebovanje.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Trebovanje | null>(<any>null);
    }
}

export class TroskoviVozilaProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    vratiTroskoveVozila(): Promise<TrosakVozila[] | null> {
        let url_ = this.baseUrl + "/api/TroskoviVozila";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiTroskoveVozila(_response);
        });
    }

    protected processVratiTroskoveVozila(response: AxiosResponse): Promise<TrosakVozila[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TrosakVozila.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TrosakVozila[] | null>(<any>null);
    }

    sacuvajTrosakVozila(trosakVozila: TrosakVozila | null): Promise<TrosakVozila | null> {
        let url_ = this.baseUrl + "/api/TroskoviVozila";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(trosakVozila);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSacuvajTrosakVozila(_response);
        });
    }

    protected processSacuvajTrosakVozila(response: AxiosResponse): Promise<TrosakVozila | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? TrosakVozila.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TrosakVozila | null>(<any>null);
    }

    obrisiTrosakVozila(id: number): Promise<TrosakVozila[] | null> {
        let url_ = this.baseUrl + "/api/TroskoviVozila/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processObrisiTrosakVozila(_response);
        });
    }

    protected processObrisiTrosakVozila(response: AxiosResponse): Promise<TrosakVozila[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TrosakVozila.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TrosakVozila[] | null>(<any>null);
    }
}

export class VrsteOdrzavanjaProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    vratiVrsteOdrzavanja(): Promise<VrstaOdrzavanja[] | null> {
        let url_ = this.baseUrl + "/api/VrsteOdrzavanja";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiVrsteOdrzavanja(_response);
        });
    }

    protected processVratiVrsteOdrzavanja(response: AxiosResponse): Promise<VrstaOdrzavanja[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VrstaOdrzavanja.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VrstaOdrzavanja[] | null>(<any>null);
    }

    sacuvajVrstuOdrzavanja(vrstaOdrzavanja: VrstaOdrzavanja | null): Promise<VrstaOdrzavanja | null> {
        let url_ = this.baseUrl + "/api/VrsteOdrzavanja";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vrstaOdrzavanja);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSacuvajVrstuOdrzavanja(_response);
        });
    }

    protected processSacuvajVrstuOdrzavanja(response: AxiosResponse): Promise<VrstaOdrzavanja | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? VrstaOdrzavanja.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 ? ValidationException.fromJS(resultData400) : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VrstaOdrzavanja | null>(<any>null);
    }

    obrisiVrstuOdrzavanja(id: number): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/VrsteOdrzavanja/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processObrisiVrstuOdrzavanja(_response);
        });
    }

    protected processObrisiVrstuOdrzavanja(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }
}

export class ZaliheRezervnihDelovaProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    vratiZaliheUSkladistu(id: number): Promise<ZalihaRezervnogDela[] | null> {
        let url_ = this.baseUrl + "/api/ZaliheRezervnihDelova/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiZaliheUSkladistu(_response);
        });
    }

    protected processVratiZaliheUSkladistu(response: AxiosResponse): Promise<ZalihaRezervnogDela[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ZalihaRezervnogDela.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ZalihaRezervnogDela[] | null>(<any>null);
    }
}

export class OrganizacioneJediniceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    vratiOrganizacioneJedinice(): Promise<OrganizacionaJedinica[] | null> {
        let url_ = this.baseUrl + "/api/OrganizacioneJedinice";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiOrganizacioneJedinice(_response);
        });
    }

    protected processVratiOrganizacioneJedinice(response: AxiosResponse): Promise<OrganizacionaJedinica[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizacionaJedinica.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrganizacionaJedinica[] | null>(<any>null);
    }

    sacuvajOrganizacionuJedinicu(organizacionaJedinica: OrganizacionaJedinica | null): Promise<OrganizacionaJedinica[] | null> {
        let url_ = this.baseUrl + "/api/OrganizacioneJedinice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(organizacionaJedinica);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSacuvajOrganizacionuJedinicu(_response);
        });
    }

    protected processSacuvajOrganizacionuJedinicu(response: AxiosResponse): Promise<OrganizacionaJedinica[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizacionaJedinica.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrganizacionaJedinica[] | null>(<any>null);
    }

    obrisiOrganizacionuJedinicu(id: number): Promise<OrganizacionaJedinica[] | null> {
        let url_ = this.baseUrl + "/api/OrganizacioneJedinice/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processObrisiOrganizacionuJedinicu(_response);
        });
    }

    protected processObrisiOrganizacionuJedinicu(response: AxiosResponse): Promise<OrganizacionaJedinica[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizacionaJedinica.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrganizacionaJedinica[] | null>(<any>null);
    }

    vratiSkladista(): Promise<OrganizacionaJedinica[] | null> {
        let url_ = this.baseUrl + "/api/OrganizacioneJedinice/VratiSkladista";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiSkladista(_response);
        });
    }

    protected processVratiSkladista(response: AxiosResponse): Promise<OrganizacionaJedinica[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizacionaJedinica.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrganizacionaJedinica[] | null>(<any>null);
    }
}

export class OsobeProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    vratiOsobe(aktivne: boolean): Promise<Osoba[] | null> {
        let url_ = this.baseUrl + "/api/Osobe?";
        if (aktivne === undefined || aktivne === null)
            throw new Error("The parameter 'aktivne' must be defined and cannot be null.");
        else
            url_ += "aktivne=" + encodeURIComponent("" + aktivne) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiOsobe(_response);
        });
    }

    protected processVratiOsobe(response: AxiosResponse): Promise<Osoba[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Osoba.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Osoba[] | null>(<any>null);
    }

    sacuvajOsobu(osoba: Osoba | null): Promise<Osoba | null> {
        let url_ = this.baseUrl + "/api/Osobe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(osoba);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSacuvajOsobu(_response);
        });
    }

    protected processSacuvajOsobu(response: AxiosResponse): Promise<Osoba | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? Osoba.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Osoba | null>(<any>null);
    }

    vratiOsobu(id: number): Promise<Osoba | null> {
        let url_ = this.baseUrl + "/api/Osobe/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiOsobu(_response);
        });
    }

    protected processVratiOsobu(response: AxiosResponse): Promise<Osoba | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? Osoba.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Osoba | null>(<any>null);
    }

    obrisiOsobu(id: number): Promise<Osoba[] | null> {
        let url_ = this.baseUrl + "/api/Osobe/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processObrisiOsobu(_response);
        });
    }

    protected processObrisiOsobu(response: AxiosResponse): Promise<Osoba[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Osoba.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Osoba[] | null>(<any>null);
    }

    promeniLozinku(id: number, lozinka: NovaLozinka | null): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Osobe/{id}/PromeniLozinku";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(lozinka);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPromeniLozinku(_response);
        });
    }

    protected processPromeniLozinku(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    promeniMojuLozinku(lozinka: NovaLozinka | null): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Osobe/PromeniMojuLozinku";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(lozinka);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPromeniMojuLozinku(_response);
        });
    }

    protected processPromeniMojuLozinku(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    vratiFunkcijeOsoba(): Promise<RadnoMesto[] | null> {
        let url_ = this.baseUrl + "/api/Osobe/VratiFunkcijeOsoba";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiFunkcijeOsoba(_response);
        });
    }

    protected processVratiFunkcijeOsoba(response: AxiosResponse): Promise<RadnoMesto[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RadnoMesto.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RadnoMesto[] | null>(<any>null);
    }

    vratiPripadajuceOsobe(): Promise<Osoba[] | null> {
        let url_ = this.baseUrl + "/api/Osobe/VratiPripadajuceOsobe";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiPripadajuceOsobe(_response);
        });
    }

    protected processVratiPripadajuceOsobe(response: AxiosResponse): Promise<Osoba[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Osoba.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Osoba[] | null>(<any>null);
    }

    vratiVozace(): Promise<Osoba[] | null> {
        let url_ = this.baseUrl + "/api/Osobe/VratiVozace";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiVozace(_response);
        });
    }

    protected processVratiVozace(response: AxiosResponse): Promise<Osoba[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Osoba.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Osoba[] | null>(<any>null);
    }

    vratiServisere(): Promise<Osoba[] | null> {
        let url_ = this.baseUrl + "/api/Osobe/VratiServisere";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiServisere(_response);
        });
    }

    protected processVratiServisere(response: AxiosResponse): Promise<Osoba[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Osoba.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Osoba[] | null>(<any>null);
    }

    vratiMagacionere(): Promise<Osoba[] | null> {
        let url_ = this.baseUrl + "/api/Osobe/VratiMagacionere";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiMagacionere(_response);
        });
    }

    protected processVratiMagacionere(response: AxiosResponse): Promise<Osoba[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Osoba.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Osoba[] | null>(<any>null);
    }

    vratiB2BPodatkeOsobe(id: number): Promise<B2BPodatakOsobe[] | null> {
        let url_ = this.baseUrl + "/api/Osobe/{id}/B2B";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiB2BPodatkeOsobe(_response);
        });
    }

    protected processVratiB2BPodatkeOsobe(response: AxiosResponse): Promise<B2BPodatakOsobe[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(B2BPodatakOsobe.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<B2BPodatakOsobe[] | null>(<any>null);
    }

    sacuvajB2BPodatkeOsobe(id: number, b2bPodaci: B2BPodatakOsobe[] | null): Promise<B2BPodatakOsobe[] | null> {
        let url_ = this.baseUrl + "/api/Osobe/{id}/B2B";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(b2bPodaci);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSacuvajB2BPodatkeOsobe(_response);
        });
    }

    protected processSacuvajB2BPodatkeOsobe(response: AxiosResponse): Promise<B2BPodatakOsobe[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(B2BPodatakOsobe.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<B2BPodatakOsobe[] | null>(<any>null);
    }

    exportToExcel(): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Osobe/ExportToExcel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportToExcel(_response);
        });
    }

    protected processExportToExcel(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    importFromExcel(file: FileParameter | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Osobe/ImportFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processImportFromExcel(_response);
        });
    }

    protected processImportFromExcel(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }
}

export class PoslovniPartneriProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    vratiPoslovnePartnere(): Promise<PoslovniPartner[] | null> {
        let url_ = this.baseUrl + "/api/PoslovniPartneri";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiPoslovnePartnere(_response);
        });
    }

    protected processVratiPoslovnePartnere(response: AxiosResponse): Promise<PoslovniPartner[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PoslovniPartner.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PoslovniPartner[] | null>(<any>null);
    }

    sacuvajPoslovnogPartnera(poslovniPartner: PoslovniPartner | null): Promise<PoslovniPartner | null> {
        let url_ = this.baseUrl + "/api/PoslovniPartneri";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(poslovniPartner);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSacuvajPoslovnogPartnera(_response);
        });
    }

    protected processSacuvajPoslovnogPartnera(response: AxiosResponse): Promise<PoslovniPartner | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PoslovniPartner.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PoslovniPartner | null>(<any>null);
    }

    obrisiPoslovnogPartnera(id: number): Promise<PoslovniPartner[] | null> {
        let url_ = this.baseUrl + "/api/PoslovniPartneri/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processObrisiPoslovnogPartnera(_response);
        });
    }

    protected processObrisiPoslovnogPartnera(response: AxiosResponse): Promise<PoslovniPartner[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PoslovniPartner.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PoslovniPartner[] | null>(<any>null);
    }

    vratiDelatnostiPoslovnihPartnera(): Promise<DelatnostiPoslovnihPartnera[] | null> {
        let url_ = this.baseUrl + "/api/PoslovniPartneri/VratiDelatnostiPoslovnihPartnera";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiDelatnostiPoslovnihPartnera(_response);
        });
    }

    protected processVratiDelatnostiPoslovnihPartnera(response: AxiosResponse): Promise<DelatnostiPoslovnihPartnera[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DelatnostiPoslovnihPartnera.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DelatnostiPoslovnihPartnera[] | null>(<any>null);
    }

    vratiOsiguravajuceKuce(): Promise<PoslovniPartner[] | null> {
        let url_ = this.baseUrl + "/api/PoslovniPartneri/VratiOsiguravajuceKuce";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiOsiguravajuceKuce(_response);
        });
    }

    protected processVratiOsiguravajuceKuce(response: AxiosResponse): Promise<PoslovniPartner[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PoslovniPartner.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PoslovniPartner[] | null>(<any>null);
    }

    vratiServise(): Promise<PoslovniPartner[] | null> {
        let url_ = this.baseUrl + "/api/PoslovniPartneri/VratiServise";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiServise(_response);
        });
    }

    protected processVratiServise(response: AxiosResponse): Promise<PoslovniPartner[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PoslovniPartner.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PoslovniPartner[] | null>(<any>null);
    }

    exportToExcel(): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/PoslovniPartneri/ExportToExcel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportToExcel(_response);
        });
    }

    protected processExportToExcel(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    importFromExcel(file: FileParameter | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/PoslovniPartneri/ImportFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processImportFromExcel(_response);
        });
    }

    protected processImportFromExcel(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }
}

export class PutniNaloziProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    sacuvajPutniNalog(putniNalog: PutniNalog | null): Promise<PutniNalog | null> {
        let url_ = this.baseUrl + "/api/PutniNalozi";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(putniNalog);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSacuvajPutniNalog(_response);
        });
    }

    protected processSacuvajPutniNalog(response: AxiosResponse): Promise<PutniNalog | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PutniNalog.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PutniNalog | null>(<any>null);
    }

    vratiPutniNalogPoId(id: number): Promise<PutniNalog | null> {
        let url_ = this.baseUrl + "/api/PutniNalozi/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiPutniNalogPoId(_response);
        });
    }

    protected processVratiPutniNalogPoId(response: AxiosResponse): Promise<PutniNalog | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PutniNalog.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PutniNalog | null>(<any>null);
    }

    vratiPutneNalogePoBroju(term: string | null): Promise<PutniNalog[] | null> {
        let url_ = this.baseUrl + "/api/PutniNalozi/VratiPutneNalogePoBroju?";
        if (term === undefined)
            throw new Error("The parameter 'term' must be defined.");
        else if(term !== null)
            url_ += "term=" + encodeURIComponent("" + term) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiPutneNalogePoBroju(_response);
        });
    }

    protected processVratiPutneNalogePoBroju(response: AxiosResponse): Promise<PutniNalog[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PutniNalog.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PutniNalog[] | null>(<any>null);
    }

    zakljuciPutniNalog(putniNalog: PutniNalog | null): Promise<any | null> {
        let url_ = this.baseUrl + "/api/PutniNalozi/ZakljuciPutniNalog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(putniNalog);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processZakljuciPutniNalog(_response);
        });
    }

    protected processZakljuciPutniNalog(response: AxiosResponse): Promise<any | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any | null>(<any>null);
    }

    vratiPutneNaloge(odDatuma: Date | undefined, doDatuma: Date | undefined, brojNaloga: string | null | undefined, vozac: number | null | undefined, vozilo: number | null | undefined): Promise<PutniNalog[] | null> {
        let url_ = this.baseUrl + "/api/PutniNalozi/VratiPutneNaloge?";
        if (odDatuma === null)
            throw new Error("The parameter 'odDatuma' cannot be null.");
        else if (odDatuma !== undefined)
            url_ += "odDatuma=" + encodeURIComponent(odDatuma ? "" + odDatuma.toJSON() : "") + "&";
        if (doDatuma === null)
            throw new Error("The parameter 'doDatuma' cannot be null.");
        else if (doDatuma !== undefined)
            url_ += "doDatuma=" + encodeURIComponent(doDatuma ? "" + doDatuma.toJSON() : "") + "&";
        if (brojNaloga !== undefined && brojNaloga !== null)
            url_ += "brojNaloga=" + encodeURIComponent("" + brojNaloga) + "&";
        if (vozac !== undefined && vozac !== null)
            url_ += "vozac=" + encodeURIComponent("" + vozac) + "&";
        if (vozilo !== undefined && vozilo !== null)
            url_ += "vozilo=" + encodeURIComponent("" + vozilo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiPutneNaloge(_response);
        });
    }

    protected processVratiPutneNaloge(response: AxiosResponse): Promise<PutniNalog[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PutniNalog.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PutniNalog[] | null>(<any>null);
    }

    vratiNalogeZaSluzbenoPutovanje(odDatuma: Date | undefined, doDatuma: Date | undefined, brojNaloga: string | null | undefined, vozac: number | null | undefined, vozilo: number | null | undefined): Promise<NalogZaSluzbenoPutovanje[] | null> {
        let url_ = this.baseUrl + "/api/PutniNalozi/VratiNalogeZaSluzbenoPutovanje?";
        if (odDatuma === null)
            throw new Error("The parameter 'odDatuma' cannot be null.");
        else if (odDatuma !== undefined)
            url_ += "odDatuma=" + encodeURIComponent(odDatuma ? "" + odDatuma.toJSON() : "") + "&";
        if (doDatuma === null)
            throw new Error("The parameter 'doDatuma' cannot be null.");
        else if (doDatuma !== undefined)
            url_ += "doDatuma=" + encodeURIComponent(doDatuma ? "" + doDatuma.toJSON() : "") + "&";
        if (brojNaloga !== undefined && brojNaloga !== null)
            url_ += "brojNaloga=" + encodeURIComponent("" + brojNaloga) + "&";
        if (vozac !== undefined && vozac !== null)
            url_ += "vozac=" + encodeURIComponent("" + vozac) + "&";
        if (vozilo !== undefined && vozilo !== null)
            url_ += "vozilo=" + encodeURIComponent("" + vozilo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiNalogeZaSluzbenoPutovanje(_response);
        });
    }

    protected processVratiNalogeZaSluzbenoPutovanje(response: AxiosResponse): Promise<NalogZaSluzbenoPutovanje[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NalogZaSluzbenoPutovanje.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NalogZaSluzbenoPutovanje[] | null>(<any>null);
    }

    vratiStampuNalogaZaSluzbenoPutovanje(odDatuma: Date | undefined, doDatuma: Date | undefined, brojNaloga: string | null | undefined, vozac: number | null | undefined, vozilo: number | null | undefined): Promise<string | null> {
        let url_ = this.baseUrl + "/api/PutniNalozi/VratiStampuNalogaZaSluzbenoPutovanje?";
        if (odDatuma === null)
            throw new Error("The parameter 'odDatuma' cannot be null.");
        else if (odDatuma !== undefined)
            url_ += "odDatuma=" + encodeURIComponent(odDatuma ? "" + odDatuma.toJSON() : "") + "&";
        if (doDatuma === null)
            throw new Error("The parameter 'doDatuma' cannot be null.");
        else if (doDatuma !== undefined)
            url_ += "doDatuma=" + encodeURIComponent(doDatuma ? "" + doDatuma.toJSON() : "") + "&";
        if (brojNaloga !== undefined && brojNaloga !== null)
            url_ += "brojNaloga=" + encodeURIComponent("" + brojNaloga) + "&";
        if (vozac !== undefined && vozac !== null)
            url_ += "vozac=" + encodeURIComponent("" + vozac) + "&";
        if (vozilo !== undefined && vozilo !== null)
            url_ += "vozilo=" + encodeURIComponent("" + vozilo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiStampuNalogaZaSluzbenoPutovanje(_response);
        });
    }

    protected processVratiStampuNalogaZaSluzbenoPutovanje(response: AxiosResponse): Promise<string | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string | null>(<any>null);
    }

    vratiStampuPutnogNaloga(id: number): Promise<string | null> {
        let url_ = this.baseUrl + "/api/PutniNalozi/VratiStampuPutnogNaloga/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiStampuPutnogNaloga(_response);
        });
    }

    protected processVratiStampuPutnogNaloga(response: AxiosResponse): Promise<string | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string | null>(<any>null);
    }
}

export class AktivnostiProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    vratiAktivnosti(): Promise<Aktivnost[] | null> {
        let url_ = this.baseUrl + "/api/Aktivnosti";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiAktivnosti(_response);
        });
    }

    protected processVratiAktivnosti(response: AxiosResponse): Promise<Aktivnost[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Aktivnost.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Aktivnost[] | null>(<any>null);
    }
}

export class EvidencijaAktivnostiVozacaProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    uveziDatoteku(file: FileParameter | null | undefined): Promise<Datoteka[] | null> {
        let url_ = this.baseUrl + "/api/EvidencijaAktivnostiVozaca";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUveziDatoteku(_response);
        });
    }

    protected processUveziDatoteku(response: AxiosResponse): Promise<Datoteka[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Datoteka.fromJS(item));
            }
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Datoteka[] | null>(<any>null);
    }

    vratiDnevnoRadnoVreme(godina: number, mesec: number, osoba: number | null, mestoTroska: number | null): Promise<DnevnoRadnoVreme[] | null> {
        let url_ = this.baseUrl + "/api/EvidencijaAktivnostiVozaca/VratiDnevnoRadnoVreme?";
        if (godina === undefined || godina === null)
            throw new Error("The parameter 'godina' must be defined and cannot be null.");
        else
            url_ += "godina=" + encodeURIComponent("" + godina) + "&";
        if (mesec === undefined || mesec === null)
            throw new Error("The parameter 'mesec' must be defined and cannot be null.");
        else
            url_ += "mesec=" + encodeURIComponent("" + mesec) + "&";
        if (osoba === undefined)
            throw new Error("The parameter 'osoba' must be defined.");
        else if(osoba !== null)
            url_ += "osoba=" + encodeURIComponent("" + osoba) + "&";
        if (mestoTroska === undefined)
            throw new Error("The parameter 'mestoTroska' must be defined.");
        else if(mestoTroska !== null)
            url_ += "mestoTroska=" + encodeURIComponent("" + mestoTroska) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiDnevnoRadnoVreme(_response);
        });
    }

    protected processVratiDnevnoRadnoVreme(response: AxiosResponse): Promise<DnevnoRadnoVreme[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DnevnoRadnoVreme.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DnevnoRadnoVreme[] | null>(<any>null);
    }

    vratiUvezeneDatoteke(): Promise<Datoteka[] | null> {
        let url_ = this.baseUrl + "/api/EvidencijaAktivnostiVozaca/VratiUvezeneDatoteke";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiUvezeneDatoteke(_response);
        });
    }

    protected processVratiUvezeneDatoteke(response: AxiosResponse): Promise<Datoteka[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Datoteka.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Datoteka[] | null>(<any>null);
    }

    vratiStampuEvidencijeRadnihVremenaVozaca(godina: number, mesec: number, vozac: number | null, mestoTroska: number | null): Promise<string | null> {
        let url_ = this.baseUrl + "/api/EvidencijaAktivnostiVozaca/VratiStampuEvidencijeRadnihVremenaVozaca?";
        if (godina === undefined || godina === null)
            throw new Error("The parameter 'godina' must be defined and cannot be null.");
        else
            url_ += "godina=" + encodeURIComponent("" + godina) + "&";
        if (mesec === undefined || mesec === null)
            throw new Error("The parameter 'mesec' must be defined and cannot be null.");
        else
            url_ += "mesec=" + encodeURIComponent("" + mesec) + "&";
        if (vozac === undefined)
            throw new Error("The parameter 'vozac' must be defined.");
        else if(vozac !== null)
            url_ += "vozac=" + encodeURIComponent("" + vozac) + "&";
        if (mestoTroska === undefined)
            throw new Error("The parameter 'mestoTroska' must be defined.");
        else if(mestoTroska !== null)
            url_ += "mestoTroska=" + encodeURIComponent("" + mestoTroska) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiStampuEvidencijeRadnihVremenaVozaca(_response);
        });
    }

    protected processVratiStampuEvidencijeRadnihVremenaVozaca(response: AxiosResponse): Promise<string | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string | null>(<any>null);
    }

    vratiPeriode(): Promise<Period[] | null> {
        let url_ = this.baseUrl + "/api/EvidencijaAktivnostiVozaca/VratiPeriode";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiPeriode(_response);
        });
    }

    protected processVratiPeriode(response: AxiosResponse): Promise<Period[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Period.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Period[] | null>(<any>null);
    }

    vratiMesecnoRadnoVreme(period: number, osoba: number | null): Promise<MesecnoRadnoVreme[] | null> {
        let url_ = this.baseUrl + "/api/EvidencijaAktivnostiVozaca/VratiMesecnoRadnoVreme?";
        if (period === undefined || period === null)
            throw new Error("The parameter 'period' must be defined and cannot be null.");
        else
            url_ += "period=" + encodeURIComponent("" + period) + "&";
        if (osoba === undefined)
            throw new Error("The parameter 'osoba' must be defined.");
        else if(osoba !== null)
            url_ += "osoba=" + encodeURIComponent("" + osoba) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiMesecnoRadnoVreme(_response);
        });
    }

    protected processVratiMesecnoRadnoVreme(response: AxiosResponse): Promise<MesecnoRadnoVreme[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MesecnoRadnoVreme.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MesecnoRadnoVreme[] | null>(<any>null);
    }

    vratiPreostaloRadnoVreme(datum: Date, osoba: number | null): Promise<PreostaloRadnoVreme[] | null> {
        let url_ = this.baseUrl + "/api/EvidencijaAktivnostiVozaca/VratiPreostaloRadnoVreme?";
        if (datum === undefined || datum === null)
            throw new Error("The parameter 'datum' must be defined and cannot be null.");
        else
            url_ += "datum=" + encodeURIComponent(datum ? "" + datum.toJSON() : "") + "&";
        if (osoba === undefined)
            throw new Error("The parameter 'osoba' must be defined.");
        else if(osoba !== null)
            url_ += "osoba=" + encodeURIComponent("" + osoba) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiPreostaloRadnoVreme(_response);
        });
    }

    protected processVratiPreostaloRadnoVreme(response: AxiosResponse): Promise<PreostaloRadnoVreme[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PreostaloRadnoVreme.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PreostaloRadnoVreme[] | null>(<any>null);
    }

    vratiEvidencijuAktivnostiVozaca(datum: Date, vozac: number | null): Promise<EvidencijaAktivnostiVozaca[] | null> {
        let url_ = this.baseUrl + "/api/EvidencijaAktivnostiVozaca/VratiEvidencijuAktivnostiVozaca?";
        if (datum === undefined || datum === null)
            throw new Error("The parameter 'datum' must be defined and cannot be null.");
        else
            url_ += "datum=" + encodeURIComponent(datum ? "" + datum.toJSON() : "") + "&";
        if (vozac === undefined)
            throw new Error("The parameter 'vozac' must be defined.");
        else if(vozac !== null)
            url_ += "vozac=" + encodeURIComponent("" + vozac) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiEvidencijuAktivnostiVozaca(_response);
        });
    }

    protected processVratiEvidencijuAktivnostiVozaca(response: AxiosResponse): Promise<EvidencijaAktivnostiVozaca[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EvidencijaAktivnostiVozaca.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EvidencijaAktivnostiVozaca[] | null>(<any>null);
    }

    vratiAktivnostiVozacaIzGps(datum: Date, vozac: number | null): Promise<EvidencijaAktivnostiVozaca[] | null> {
        let url_ = this.baseUrl + "/api/EvidencijaAktivnostiVozaca/VratiAktivnostiVozacaIzGps?";
        if (datum === undefined || datum === null)
            throw new Error("The parameter 'datum' must be defined and cannot be null.");
        else
            url_ += "datum=" + encodeURIComponent(datum ? "" + datum.toJSON() : "") + "&";
        if (vozac === undefined)
            throw new Error("The parameter 'vozac' must be defined.");
        else if(vozac !== null)
            url_ += "vozac=" + encodeURIComponent("" + vozac) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiAktivnostiVozacaIzGps(_response);
        });
    }

    protected processVratiAktivnostiVozacaIzGps(response: AxiosResponse): Promise<EvidencijaAktivnostiVozaca[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EvidencijaAktivnostiVozaca.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EvidencijaAktivnostiVozaca[] | null>(<any>null);
    }

    sacuvajEvidencijuAktivnostiVozaca(datum: Date, vozac: number | null, evidencijaAktivnostiVozaca: EvidencijaAktivnostiVozaca[] | null): Promise<EvidencijaAktivnostiVozaca[] | null> {
        let url_ = this.baseUrl + "/api/EvidencijaAktivnostiVozaca/SacuvajEvidencijuAktivnostiVozaca?";
        if (datum === undefined || datum === null)
            throw new Error("The parameter 'datum' must be defined and cannot be null.");
        else
            url_ += "datum=" + encodeURIComponent(datum ? "" + datum.toJSON() : "") + "&";
        if (vozac === undefined)
            throw new Error("The parameter 'vozac' must be defined.");
        else if(vozac !== null)
            url_ += "vozac=" + encodeURIComponent("" + vozac) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(evidencijaAktivnostiVozaca);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSacuvajEvidencijuAktivnostiVozaca(_response);
        });
    }

    protected processSacuvajEvidencijuAktivnostiVozaca(response: AxiosResponse): Promise<EvidencijaAktivnostiVozaca[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EvidencijaAktivnostiVozaca.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EvidencijaAktivnostiVozaca[] | null>(<any>null);
    }
}

export class NaloziZaSluzbenaPutovanjaProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    vratiDnevnaRadnaVremenaZaNalogZaSluzbenaPutovanja(odDatuma: Date, doDatuma: Date, organizacionaJedinica: number | null, vozac: number | null): Promise<NaloziZaSluzbenaPutovanja | null> {
        let url_ = this.baseUrl + "/api/NaloziZaSluzbenaPutovanja?";
        if (odDatuma === undefined || odDatuma === null)
            throw new Error("The parameter 'odDatuma' must be defined and cannot be null.");
        else
            url_ += "odDatuma=" + encodeURIComponent(odDatuma ? "" + odDatuma.toJSON() : "") + "&";
        if (doDatuma === undefined || doDatuma === null)
            throw new Error("The parameter 'doDatuma' must be defined and cannot be null.");
        else
            url_ += "doDatuma=" + encodeURIComponent(doDatuma ? "" + doDatuma.toJSON() : "") + "&";
        if (organizacionaJedinica === undefined)
            throw new Error("The parameter 'organizacionaJedinica' must be defined.");
        else if(organizacionaJedinica !== null)
            url_ += "organizacionaJedinica=" + encodeURIComponent("" + organizacionaJedinica) + "&";
        if (vozac === undefined)
            throw new Error("The parameter 'vozac' must be defined.");
        else if(vozac !== null)
            url_ += "vozac=" + encodeURIComponent("" + vozac) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiDnevnaRadnaVremenaZaNalogZaSluzbenaPutovanja(_response);
        });
    }

    protected processVratiDnevnaRadnaVremenaZaNalogZaSluzbenaPutovanja(response: AxiosResponse): Promise<NaloziZaSluzbenaPutovanja | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? NaloziZaSluzbenaPutovanja.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NaloziZaSluzbenaPutovanja | null>(<any>null);
    }

    vratiStampuNalogaZaSluzbenaPutnovanja(dnevnice: DnevnoAktivnoVreme[] | null): Promise<string | null> {
        let url_ = this.baseUrl + "/api/NaloziZaSluzbenaPutovanja";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dnevnice);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiStampuNalogaZaSluzbenaPutnovanja(_response);
        });
    }

    protected processVratiStampuNalogaZaSluzbenaPutnovanja(response: AxiosResponse): Promise<string | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string | null>(<any>null);
    }
}

export class OdsustvaProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    vratiOdsustva(godina: number): Promise<Odsustvo[] | null> {
        let url_ = this.baseUrl + "/api/Odsustva?";
        if (godina === undefined || godina === null)
            throw new Error("The parameter 'godina' must be defined and cannot be null.");
        else
            url_ += "godina=" + encodeURIComponent("" + godina) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiOdsustva(_response);
        });
    }

    protected processVratiOdsustva(response: AxiosResponse): Promise<Odsustvo[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Odsustvo.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Odsustvo[] | null>(<any>null);
    }

    sacuvajOdsustvo(odsustvo: Odsustvo | null): Promise<Odsustvo | null> {
        let url_ = this.baseUrl + "/api/Odsustva";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(odsustvo);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSacuvajOdsustvo(_response);
        });
    }

    protected processSacuvajOdsustvo(response: AxiosResponse): Promise<Odsustvo | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? Odsustvo.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Odsustvo | null>(<any>null);
    }

    obrisiOdsustvo(id: number): Promise<Odsustvo[] | null> {
        let url_ = this.baseUrl + "/api/Odsustva/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processObrisiOdsustvo(_response);
        });
    }

    protected processObrisiOdsustvo(response: AxiosResponse): Promise<Odsustvo[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Odsustvo.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Odsustvo[] | null>(<any>null);
    }

    vratiVrsteOdsustva(): Promise<VrstaOdsustva[] | null> {
        let url_ = this.baseUrl + "/api/Odsustva/VratiVrsteOdsustva";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiVrsteOdsustva(_response);
        });
    }

    protected processVratiVrsteOdsustva(response: AxiosResponse): Promise<VrstaOdsustva[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VrstaOdsustva.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VrstaOdsustva[] | null>(<any>null);
    }
}

export class SipanjeGorivaProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    uveziSipanjeGoriva(file: FileParameter | null | undefined, provider: number): Promise<Datoteka[] | null> {
        let url_ = this.baseUrl + "/api/SipanjeGoriva/{provider}";
        if (provider === undefined || provider === null)
            throw new Error("The parameter 'provider' must be defined.");
        url_ = url_.replace("{provider}", encodeURIComponent("" + provider));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUveziSipanjeGoriva(_response);
        });
    }

    protected processUveziSipanjeGoriva(response: AxiosResponse): Promise<Datoteka[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Datoteka.fromJS(item));
            }
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Datoteka[] | null>(<any>null);
    }

    vratiUvezeneDatoteke(): Promise<Datoteka[] | null> {
        let url_ = this.baseUrl + "/api/SipanjeGoriva";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiUvezeneDatoteke(_response);
        });
    }

    protected processVratiUvezeneDatoteke(response: AxiosResponse): Promise<Datoteka[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Datoteka.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Datoteka[] | null>(<any>null);
    }

    sacuvajStavkuSipanjaGoriva(stavkaIzvestajaSipanjaIPotrosnjeGoriva: StavkaIzvestajaSipanjaIPotrosnjeGoriva | null): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/SipanjeGoriva";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(stavkaIzvestajaSipanjaIPotrosnjeGoriva);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSacuvajStavkuSipanjaGoriva(_response);
        });
    }

    protected processSacuvajStavkuSipanjaGoriva(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    vratiIzvesteajEvidencijeSipanjaIPotrosnjeGoriva(odDatuma: Date, doDatuma: Date, vozilo: number | null): Promise<StavkaIzvestajaSipanjaIPotrosnjeGoriva[] | null> {
        let url_ = this.baseUrl + "/api/SipanjeGoriva/VratiIzvesteajEvidencijeSipanjaIPotrosnjeGoriva?";
        if (odDatuma === undefined || odDatuma === null)
            throw new Error("The parameter 'odDatuma' must be defined and cannot be null.");
        else
            url_ += "odDatuma=" + encodeURIComponent(odDatuma ? "" + odDatuma.toJSON() : "") + "&";
        if (doDatuma === undefined || doDatuma === null)
            throw new Error("The parameter 'doDatuma' must be defined and cannot be null.");
        else
            url_ += "doDatuma=" + encodeURIComponent(doDatuma ? "" + doDatuma.toJSON() : "") + "&";
        if (vozilo === undefined)
            throw new Error("The parameter 'vozilo' must be defined.");
        else if(vozilo !== null)
            url_ += "vozilo=" + encodeURIComponent("" + vozilo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiIzvesteajEvidencijeSipanjaIPotrosnjeGoriva(_response);
        });
    }

    protected processVratiIzvesteajEvidencijeSipanjaIPotrosnjeGoriva(response: AxiosResponse): Promise<StavkaIzvestajaSipanjaIPotrosnjeGoriva[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StavkaIzvestajaSipanjaIPotrosnjeGoriva.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StavkaIzvestajaSipanjaIPotrosnjeGoriva[] | null>(<any>null);
    }
}

export class SteteProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    sacuvajStetniDogadjaj(stetniDogadjaj: StetniDogadjaj | null): Promise<StetniDogadjaj | null> {
        let url_ = this.baseUrl + "/api/Stete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(stetniDogadjaj);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSacuvajStetniDogadjaj(_response);
        });
    }

    protected processSacuvajStetniDogadjaj(response: AxiosResponse): Promise<StetniDogadjaj | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? StetniDogadjaj.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StetniDogadjaj | null>(<any>null);
    }

    vratiStetneDogadjaje(odDatuma: Date | null, doDatuma: Date | null, brojStete: string | null, brojZapisnika: string | null, brojPolise: string | null, vozilo: number | null, vozac: number | null): Promise<StetniDogadjaj[] | null> {
        let url_ = this.baseUrl + "/api/Stete?";
        if (odDatuma === undefined)
            throw new Error("The parameter 'odDatuma' must be defined.");
        else if(odDatuma !== null)
            url_ += "odDatuma=" + encodeURIComponent(odDatuma ? "" + odDatuma.toJSON() : "") + "&";
        if (doDatuma === undefined)
            throw new Error("The parameter 'doDatuma' must be defined.");
        else if(doDatuma !== null)
            url_ += "doDatuma=" + encodeURIComponent(doDatuma ? "" + doDatuma.toJSON() : "") + "&";
        if (brojStete === undefined)
            throw new Error("The parameter 'brojStete' must be defined.");
        else if(brojStete !== null)
            url_ += "brojStete=" + encodeURIComponent("" + brojStete) + "&";
        if (brojZapisnika === undefined)
            throw new Error("The parameter 'brojZapisnika' must be defined.");
        else if(brojZapisnika !== null)
            url_ += "brojZapisnika=" + encodeURIComponent("" + brojZapisnika) + "&";
        if (brojPolise === undefined)
            throw new Error("The parameter 'brojPolise' must be defined.");
        else if(brojPolise !== null)
            url_ += "brojPolise=" + encodeURIComponent("" + brojPolise) + "&";
        if (vozilo === undefined)
            throw new Error("The parameter 'vozilo' must be defined.");
        else if(vozilo !== null)
            url_ += "vozilo=" + encodeURIComponent("" + vozilo) + "&";
        if (vozac === undefined)
            throw new Error("The parameter 'vozac' must be defined.");
        else if(vozac !== null)
            url_ += "vozac=" + encodeURIComponent("" + vozac) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiStetneDogadjaje(_response);
        });
    }

    protected processVratiStetneDogadjaje(response: AxiosResponse): Promise<StetniDogadjaj[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StetniDogadjaj.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StetniDogadjaj[] | null>(<any>null);
    }

    vratiStetneDogadjajeVozila(vozilo: number): Promise<StetniDogadjaj[] | null> {
        let url_ = this.baseUrl + "/api/Stete/VratiStetneDogadjajeVozila?";
        if (vozilo === undefined || vozilo === null)
            throw new Error("The parameter 'vozilo' must be defined and cannot be null.");
        else
            url_ += "vozilo=" + encodeURIComponent("" + vozilo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiStetneDogadjajeVozila(_response);
        });
    }

    protected processVratiStetneDogadjajeVozila(response: AxiosResponse): Promise<StetniDogadjaj[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StetniDogadjaj.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StetniDogadjaj[] | null>(<any>null);
    }

    zakljuciStetniDogadjaj(stetniDogadjaj: StetniDogadjaj | null): Promise<StetniDogadjaj | null> {
        let url_ = this.baseUrl + "/api/Stete/ZakljuciStetniDogadjaj";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(stetniDogadjaj);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processZakljuciStetniDogadjaj(_response);
        });
    }

    protected processZakljuciStetniDogadjaj(response: AxiosResponse): Promise<StetniDogadjaj | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? StetniDogadjaj.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StetniDogadjaj | null>(<any>null);
    }
}

export class GrupeVozilaProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    vratiGrupeVozila(): Promise<GrupaVozila[] | null> {
        let url_ = this.baseUrl + "/api/GrupeVozila";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiGrupeVozila(_response);
        });
    }

    protected processVratiGrupeVozila(response: AxiosResponse): Promise<GrupaVozila[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GrupaVozila.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GrupaVozila[] | null>(<any>null);
    }

    sacuvajGrupuVozila(grupaVozila: GrupaVozila | null): Promise<number> {
        let url_ = this.baseUrl + "/api/GrupeVozila";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(grupaVozila);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSacuvajGrupuVozila(_response);
        });
    }

    protected processSacuvajGrupuVozila(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(<any>null);
    }

    obrisiGrupuVozila(id: number): Promise<GrupaVozila[] | null> {
        let url_ = this.baseUrl + "/api/GrupeVozila/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processObrisiGrupuVozila(_response);
        });
    }

    protected processObrisiGrupuVozila(response: AxiosResponse): Promise<GrupaVozila[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GrupaVozila.fromJS(item));
            }
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GrupaVozila[] | null>(<any>null);
    }

    sacuvajPodgrupuVozila(podgrupa: PodgrupaVozila | null): Promise<PodgrupaVozila[] | null> {
        let url_ = this.baseUrl + "/api/GrupeVozila/SacuvajPodgrupuVozila";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(podgrupa);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSacuvajPodgrupuVozila(_response);
        });
    }

    protected processSacuvajPodgrupuVozila(response: AxiosResponse): Promise<PodgrupaVozila[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PodgrupaVozila.fromJS(item));
            }
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PodgrupaVozila[] | null>(<any>null);
    }

    obrisiPodgrupuVozila(id: number): Promise<PodgrupaVozila[] | null> {
        let url_ = this.baseUrl + "/api/GrupeVozila/ObrisiPodgrupuVozila/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processObrisiPodgrupuVozila(_response);
        });
    }

    protected processObrisiPodgrupuVozila(response: AxiosResponse): Promise<PodgrupaVozila[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PodgrupaVozila.fromJS(item));
            }
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PodgrupaVozila[] | null>(<any>null);
    }
}

export class MarkeIModeliVozilaProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    vratiMarkeIModeleVozila(): Promise<MarkaVozila[] | null> {
        let url_ = this.baseUrl + "/api/MarkeIModeliVozila";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiMarkeIModeleVozila(_response);
        });
    }

    protected processVratiMarkeIModeleVozila(response: AxiosResponse): Promise<MarkaVozila[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MarkaVozila.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MarkaVozila[] | null>(<any>null);
    }

    sacuvajMarkuVozila(markaVozila: MarkaVozila | null): Promise<number> {
        let url_ = this.baseUrl + "/api/MarkeIModeliVozila";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(markaVozila);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSacuvajMarkuVozila(_response);
        });
    }

    protected processSacuvajMarkuVozila(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 ? ValidationException.fromJS(resultData400) : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(<any>null);
    }

    obrisiMarkuVozila(id: number): Promise<MarkaVozila[] | null> {
        let url_ = this.baseUrl + "/api/MarkeIModeliVozila/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processObrisiMarkuVozila(_response);
        });
    }

    protected processObrisiMarkuVozila(response: AxiosResponse): Promise<MarkaVozila[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MarkaVozila.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MarkaVozila[] | null>(<any>null);
    }

    sacuvajModelVozila(modelVozila: ModelVozila | null): Promise<ModelVozila[] | null> {
        let url_ = this.baseUrl + "/api/MarkeIModeliVozila/SacuvajModelVozila";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(modelVozila);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSacuvajModelVozila(_response);
        });
    }

    protected processSacuvajModelVozila(response: AxiosResponse): Promise<ModelVozila[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ModelVozila.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ModelVozila[] | null>(<any>null);
    }

    obrisiModelVozila(id: number): Promise<ModelVozila[] | null> {
        let url_ = this.baseUrl + "/api/MarkeIModeliVozila/ObrisiModelVozila/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processObrisiModelVozila(_response);
        });
    }

    protected processObrisiModelVozila(response: AxiosResponse): Promise<ModelVozila[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ModelVozila.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ModelVozila[] | null>(<any>null);
    }
}

export class OpremaProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    vratiOpremu(): Promise<Oprema[] | null> {
        let url_ = this.baseUrl + "/api/Oprema";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiOpremu(_response);
        });
    }

    protected processVratiOpremu(response: AxiosResponse): Promise<Oprema[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Oprema.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Oprema[] | null>(<any>null);
    }

    sacuvajOpremu(oprema: Oprema | null): Promise<number> {
        let url_ = this.baseUrl + "/api/Oprema";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(oprema);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSacuvajOpremu(_response);
        });
    }

    protected processSacuvajOpremu(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 ? ValidationException.fromJS(resultData400) : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(<any>null);
    }

    obrisiOpremu(id: number): Promise<Oprema[] | null> {
        let url_ = this.baseUrl + "/api/Oprema/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processObrisiOpremu(_response);
        });
    }

    protected processObrisiOpremu(response: AxiosResponse): Promise<Oprema[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Oprema.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Oprema[] | null>(<any>null);
    }
}

export class StatusiVozilaProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    vratiStatuseVozila(): Promise<StatusVozila[] | null> {
        let url_ = this.baseUrl + "/api/StatusiVozila";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiStatuseVozila(_response);
        });
    }

    protected processVratiStatuseVozila(response: AxiosResponse): Promise<StatusVozila[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StatusVozila.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StatusVozila[] | null>(<any>null);
    }

    sacuvajStatusVozila(statusVozila: StatusVozila | null): Promise<number> {
        let url_ = this.baseUrl + "/api/StatusiVozila";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(statusVozila);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSacuvajStatusVozila(_response);
        });
    }

    protected processSacuvajStatusVozila(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(<any>null);
    }

    obrisiStatusVozila(id: number): Promise<StatusVozila[] | null> {
        let url_ = this.baseUrl + "/api/StatusiVozila/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processObrisiStatusVozila(_response);
        });
    }

    protected processObrisiStatusVozila(response: AxiosResponse): Promise<StatusVozila[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StatusVozila.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StatusVozila[] | null>(<any>null);
    }
}

export class VozilaProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    vratiVozila(): Promise<Vozilo[] | null> {
        let url_ = this.baseUrl + "/api/Vozila";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiVozila(_response);
        });
    }

    protected processVratiVozila(response: AxiosResponse): Promise<Vozilo[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Vozilo.fromJS(item));
            }
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Vozilo[] | null>(<any>null);
    }

    sacuvajVozilo(vozilo: Vozilo | null): Promise<number> {
        let url_ = this.baseUrl + "/api/Vozila";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vozilo);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSacuvajVozilo(_response);
        });
    }

    protected processSacuvajVozilo(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(<any>null);
    }

    vratiVozilo(id: number): Promise<Vozilo | null> {
        let url_ = this.baseUrl + "/api/Vozila/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiVozilo(_response);
        });
    }

    protected processVratiVozilo(response: AxiosResponse): Promise<Vozilo | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? Vozilo.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404 !== undefined ? resultData404 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Vozilo | null>(<any>null);
    }

    vratiNormativPotrosnjeGorivaVozila(id: number): Promise<NormativPotrosnjeGoriva[] | null> {
        let url_ = this.baseUrl + "/api/Vozila/{id}/NormativPotrosnjeGoriva";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiNormativPotrosnjeGorivaVozila(_response);
        });
    }

    protected processVratiNormativPotrosnjeGorivaVozila(response: AxiosResponse): Promise<NormativPotrosnjeGoriva[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NormativPotrosnjeGoriva.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NormativPotrosnjeGoriva[] | null>(<any>null);
    }

    sacuvajNormativPotrosnjeGoriva(id: number, normativ: NormativPotrosnjeGoriva[] | null): Promise<NormativPotrosnjeGoriva[] | null> {
        let url_ = this.baseUrl + "/api/Vozila/{id}/NormativPotrosnjeGoriva";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(normativ);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSacuvajNormativPotrosnjeGoriva(_response);
        });
    }

    protected processSacuvajNormativPotrosnjeGoriva(response: AxiosResponse): Promise<NormativPotrosnjeGoriva[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NormativPotrosnjeGoriva.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NormativPotrosnjeGoriva[] | null>(<any>null);
    }

    vratiMarkeVozila(): Promise<MarkaVozila[] | null> {
        let url_ = this.baseUrl + "/api/Vozila/VratiMarkeVozila";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiMarkeVozila(_response);
        });
    }

    protected processVratiMarkeVozila(response: AxiosResponse): Promise<MarkaVozila[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MarkaVozila.fromJS(item));
            }
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MarkaVozila[] | null>(<any>null);
    }

    vratiTipoveVozila(): Promise<TipVozila[] | null> {
        let url_ = this.baseUrl + "/api/Vozila/VratiTipoveVozila";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiTipoveVozila(_response);
        });
    }

    protected processVratiTipoveVozila(response: AxiosResponse): Promise<TipVozila[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TipVozila.fromJS(item));
            }
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TipVozila[] | null>(<any>null);
    }

    sacuvajTipVozila(tipVozila: TipVozila | null): Promise<number> {
        let url_ = this.baseUrl + "/api/Vozila/SacuvajTipVozila";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tipVozila);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSacuvajTipVozila(_response);
        });
    }

    protected processSacuvajTipVozila(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(<any>null);
    }

    obrisiTipVozila(id: number): Promise<TipVozila[] | null> {
        let url_ = this.baseUrl + "/api/Vozila/ObrisiTipVozila/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processObrisiTipVozila(_response);
        });
    }

    protected processObrisiTipVozila(response: AxiosResponse): Promise<TipVozila[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TipVozila.fromJS(item));
            }
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TipVozila[] | null>(<any>null);
    }

    vratiBojeVozila(term: string | null): Promise<string[] | null> {
        let url_ = this.baseUrl + "/api/Vozila/VratiBojeVozila?";
        if (term === undefined)
            throw new Error("The parameter 'term' must be defined.");
        else if(term !== null)
            url_ += "term=" + encodeURIComponent("" + term) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiBojeVozila(_response);
        });
    }

    protected processVratiBojeVozila(response: AxiosResponse): Promise<string[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[] | null>(<any>null);
    }

    vratiKategorijeVozila(): Promise<KategorijaVozila[] | null> {
        let url_ = this.baseUrl + "/api/Vozila/VratiKategorijeVozila";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiKategorijeVozila(_response);
        });
    }

    protected processVratiKategorijeVozila(response: AxiosResponse): Promise<KategorijaVozila[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KategorijaVozila.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KategorijaVozila[] | null>(<any>null);
    }

    vratiTipoveMotoraVozila(): Promise<TipMotora[] | null> {
        let url_ = this.baseUrl + "/api/Vozila/VratiTipoveMotoraVozila";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiTipoveMotoraVozila(_response);
        });
    }

    protected processVratiTipoveMotoraVozila(response: AxiosResponse): Promise<TipMotora[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TipMotora.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TipMotora[] | null>(<any>null);
    }

    vratiNacineNabavkeVozila(): Promise<NacinNabavkeVozila[] | null> {
        let url_ = this.baseUrl + "/api/Vozila/VratiNacineNabavkeVozila";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiNacineNabavkeVozila(_response);
        });
    }

    protected processVratiNacineNabavkeVozila(response: AxiosResponse): Promise<NacinNabavkeVozila[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NacinNabavkeVozila.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NacinNabavkeVozila[] | null>(<any>null);
    }

    vratiNabavkuVozila(id: number): Promise<NabavkaVozila | null> {
        let url_ = this.baseUrl + "/api/Vozila/{id}/NabavkaVozila";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiNabavkuVozila(_response);
        });
    }

    protected processVratiNabavkuVozila(response: AxiosResponse): Promise<NabavkaVozila | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? NabavkaVozila.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NabavkaVozila | null>(<any>null);
    }

    sacuvajNabavkuVozila(id: number, nabavkaVozila: NabavkaVozila | null): Promise<number> {
        let url_ = this.baseUrl + "/api/Vozila/{id}/NabavkaVozila";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(nabavkaVozila);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSacuvajNabavkuVozila(_response);
        });
    }

    protected processSacuvajNabavkuVozila(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(<any>null);
    }

    obrisiNabavkuVozila(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/Vozila/{id}/NabavkaVozila";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processObrisiNabavkuVozila(_response);
        });
    }

    protected processObrisiNabavkuVozila(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(<any>null);
    }

    sacuvajPoliseOsiguranja(idVozila: number, polise: PolisaOsiguranja[] | null): Promise<PolisaOsiguranja[] | null> {
        let url_ = this.baseUrl + "/api/Vozila/{idVozila}/PoliseOsiguranja";
        if (idVozila === undefined || idVozila === null)
            throw new Error("The parameter 'idVozila' must be defined.");
        url_ = url_.replace("{idVozila}", encodeURIComponent("" + idVozila));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(polise);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSacuvajPoliseOsiguranja(_response);
        });
    }

    protected processSacuvajPoliseOsiguranja(response: AxiosResponse): Promise<PolisaOsiguranja[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PolisaOsiguranja.fromJS(item));
            }
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PolisaOsiguranja[] | null>(<any>null);
    }

    vratiPoliseOsiguranja(idVozila: number): Promise<PolisaOsiguranja[] | null> {
        let url_ = this.baseUrl + "/api/Vozila/{idVozila}/PoliseOsiguranja";
        if (idVozila === undefined || idVozila === null)
            throw new Error("The parameter 'idVozila' must be defined.");
        url_ = url_.replace("{idVozila}", encodeURIComponent("" + idVozila));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiPoliseOsiguranja(_response);
        });
    }

    protected processVratiPoliseOsiguranja(response: AxiosResponse): Promise<PolisaOsiguranja[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PolisaOsiguranja.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PolisaOsiguranja[] | null>(<any>null);
    }

    obrisiPolisuOsiguranja(idVozila: number, idPolise: number): Promise<PolisaOsiguranja[] | null> {
        let url_ = this.baseUrl + "/api/Vozila/{idVozila}/PoliseOsiguranja/{idPolise}";
        if (idVozila === undefined || idVozila === null)
            throw new Error("The parameter 'idVozila' must be defined.");
        url_ = url_.replace("{idVozila}", encodeURIComponent("" + idVozila));
        if (idPolise === undefined || idPolise === null)
            throw new Error("The parameter 'idPolise' must be defined.");
        url_ = url_.replace("{idPolise}", encodeURIComponent("" + idPolise));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processObrisiPolisuOsiguranja(_response);
        });
    }

    protected processObrisiPolisuOsiguranja(response: AxiosResponse): Promise<PolisaOsiguranja[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PolisaOsiguranja.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PolisaOsiguranja[] | null>(<any>null);
    }

    vratiOsiguravajuceKuce(term: string | null): Promise<string[] | null> {
        let url_ = this.baseUrl + "/api/Vozila/VratiOsiguravajuceKuce?";
        if (term === undefined)
            throw new Error("The parameter 'term' must be defined.");
        else if(term !== null)
            url_ += "term=" + encodeURIComponent("" + term) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiOsiguravajuceKuce(_response);
        });
    }

    protected processVratiOsiguravajuceKuce(response: AxiosResponse): Promise<string[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[] | null>(<any>null);
    }

    vratiB2BPodatkeVozila(id: number): Promise<B2BPodatakVozila[] | null> {
        let url_ = this.baseUrl + "/api/Vozila/{id}/B2B";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiB2BPodatkeVozila(_response);
        });
    }

    protected processVratiB2BPodatkeVozila(response: AxiosResponse): Promise<B2BPodatakVozila[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(B2BPodatakVozila.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<B2BPodatakVozila[] | null>(<any>null);
    }

    sacuvajB2BPodatkeVozila(id: number, b2bPodaci: B2BPodatakVozila[] | null): Promise<B2BPodatakVozila[] | null> {
        let url_ = this.baseUrl + "/api/Vozila/{id}/B2B";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(b2bPodaci);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSacuvajB2BPodatkeVozila(_response);
        });
    }

    protected processSacuvajB2BPodatkeVozila(response: AxiosResponse): Promise<B2BPodatakVozila[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(B2BPodatakVozila.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<B2BPodatakVozila[] | null>(<any>null);
    }

    vratiVozilaKorisnika(): Promise<Vozilo[] | null> {
        let url_ = this.baseUrl + "/api/Vozila/VratiVozilaKorisnika";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiVozilaKorisnika(_response);
        });
    }

    protected processVratiVozilaKorisnika(response: AxiosResponse): Promise<Vozilo[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Vozilo.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Vozilo[] | null>(<any>null);
    }

    vratiPozicijeVozila(): Promise<GpsPozicija[] | null> {
        let url_ = this.baseUrl + "/api/Vozila/VratiPozicijeVozila";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiPozicijeVozila(_response);
        });
    }

    protected processVratiPozicijeVozila(response: AxiosResponse): Promise<GpsPozicija[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GpsPozicija.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GpsPozicija[] | null>(<any>null);
    }

    uveziKretanjaVozila(file: FileParameter | null | undefined, provajder: number): Promise<Datoteka[] | null> {
        let url_ = this.baseUrl + "/api/Vozila/UveziKretanjaVozila?";
        if (provajder === undefined || provajder === null)
            throw new Error("The parameter 'provajder' must be defined and cannot be null.");
        else
            url_ += "provajder=" + encodeURIComponent("" + provajder) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUveziKretanjaVozila(_response);
        });
    }

    protected processUveziKretanjaVozila(response: AxiosResponse): Promise<Datoteka[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Datoteka.fromJS(item));
            }
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Datoteka[] | null>(<any>null);
    }

    vratiUvezeneDatotekeKretanjaVozila(): Promise<Datoteka[] | null> {
        let url_ = this.baseUrl + "/api/Vozila/VratiUvezeneDatotekeKretanjaVozila";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiUvezeneDatotekeKretanjaVozila(_response);
        });
    }

    protected processVratiUvezeneDatotekeKretanjaVozila(response: AxiosResponse): Promise<Datoteka[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Datoteka.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Datoteka[] | null>(<any>null);
    }

    vratiTroskoveVozila(vozilo: number): Promise<TroskoviVozila | null> {
        let url_ = this.baseUrl + "/api/Vozila/VratiTroskoveVozila?";
        if (vozilo === undefined || vozilo === null)
            throw new Error("The parameter 'vozilo' must be defined and cannot be null.");
        else
            url_ += "vozilo=" + encodeURIComponent("" + vozilo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiTroskoveVozila(_response);
        });
    }

    protected processVratiTroskoveVozila(response: AxiosResponse): Promise<TroskoviVozila | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? TroskoviVozila.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TroskoviVozila | null>(<any>null);
    }

    vratiZaglavljePregledaVozila(vozilo: number): Promise<F_voz_ZaglavljePregledaVozila | null> {
        let url_ = this.baseUrl + "/api/Vozila/VratiZaglavljePregledaVozila?";
        if (vozilo === undefined || vozilo === null)
            throw new Error("The parameter 'vozilo' must be defined and cannot be null.");
        else
            url_ += "vozilo=" + encodeURIComponent("" + vozilo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiZaglavljePregledaVozila(_response);
        });
    }

    protected processVratiZaglavljePregledaVozila(response: AxiosResponse): Promise<F_voz_ZaglavljePregledaVozila | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? F_voz_ZaglavljePregledaVozila.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<F_voz_ZaglavljePregledaVozila | null>(<any>null);
    }

    exportToExcel(): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Vozila/ExportToExcel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportToExcel(_response);
        });
    }

    protected processExportToExcel(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    importFromExcel(file: FileParameter | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Vozila/ImportFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processImportFromExcel(_response);
        });
    }

    protected processImportFromExcel(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    vratiVoziloPoRegistraskomIliGaraznomBroju(broj: string | null): Promise<Vozilo | null> {
        let url_ = this.baseUrl + "/api/Vozila/VratiVoziloPoRegistraskomIliGaraznomBroju?";
        if (broj === undefined)
            throw new Error("The parameter 'broj' must be defined.");
        else if(broj !== null)
            url_ += "broj=" + encodeURIComponent("" + broj) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVratiVoziloPoRegistraskomIliGaraznomBroju(_response);
        });
    }

    protected processVratiVoziloPoRegistraskomIliGaraznomBroju(response: AxiosResponse): Promise<Vozilo | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? Vozilo.fromJS(resultData200) : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Vozilo | null>(<any>null);
    }
}

export class B2BProvajder implements IB2BProvajder {
    id!: number;
    naziv?: string | undefined;
    tip?: string | undefined;

    constructor(data?: IB2BProvajder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.tip = _data["tip"];
        }
    }

    static fromJS(data: any): B2BProvajder {
        data = typeof data === 'object' ? data : {};
        let result = new B2BProvajder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["tip"] = this.tip;
        return data; 
    }
}

export interface IB2BProvajder {
    id: number;
    naziv?: string | undefined;
    tip?: string | undefined;
}

export class PodesavanjeSistema implements IPodesavanjeSistema {
    id!: number;
    cenaRadnogSata!: number;
    koristiZalihe!: boolean;
    brojRadnihDanaUNedelji!: number;
    brojRadnihSatiUDanu!: number;
    kursEvra!: number;
    iznosDnevniceVozaca!: number;
    pdvStopa!: number;

    constructor(data?: IPodesavanjeSistema) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.cenaRadnogSata = _data["cenaRadnogSata"];
            this.koristiZalihe = _data["koristiZalihe"];
            this.brojRadnihDanaUNedelji = _data["brojRadnihDanaUNedelji"];
            this.brojRadnihSatiUDanu = _data["brojRadnihSatiUDanu"];
            this.kursEvra = _data["kursEvra"];
            this.iznosDnevniceVozaca = _data["iznosDnevniceVozaca"];
            this.pdvStopa = _data["pdvStopa"];
        }
    }

    static fromJS(data: any): PodesavanjeSistema {
        data = typeof data === 'object' ? data : {};
        let result = new PodesavanjeSistema();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cenaRadnogSata"] = this.cenaRadnogSata;
        data["koristiZalihe"] = this.koristiZalihe;
        data["brojRadnihDanaUNedelji"] = this.brojRadnihDanaUNedelji;
        data["brojRadnihSatiUDanu"] = this.brojRadnihSatiUDanu;
        data["kursEvra"] = this.kursEvra;
        data["iznosDnevniceVozaca"] = this.iznosDnevniceVozaca;
        data["pdvStopa"] = this.pdvStopa;
        return data; 
    }
}

export interface IPodesavanjeSistema {
    id: number;
    cenaRadnogSata: number;
    koristiZalihe: boolean;
    brojRadnihDanaUNedelji: number;
    brojRadnihSatiUDanu: number;
    kursEvra: number;
    iznosDnevniceVozaca: number;
    pdvStopa: number;
}

export class Podsetnik implements IPodsetnik {
    id!: number;
    opis?: string | undefined;
    datum?: Date | undefined;
    upozoriPre!: number;
    primaoci?: PrimaocPodsetnika[] | undefined;
    ukljucen!: boolean;
    razlika!: number;

    constructor(data?: IPodsetnik) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.opis = _data["opis"];
            this.datum = _data["datum"] ? new Date(_data["datum"].toString()) : <any>undefined;
            this.upozoriPre = _data["upozoriPre"];
            if (Array.isArray(_data["primaoci"])) {
                this.primaoci = [] as any;
                for (let item of _data["primaoci"])
                    this.primaoci!.push(PrimaocPodsetnika.fromJS(item));
            }
            this.ukljucen = _data["ukljucen"];
            this.razlika = _data["razlika"];
        }
    }

    static fromJS(data: any): Podsetnik {
        data = typeof data === 'object' ? data : {};
        let result = new Podsetnik();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["opis"] = this.opis;
        data["datum"] = this.datum ? this.datum.toISOString() : <any>undefined;
        data["upozoriPre"] = this.upozoriPre;
        if (Array.isArray(this.primaoci)) {
            data["primaoci"] = [];
            for (let item of this.primaoci)
                data["primaoci"].push(item.toJSON());
        }
        data["ukljucen"] = this.ukljucen;
        data["razlika"] = this.razlika;
        return data; 
    }
}

export interface IPodsetnik {
    id: number;
    opis?: string | undefined;
    datum?: Date | undefined;
    upozoriPre: number;
    primaoci?: PrimaocPodsetnika[] | undefined;
    ukljucen: boolean;
    razlika: number;
}

export class PodsetnikVozila extends Podsetnik implements IPodsetnikVozila {
    voziloId!: number;
    vozilo?: string | undefined;
    stanjeKilometraze?: number | undefined;

    constructor(data?: IPodsetnikVozila) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.voziloId = _data["voziloId"];
            this.vozilo = _data["vozilo"];
            this.stanjeKilometraze = _data["stanjeKilometraze"];
        }
    }

    static fromJS(data: any): PodsetnikVozila {
        data = typeof data === 'object' ? data : {};
        let result = new PodsetnikVozila();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voziloId"] = this.voziloId;
        data["vozilo"] = this.vozilo;
        data["stanjeKilometraze"] = this.stanjeKilometraze;
        super.toJSON(data);
        return data; 
    }
}

export interface IPodsetnikVozila extends IPodsetnik {
    voziloId: number;
    vozilo?: string | undefined;
    stanjeKilometraze?: number | undefined;
}

export class PrimaocPodsetnika implements IPrimaocPodsetnika {
    id!: number;
    osobaId?: number | undefined;
    osoba?: string | undefined;
    email?: string | undefined;
    display?: string | undefined;
    ukljucen!: boolean;

    constructor(data?: IPrimaocPodsetnika) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.osobaId = _data["osobaId"];
            this.osoba = _data["osoba"];
            this.email = _data["email"];
            this.display = _data["display"];
            this.ukljucen = _data["ukljucen"];
        }
    }

    static fromJS(data: any): PrimaocPodsetnika {
        data = typeof data === 'object' ? data : {};
        let result = new PrimaocPodsetnika();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["osobaId"] = this.osobaId;
        data["osoba"] = this.osoba;
        data["email"] = this.email;
        data["display"] = this.display;
        data["ukljucen"] = this.ukljucen;
        return data; 
    }
}

export interface IPrimaocPodsetnika {
    id: number;
    osobaId?: number | undefined;
    osoba?: string | undefined;
    email?: string | undefined;
    display?: string | undefined;
    ukljucen: boolean;
}

export class PodsetnikOsobe extends Podsetnik implements IPodsetnikOsobe {
    osobaId!: number;
    osoba?: string | undefined;

    constructor(data?: IPodsetnikOsobe) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.osobaId = _data["osobaId"];
            this.osoba = _data["osoba"];
        }
    }

    static fromJS(data: any): PodsetnikOsobe {
        data = typeof data === 'object' ? data : {};
        let result = new PodsetnikOsobe();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["osobaId"] = this.osobaId;
        data["osoba"] = this.osoba;
        super.toJSON(data);
        return data; 
    }
}

export interface IPodsetnikOsobe extends IPodsetnik {
    osobaId: number;
    osoba?: string | undefined;
}

export class TransakcijeKorisnika implements ITransakcijeKorisnika {
    idOsobe!: number;
    transakcije?: string[] | undefined;

    constructor(data?: ITransakcijeKorisnika) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idOsobe = _data["idOsobe"];
            if (Array.isArray(_data["transakcije"])) {
                this.transakcije = [] as any;
                for (let item of _data["transakcije"])
                    this.transakcije!.push(item);
            }
        }
    }

    static fromJS(data: any): TransakcijeKorisnika {
        data = typeof data === 'object' ? data : {};
        let result = new TransakcijeKorisnika();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idOsobe"] = this.idOsobe;
        if (Array.isArray(this.transakcije)) {
            data["transakcije"] = [];
            for (let item of this.transakcije)
                data["transakcije"].push(item);
        }
        return data; 
    }
}

export interface ITransakcijeKorisnika {
    idOsobe: number;
    transakcije?: string[] | undefined;
}

export class Dashboard implements IDashboard {
    ucesceUUkupnimTroskovima?: { [key: string]: UcesceUUkupnimTroskovima; } | undefined;
    inventarskiVozniPark?: InventarskiVozniPark | undefined;
    ukupniTrosak?: UkupniTrosak | undefined;
    pcPoGodinama?: PCPoGodinama[] | undefined;
    troskoviOdrzavanjaPoVozilima?: { [key: string]: TroskoviOdrzavanjaPoVozilima[]; } | undefined;
    troskoviOdrzavanjaPoGrupama?: { [key: string]: DashboardTroskoviOdrzavanjaPoGrupama[]; } | undefined;
    predjeniKilometri?: PredjeniKilometri | undefined;

    constructor(data?: IDashboard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["ucesceUUkupnimTroskovima"]) {
                this.ucesceUUkupnimTroskovima = {} as any;
                for (let key in _data["ucesceUUkupnimTroskovima"]) {
                    if (_data["ucesceUUkupnimTroskovima"].hasOwnProperty(key))
                        this.ucesceUUkupnimTroskovima![key] = _data["ucesceUUkupnimTroskovima"][key] ? UcesceUUkupnimTroskovima.fromJS(_data["ucesceUUkupnimTroskovima"][key]) : new UcesceUUkupnimTroskovima();
                }
            }
            this.inventarskiVozniPark = _data["inventarskiVozniPark"] ? InventarskiVozniPark.fromJS(_data["inventarskiVozniPark"]) : <any>undefined;
            this.ukupniTrosak = _data["ukupniTrosak"] ? UkupniTrosak.fromJS(_data["ukupniTrosak"]) : <any>undefined;
            if (Array.isArray(_data["pcPoGodinama"])) {
                this.pcPoGodinama = [] as any;
                for (let item of _data["pcPoGodinama"])
                    this.pcPoGodinama!.push(PCPoGodinama.fromJS(item));
            }
            if (_data["troskoviOdrzavanjaPoVozilima"]) {
                this.troskoviOdrzavanjaPoVozilima = {} as any;
                for (let key in _data["troskoviOdrzavanjaPoVozilima"]) {
                    if (_data["troskoviOdrzavanjaPoVozilima"].hasOwnProperty(key))
                        this.troskoviOdrzavanjaPoVozilima![key] = _data["troskoviOdrzavanjaPoVozilima"][key] ? _data["troskoviOdrzavanjaPoVozilima"][key].map((i: any) => TroskoviOdrzavanjaPoVozilima.fromJS(i)) : [];
                }
            }
            if (_data["troskoviOdrzavanjaPoGrupama"]) {
                this.troskoviOdrzavanjaPoGrupama = {} as any;
                for (let key in _data["troskoviOdrzavanjaPoGrupama"]) {
                    if (_data["troskoviOdrzavanjaPoGrupama"].hasOwnProperty(key))
                        this.troskoviOdrzavanjaPoGrupama![key] = _data["troskoviOdrzavanjaPoGrupama"][key] ? _data["troskoviOdrzavanjaPoGrupama"][key].map((i: any) => DashboardTroskoviOdrzavanjaPoGrupama.fromJS(i)) : [];
                }
            }
            this.predjeniKilometri = _data["predjeniKilometri"] ? PredjeniKilometri.fromJS(_data["predjeniKilometri"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Dashboard {
        data = typeof data === 'object' ? data : {};
        let result = new Dashboard();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.ucesceUUkupnimTroskovima) {
            data["ucesceUUkupnimTroskovima"] = {};
            for (let key in this.ucesceUUkupnimTroskovima) {
                if (this.ucesceUUkupnimTroskovima.hasOwnProperty(key))
                    data["ucesceUUkupnimTroskovima"][key] = this.ucesceUUkupnimTroskovima[key] ? this.ucesceUUkupnimTroskovima[key].toJSON() : <any>undefined;
            }
        }
        data["inventarskiVozniPark"] = this.inventarskiVozniPark ? this.inventarskiVozniPark.toJSON() : <any>undefined;
        data["ukupniTrosak"] = this.ukupniTrosak ? this.ukupniTrosak.toJSON() : <any>undefined;
        if (Array.isArray(this.pcPoGodinama)) {
            data["pcPoGodinama"] = [];
            for (let item of this.pcPoGodinama)
                data["pcPoGodinama"].push(item.toJSON());
        }
        if (this.troskoviOdrzavanjaPoVozilima) {
            data["troskoviOdrzavanjaPoVozilima"] = {};
            for (let key in this.troskoviOdrzavanjaPoVozilima) {
                if (this.troskoviOdrzavanjaPoVozilima.hasOwnProperty(key))
                    data["troskoviOdrzavanjaPoVozilima"][key] = this.troskoviOdrzavanjaPoVozilima[key];
            }
        }
        if (this.troskoviOdrzavanjaPoGrupama) {
            data["troskoviOdrzavanjaPoGrupama"] = {};
            for (let key in this.troskoviOdrzavanjaPoGrupama) {
                if (this.troskoviOdrzavanjaPoGrupama.hasOwnProperty(key))
                    data["troskoviOdrzavanjaPoGrupama"][key] = this.troskoviOdrzavanjaPoGrupama[key];
            }
        }
        data["predjeniKilometri"] = this.predjeniKilometri ? this.predjeniKilometri.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IDashboard {
    ucesceUUkupnimTroskovima?: { [key: string]: UcesceUUkupnimTroskovima; } | undefined;
    inventarskiVozniPark?: InventarskiVozniPark | undefined;
    ukupniTrosak?: UkupniTrosak | undefined;
    pcPoGodinama?: PCPoGodinama[] | undefined;
    troskoviOdrzavanjaPoVozilima?: { [key: string]: TroskoviOdrzavanjaPoVozilima[]; } | undefined;
    troskoviOdrzavanjaPoGrupama?: { [key: string]: DashboardTroskoviOdrzavanjaPoGrupama[]; } | undefined;
    predjeniKilometri?: PredjeniKilometri | undefined;
}

export class UcesceUUkupnimTroskovima implements IUcesceUUkupnimTroskovima {
    gorivo!: number;
    odrzavanje!: number;
    osiguranje!: number;
    amortizacija!: number;
    takse!: number;
    sum!: number;

    constructor(data?: IUcesceUUkupnimTroskovima) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gorivo = _data["gorivo"];
            this.odrzavanje = _data["odrzavanje"];
            this.osiguranje = _data["osiguranje"];
            this.amortizacija = _data["amortizacija"];
            this.takse = _data["takse"];
            this.sum = _data["sum"];
        }
    }

    static fromJS(data: any): UcesceUUkupnimTroskovima {
        data = typeof data === 'object' ? data : {};
        let result = new UcesceUUkupnimTroskovima();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gorivo"] = this.gorivo;
        data["odrzavanje"] = this.odrzavanje;
        data["osiguranje"] = this.osiguranje;
        data["amortizacija"] = this.amortizacija;
        data["takse"] = this.takse;
        data["sum"] = this.sum;
        return data; 
    }
}

export interface IUcesceUUkupnimTroskovima {
    gorivo: number;
    odrzavanje: number;
    osiguranje: number;
    amortizacija: number;
    takse: number;
    sum: number;
}

export class InventarskiVozniPark implements IInventarskiVozniPark {
    brojVozila!: number;
    porastUOdnosuNaProsluGodinu!: number;

    constructor(data?: IInventarskiVozniPark) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.brojVozila = _data["brojVozila"];
            this.porastUOdnosuNaProsluGodinu = _data["porastUOdnosuNaProsluGodinu"];
        }
    }

    static fromJS(data: any): InventarskiVozniPark {
        data = typeof data === 'object' ? data : {};
        let result = new InventarskiVozniPark();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["brojVozila"] = this.brojVozila;
        data["porastUOdnosuNaProsluGodinu"] = this.porastUOdnosuNaProsluGodinu;
        return data; 
    }
}

export interface IInventarskiVozniPark {
    brojVozila: number;
    porastUOdnosuNaProsluGodinu: number;
}

export class UkupniTrosak implements IUkupniTrosak {
    iznosUkupnogTroska!: number;
    porastUTekucojGodini!: number;

    constructor(data?: IUkupniTrosak) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.iznosUkupnogTroska = _data["iznosUkupnogTroska"];
            this.porastUTekucojGodini = _data["porastUTekucojGodini"];
        }
    }

    static fromJS(data: any): UkupniTrosak {
        data = typeof data === 'object' ? data : {};
        let result = new UkupniTrosak();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["iznosUkupnogTroska"] = this.iznosUkupnogTroska;
        data["porastUTekucojGodini"] = this.porastUTekucojGodini;
        return data; 
    }
}

export interface IUkupniTrosak {
    iznosUkupnogTroska: number;
    porastUTekucojGodini: number;
}

export class PCPoGodinama implements IPCPoGodinama {
    godina!: number;
    p?: number | undefined;
    c?: number | undefined;

    constructor(data?: IPCPoGodinama) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.godina = _data["godina"];
            this.p = _data["p"];
            this.c = _data["c"];
        }
    }

    static fromJS(data: any): PCPoGodinama {
        data = typeof data === 'object' ? data : {};
        let result = new PCPoGodinama();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["godina"] = this.godina;
        data["p"] = this.p;
        data["c"] = this.c;
        return data; 
    }
}

export interface IPCPoGodinama {
    godina: number;
    p?: number | undefined;
    c?: number | undefined;
}

export class TroskoviOdrzavanjaPoVozilima implements ITroskoviOdrzavanjaPoVozilima {
    godina!: number;
    vozilo?: string | undefined;
    iznos!: number;

    constructor(data?: ITroskoviOdrzavanjaPoVozilima) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.godina = _data["godina"];
            this.vozilo = _data["vozilo"];
            this.iznos = _data["iznos"];
        }
    }

    static fromJS(data: any): TroskoviOdrzavanjaPoVozilima {
        data = typeof data === 'object' ? data : {};
        let result = new TroskoviOdrzavanjaPoVozilima();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["godina"] = this.godina;
        data["vozilo"] = this.vozilo;
        data["iznos"] = this.iznos;
        return data; 
    }
}

export interface ITroskoviOdrzavanjaPoVozilima {
    godina: number;
    vozilo?: string | undefined;
    iznos: number;
}

export class DashboardTroskoviOdrzavanjaPoGrupama implements IDashboardTroskoviOdrzavanjaPoGrupama {
    godina!: number;
    naziv?: string | undefined;
    iznos!: number;
    preventivno!: boolean;
    sortOrder!: number;

    constructor(data?: IDashboardTroskoviOdrzavanjaPoGrupama) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.godina = _data["godina"];
            this.naziv = _data["naziv"];
            this.iznos = _data["iznos"];
            this.preventivno = _data["preventivno"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): DashboardTroskoviOdrzavanjaPoGrupama {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardTroskoviOdrzavanjaPoGrupama();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["godina"] = this.godina;
        data["naziv"] = this.naziv;
        data["iznos"] = this.iznos;
        data["preventivno"] = this.preventivno;
        data["sortOrder"] = this.sortOrder;
        return data; 
    }
}

export interface IDashboardTroskoviOdrzavanjaPoGrupama {
    godina: number;
    naziv?: string | undefined;
    iznos: number;
    preventivno: boolean;
    sortOrder: number;
}

export class PredjeniKilometri implements IPredjeniKilometri {
    predjenoKilometara!: number;
    porast!: number;

    constructor(data?: IPredjeniKilometri) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.predjenoKilometara = _data["predjenoKilometara"];
            this.porast = _data["porast"];
        }
    }

    static fromJS(data: any): PredjeniKilometri {
        data = typeof data === 'object' ? data : {};
        let result = new PredjeniKilometri();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["predjenoKilometara"] = this.predjenoKilometara;
        data["porast"] = this.porast;
        return data; 
    }
}

export interface IPredjeniKilometri {
    predjenoKilometara: number;
    porast: number;
}

export class Entity implements IEntity {
    id!: number;
    isNew!: boolean;

    constructor(data?: IEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isNew = _data["isNew"];
        }
    }

    static fromJS(data: any): Entity {
        data = typeof data === 'object' ? data : {};
        let result = new Entity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isNew"] = this.isNew;
        return data; 
    }
}

export interface IEntity {
    id: number;
    isNew: boolean;
}

export class Firma extends Entity implements IFirma {
    naziv?: string | undefined;
    pib?: string | undefined;
    maticniBroj?: string | undefined;
    ulicaIBroj?: string | undefined;
    mesto?: string | undefined;
    telefon?: string | undefined;
    email?: string | undefined;

    constructor(data?: IFirma) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.naziv = _data["naziv"];
            this.pib = _data["pib"];
            this.maticniBroj = _data["maticniBroj"];
            this.ulicaIBroj = _data["ulicaIBroj"];
            this.mesto = _data["mesto"];
            this.telefon = _data["telefon"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): Firma {
        data = typeof data === 'object' ? data : {};
        let result = new Firma();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["naziv"] = this.naziv;
        data["pib"] = this.pib;
        data["maticniBroj"] = this.maticniBroj;
        data["ulicaIBroj"] = this.ulicaIBroj;
        data["mesto"] = this.mesto;
        data["telefon"] = this.telefon;
        data["email"] = this.email;
        super.toJSON(data);
        return data; 
    }
}

export interface IFirma extends IEntity {
    naziv?: string | undefined;
    pib?: string | undefined;
    maticniBroj?: string | undefined;
    ulicaIBroj?: string | undefined;
    mesto?: string | undefined;
    telefon?: string | undefined;
    email?: string | undefined;
}

export class Exception implements IException {
    stackTrace?: string | undefined;
    message!: string;
    innerException?: Exception | undefined;
    source?: string | undefined;

    constructor(data?: IException) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stackTrace = _data["StackTrace"];
            this.message = _data["Message"];
            this.innerException = _data["InnerException"] ? Exception.fromJS(_data["InnerException"]) : <any>undefined;
            this.source = _data["Source"];
        }
    }

    static fromJS(data: any): Exception {
        data = typeof data === 'object' ? data : {};
        let result = new Exception();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["StackTrace"] = this.stackTrace;
        data["Message"] = this.message;
        data["InnerException"] = this.innerException ? this.innerException.toJSON() : <any>undefined;
        data["Source"] = this.source;
        return data; 
    }
}

export interface IException {
    stackTrace?: string | undefined;
    message: string;
    innerException?: Exception | undefined;
    source?: string | undefined;
}

export class ValidationException extends Exception implements IValidationException {
    failures?: { [key: string]: string[]; } | undefined;

    constructor(data?: IValidationException) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (_data["failures"]) {
                this.failures = {} as any;
                for (let key in _data["failures"]) {
                    if (_data["failures"].hasOwnProperty(key))
                        this.failures![key] = _data["failures"][key] !== undefined ? _data["failures"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): ValidationException {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationException();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.failures) {
            data["failures"] = {};
            for (let key in this.failures) {
                if (this.failures.hasOwnProperty(key))
                    data["failures"][key] = this.failures[key];
            }
        }
        super.toJSON(data);
        return data; 
    }
}

export interface IValidationException extends IException {
    failures?: { [key: string]: string[]; } | undefined;
}

export class PredjeniKilometriIPotrosnjaGoriva implements IPredjeniKilometriIPotrosnjaGoriva {
    predjeniKilometri?: F_izv_PotrosnjaGorivaIPredjeniKilometriPoGrupamaVozila[] | undefined;
    potrosenoGorivo?: F_izv_PotrosnjaGorivaIPredjeniKilometriPoGrupamaVozila[] | undefined;

    constructor(data?: IPredjeniKilometriIPotrosnjaGoriva) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["predjeniKilometri"])) {
                this.predjeniKilometri = [] as any;
                for (let item of _data["predjeniKilometri"])
                    this.predjeniKilometri!.push(F_izv_PotrosnjaGorivaIPredjeniKilometriPoGrupamaVozila.fromJS(item));
            }
            if (Array.isArray(_data["potrosenoGorivo"])) {
                this.potrosenoGorivo = [] as any;
                for (let item of _data["potrosenoGorivo"])
                    this.potrosenoGorivo!.push(F_izv_PotrosnjaGorivaIPredjeniKilometriPoGrupamaVozila.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PredjeniKilometriIPotrosnjaGoriva {
        data = typeof data === 'object' ? data : {};
        let result = new PredjeniKilometriIPotrosnjaGoriva();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.predjeniKilometri)) {
            data["predjeniKilometri"] = [];
            for (let item of this.predjeniKilometri)
                data["predjeniKilometri"].push(item.toJSON());
        }
        if (Array.isArray(this.potrosenoGorivo)) {
            data["potrosenoGorivo"] = [];
            for (let item of this.potrosenoGorivo)
                data["potrosenoGorivo"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPredjeniKilometriIPotrosnjaGoriva {
    predjeniKilometri?: F_izv_PotrosnjaGorivaIPredjeniKilometriPoGrupamaVozila[] | undefined;
    potrosenoGorivo?: F_izv_PotrosnjaGorivaIPredjeniKilometriPoGrupamaVozila[] | undefined;
}

export class F_izv_PotrosnjaGorivaIPredjeniKilometriPoGrupamaVozila implements IF_izv_PotrosnjaGorivaIPredjeniKilometriPoGrupamaVozila {
    grupa?: string | undefined;
    podGrupa?: string | undefined;
    januar!: number;
    februar!: number;
    mart!: number;
    april!: number;
    maj!: number;
    jun!: number;
    jul!: number;
    avgust!: number;
    septembar!: number;
    oktobar!: number;
    novembar!: number;
    decembar!: number;
    total!: number;

    constructor(data?: IF_izv_PotrosnjaGorivaIPredjeniKilometriPoGrupamaVozila) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.grupa = _data["grupa"];
            this.podGrupa = _data["podGrupa"];
            this.januar = _data["januar"];
            this.februar = _data["februar"];
            this.mart = _data["mart"];
            this.april = _data["april"];
            this.maj = _data["maj"];
            this.jun = _data["jun"];
            this.jul = _data["jul"];
            this.avgust = _data["avgust"];
            this.septembar = _data["septembar"];
            this.oktobar = _data["oktobar"];
            this.novembar = _data["novembar"];
            this.decembar = _data["decembar"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): F_izv_PotrosnjaGorivaIPredjeniKilometriPoGrupamaVozila {
        data = typeof data === 'object' ? data : {};
        let result = new F_izv_PotrosnjaGorivaIPredjeniKilometriPoGrupamaVozila();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["grupa"] = this.grupa;
        data["podGrupa"] = this.podGrupa;
        data["januar"] = this.januar;
        data["februar"] = this.februar;
        data["mart"] = this.mart;
        data["april"] = this.april;
        data["maj"] = this.maj;
        data["jun"] = this.jun;
        data["jul"] = this.jul;
        data["avgust"] = this.avgust;
        data["septembar"] = this.septembar;
        data["oktobar"] = this.oktobar;
        data["novembar"] = this.novembar;
        data["decembar"] = this.decembar;
        data["total"] = this.total;
        return data; 
    }
}

export interface IF_izv_PotrosnjaGorivaIPredjeniKilometriPoGrupamaVozila {
    grupa?: string | undefined;
    podGrupa?: string | undefined;
    januar: number;
    februar: number;
    mart: number;
    april: number;
    maj: number;
    jun: number;
    jul: number;
    avgust: number;
    septembar: number;
    oktobar: number;
    novembar: number;
    decembar: number;
    total: number;
}

export class F_izv_TroskoviVozila implements IF_izv_TroskoviVozila {
    voziloId!: number;
    registarskaOznaka?: string | undefined;
    markaIModel?: string | undefined;
    troskoviOdrzavanja!: number;
    troskoviGoriva!: number;
    ukupniTroskovi!: number;
    ukupnaKilometraza!: number;
    trosakPoKm!: number;

    constructor(data?: IF_izv_TroskoviVozila) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.voziloId = _data["voziloId"];
            this.registarskaOznaka = _data["registarskaOznaka"];
            this.markaIModel = _data["markaIModel"];
            this.troskoviOdrzavanja = _data["troskoviOdrzavanja"];
            this.troskoviGoriva = _data["troskoviGoriva"];
            this.ukupniTroskovi = _data["ukupniTroskovi"];
            this.ukupnaKilometraza = _data["ukupnaKilometraza"];
            this.trosakPoKm = _data["trosakPoKm"];
        }
    }

    static fromJS(data: any): F_izv_TroskoviVozila {
        data = typeof data === 'object' ? data : {};
        let result = new F_izv_TroskoviVozila();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voziloId"] = this.voziloId;
        data["registarskaOznaka"] = this.registarskaOznaka;
        data["markaIModel"] = this.markaIModel;
        data["troskoviOdrzavanja"] = this.troskoviOdrzavanja;
        data["troskoviGoriva"] = this.troskoviGoriva;
        data["ukupniTroskovi"] = this.ukupniTroskovi;
        data["ukupnaKilometraza"] = this.ukupnaKilometraza;
        data["trosakPoKm"] = this.trosakPoKm;
        return data; 
    }
}

export interface IF_izv_TroskoviVozila {
    voziloId: number;
    registarskaOznaka?: string | undefined;
    markaIModel?: string | undefined;
    troskoviOdrzavanja: number;
    troskoviGoriva: number;
    ukupniTroskovi: number;
    ukupnaKilometraza: number;
    trosakPoKm: number;
}

export class F_izv_VratiPrejdeneKilometreVozilaIVozaca implements IF_izv_VratiPrejdeneKilometreVozilaIVozaca {
    registarskaOznaka?: string | undefined;
    markaIModelVozila?: string | undefined;
    vozac?: string | undefined;
    predjeno!: number;
    ukupnoPredjeniKilometriVozila!: number;
    procenat1!: number;
    procenat2!: number;

    constructor(data?: IF_izv_VratiPrejdeneKilometreVozilaIVozaca) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.registarskaOznaka = _data["registarskaOznaka"];
            this.markaIModelVozila = _data["markaIModelVozila"];
            this.vozac = _data["vozac"];
            this.predjeno = _data["predjeno"];
            this.ukupnoPredjeniKilometriVozila = _data["ukupnoPredjeniKilometriVozila"];
            this.procenat1 = _data["procenat1"];
            this.procenat2 = _data["procenat2"];
        }
    }

    static fromJS(data: any): F_izv_VratiPrejdeneKilometreVozilaIVozaca {
        data = typeof data === 'object' ? data : {};
        let result = new F_izv_VratiPrejdeneKilometreVozilaIVozaca();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["registarskaOznaka"] = this.registarskaOznaka;
        data["markaIModelVozila"] = this.markaIModelVozila;
        data["vozac"] = this.vozac;
        data["predjeno"] = this.predjeno;
        data["ukupnoPredjeniKilometriVozila"] = this.ukupnoPredjeniKilometriVozila;
        data["procenat1"] = this.procenat1;
        data["procenat2"] = this.procenat2;
        return data; 
    }
}

export interface IF_izv_VratiPrejdeneKilometreVozilaIVozaca {
    registarskaOznaka?: string | undefined;
    markaIModelVozila?: string | undefined;
    vozac?: string | undefined;
    predjeno: number;
    ukupnoPredjeniKilometriVozila: number;
    procenat1: number;
    procenat2: number;
}

export class PregledKretanja implements IPregledKretanja {
    vozac?: string | undefined;
    vozilo?: string | undefined;
    vremePolaska!: Date;
    mestoPolaska?: string | undefined;
    kilometrazaPolaska!: number;
    vremeDolaska!: Date;
    mestoDolaska?: string | undefined;
    kilometrazaDolaska!: number;
    predjeno!: number;

    constructor(data?: IPregledKretanja) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vozac = _data["vozac"];
            this.vozilo = _data["vozilo"];
            this.vremePolaska = _data["vremePolaska"] ? new Date(_data["vremePolaska"].toString()) : <any>undefined;
            this.mestoPolaska = _data["mestoPolaska"];
            this.kilometrazaPolaska = _data["kilometrazaPolaska"];
            this.vremeDolaska = _data["vremeDolaska"] ? new Date(_data["vremeDolaska"].toString()) : <any>undefined;
            this.mestoDolaska = _data["mestoDolaska"];
            this.kilometrazaDolaska = _data["kilometrazaDolaska"];
            this.predjeno = _data["predjeno"];
        }
    }

    static fromJS(data: any): PregledKretanja {
        data = typeof data === 'object' ? data : {};
        let result = new PregledKretanja();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vozac"] = this.vozac;
        data["vozilo"] = this.vozilo;
        data["vremePolaska"] = this.vremePolaska ? this.vremePolaska.toISOString() : <any>undefined;
        data["mestoPolaska"] = this.mestoPolaska;
        data["kilometrazaPolaska"] = this.kilometrazaPolaska;
        data["vremeDolaska"] = this.vremeDolaska ? this.vremeDolaska.toISOString() : <any>undefined;
        data["mestoDolaska"] = this.mestoDolaska;
        data["kilometrazaDolaska"] = this.kilometrazaDolaska;
        data["predjeno"] = this.predjeno;
        return data; 
    }
}

export interface IPregledKretanja {
    vozac?: string | undefined;
    vozilo?: string | undefined;
    vremePolaska: Date;
    mestoPolaska?: string | undefined;
    kilometrazaPolaska: number;
    vremeDolaska: Date;
    mestoDolaska?: string | undefined;
    kilometrazaDolaska: number;
    predjeno: number;
}

export enum NotificationType {
    Podsetnik = 1,
}

export class Dokument implements IDokument {
    id!: number;
    broj?: string | undefined;

    constructor(data?: IDokument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.broj = _data["broj"];
        }
    }

    static fromJS(data: any): Dokument {
        data = typeof data === 'object' ? data : {};
        let result = new Dokument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["broj"] = this.broj;
        return data; 
    }
}

export interface IDokument {
    id: number;
    broj?: string | undefined;
}

export class StavkaDokumenta implements IStavkaDokumenta {
    id!: number;
    opis?: string | undefined;
    opis2?: string | undefined;
    vrstaOdrzavanja?: string | undefined;
    vrstaOdrzavanjaId?: number | undefined;
    grupaDelova?: string | undefined;
    grupaDelovaId?: number | undefined;
    servisnaOperacija?: string | undefined;
    servisnaOperacijaId!: number;
    rezervniDeo?: string | undefined;
    rezervniDeoId!: number;
    kolicina!: number;
    utrosenaKolicina!: number;
    cena!: number;
    iznos!: number;
    rabat!: number;
    pdvStopa!: number;
    pdv!: number;
    osnovica!: number;
    kataloskiBroj?: string | undefined;
    sifra?: string | undefined;
    vrstaTroska?: string | undefined;
    vrstaTroskaId?: number | undefined;
    raspodelaTroskova?: RaspodelaTroska[] | undefined;

    constructor(data?: IStavkaDokumenta) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.opis = _data["opis"];
            this.opis2 = _data["opis2"];
            this.vrstaOdrzavanja = _data["vrstaOdrzavanja"];
            this.vrstaOdrzavanjaId = _data["vrstaOdrzavanjaId"];
            this.grupaDelova = _data["grupaDelova"];
            this.grupaDelovaId = _data["grupaDelovaId"];
            this.servisnaOperacija = _data["servisnaOperacija"];
            this.servisnaOperacijaId = _data["servisnaOperacijaId"];
            this.rezervniDeo = _data["rezervniDeo"];
            this.rezervniDeoId = _data["rezervniDeoId"];
            this.kolicina = _data["kolicina"];
            this.utrosenaKolicina = _data["utrosenaKolicina"];
            this.cena = _data["cena"];
            this.iznos = _data["iznos"];
            this.rabat = _data["rabat"];
            this.pdvStopa = _data["pdvStopa"];
            this.pdv = _data["pdv"];
            this.osnovica = _data["osnovica"];
            this.kataloskiBroj = _data["kataloskiBroj"];
            this.sifra = _data["sifra"];
            this.vrstaTroska = _data["vrstaTroska"];
            this.vrstaTroskaId = _data["vrstaTroskaId"];
            if (Array.isArray(_data["raspodelaTroskova"])) {
                this.raspodelaTroskova = [] as any;
                for (let item of _data["raspodelaTroskova"])
                    this.raspodelaTroskova!.push(RaspodelaTroska.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StavkaDokumenta {
        data = typeof data === 'object' ? data : {};
        let result = new StavkaDokumenta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["opis"] = this.opis;
        data["opis2"] = this.opis2;
        data["vrstaOdrzavanja"] = this.vrstaOdrzavanja;
        data["vrstaOdrzavanjaId"] = this.vrstaOdrzavanjaId;
        data["grupaDelova"] = this.grupaDelova;
        data["grupaDelovaId"] = this.grupaDelovaId;
        data["servisnaOperacija"] = this.servisnaOperacija;
        data["servisnaOperacijaId"] = this.servisnaOperacijaId;
        data["rezervniDeo"] = this.rezervniDeo;
        data["rezervniDeoId"] = this.rezervniDeoId;
        data["kolicina"] = this.kolicina;
        data["utrosenaKolicina"] = this.utrosenaKolicina;
        data["cena"] = this.cena;
        data["iznos"] = this.iznos;
        data["rabat"] = this.rabat;
        data["pdvStopa"] = this.pdvStopa;
        data["pdv"] = this.pdv;
        data["osnovica"] = this.osnovica;
        data["kataloskiBroj"] = this.kataloskiBroj;
        data["sifra"] = this.sifra;
        data["vrstaTroska"] = this.vrstaTroska;
        data["vrstaTroskaId"] = this.vrstaTroskaId;
        if (Array.isArray(this.raspodelaTroskova)) {
            data["raspodelaTroskova"] = [];
            for (let item of this.raspodelaTroskova)
                data["raspodelaTroskova"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IStavkaDokumenta {
    id: number;
    opis?: string | undefined;
    opis2?: string | undefined;
    vrstaOdrzavanja?: string | undefined;
    vrstaOdrzavanjaId?: number | undefined;
    grupaDelova?: string | undefined;
    grupaDelovaId?: number | undefined;
    servisnaOperacija?: string | undefined;
    servisnaOperacijaId: number;
    rezervniDeo?: string | undefined;
    rezervniDeoId: number;
    kolicina: number;
    utrosenaKolicina: number;
    cena: number;
    iznos: number;
    rabat: number;
    pdvStopa: number;
    pdv: number;
    osnovica: number;
    kataloskiBroj?: string | undefined;
    sifra?: string | undefined;
    vrstaTroska?: string | undefined;
    vrstaTroskaId?: number | undefined;
    raspodelaTroskova?: RaspodelaTroska[] | undefined;
}

export class RaspodelaTroska implements IRaspodelaTroska {
    id!: number;
    vozilo?: string | undefined;
    voziloId!: number;
    stavkaId!: number;
    kolicina!: number;

    constructor(data?: IRaspodelaTroska) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.vozilo = _data["vozilo"];
            this.voziloId = _data["voziloId"];
            this.stavkaId = _data["stavkaId"];
            this.kolicina = _data["kolicina"];
        }
    }

    static fromJS(data: any): RaspodelaTroska {
        data = typeof data === 'object' ? data : {};
        let result = new RaspodelaTroska();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["vozilo"] = this.vozilo;
        data["voziloId"] = this.voziloId;
        data["stavkaId"] = this.stavkaId;
        data["kolicina"] = this.kolicina;
        return data; 
    }
}

export interface IRaspodelaTroska {
    id: number;
    vozilo?: string | undefined;
    voziloId: number;
    stavkaId: number;
    kolicina: number;
}

export class Artikal implements IArtikal {
    naziv?: string | undefined;
    grupaDelovaId?: number | undefined;
    vrstaOdrzavanjaId?: number | undefined;

    constructor(data?: IArtikal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.naziv = _data["naziv"];
            this.grupaDelovaId = _data["grupaDelovaId"];
            this.vrstaOdrzavanjaId = _data["vrstaOdrzavanjaId"];
        }
    }

    static fromJS(data: any): Artikal {
        data = typeof data === 'object' ? data : {};
        let result = new Artikal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["naziv"] = this.naziv;
        data["grupaDelovaId"] = this.grupaDelovaId;
        data["vrstaOdrzavanjaId"] = this.vrstaOdrzavanjaId;
        return data; 
    }
}

export interface IArtikal {
    naziv?: string | undefined;
    grupaDelovaId?: number | undefined;
    vrstaOdrzavanjaId?: number | undefined;
}

export class DokumentInfo implements IDokumentInfo {
    id!: number;
    broj?: string | undefined;
    datum!: Date;
    tip?: string | undefined;
    vozilo?: string | undefined;
    dokumentKreirao?: string | undefined;
    dobavljac?: string | undefined;
    osnovica!: number;
    pdv!: number;
    iznos!: number;
    status!: number;
    serviser?: string | undefined;
    skladiste?: string | undefined;
    deloveIzdao?: string | undefined;
    delovePrimio?: string | undefined;
    deloveVratio?: string | undefined;
    serivsneOperacije?: StavkaDokumenta[] | undefined;
    sopstveniDelovi?: StavkaDokumenta[] | undefined;
    fakturisaniDelovi?: StavkaDokumenta[] | undefined;
    troskovi?: StavkaDokumenta[] | undefined;

    constructor(data?: IDokumentInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.broj = _data["broj"];
            this.datum = _data["datum"] ? new Date(_data["datum"].toString()) : <any>undefined;
            this.tip = _data["tip"];
            this.vozilo = _data["vozilo"];
            this.dokumentKreirao = _data["dokumentKreirao"];
            this.dobavljac = _data["dobavljac"];
            this.osnovica = _data["osnovica"];
            this.pdv = _data["pdv"];
            this.iznos = _data["iznos"];
            this.status = _data["status"];
            this.serviser = _data["serviser"];
            this.skladiste = _data["skladiste"];
            this.deloveIzdao = _data["deloveIzdao"];
            this.delovePrimio = _data["delovePrimio"];
            this.deloveVratio = _data["deloveVratio"];
            if (Array.isArray(_data["serivsneOperacije"])) {
                this.serivsneOperacije = [] as any;
                for (let item of _data["serivsneOperacije"])
                    this.serivsneOperacije!.push(StavkaDokumenta.fromJS(item));
            }
            if (Array.isArray(_data["sopstveniDelovi"])) {
                this.sopstveniDelovi = [] as any;
                for (let item of _data["sopstveniDelovi"])
                    this.sopstveniDelovi!.push(StavkaDokumenta.fromJS(item));
            }
            if (Array.isArray(_data["fakturisaniDelovi"])) {
                this.fakturisaniDelovi = [] as any;
                for (let item of _data["fakturisaniDelovi"])
                    this.fakturisaniDelovi!.push(StavkaDokumenta.fromJS(item));
            }
            if (Array.isArray(_data["troskovi"])) {
                this.troskovi = [] as any;
                for (let item of _data["troskovi"])
                    this.troskovi!.push(StavkaDokumenta.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DokumentInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DokumentInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["broj"] = this.broj;
        data["datum"] = this.datum ? this.datum.toISOString() : <any>undefined;
        data["tip"] = this.tip;
        data["vozilo"] = this.vozilo;
        data["dokumentKreirao"] = this.dokumentKreirao;
        data["dobavljac"] = this.dobavljac;
        data["osnovica"] = this.osnovica;
        data["pdv"] = this.pdv;
        data["iznos"] = this.iznos;
        data["status"] = this.status;
        data["serviser"] = this.serviser;
        data["skladiste"] = this.skladiste;
        data["deloveIzdao"] = this.deloveIzdao;
        data["delovePrimio"] = this.delovePrimio;
        data["deloveVratio"] = this.deloveVratio;
        if (Array.isArray(this.serivsneOperacije)) {
            data["serivsneOperacije"] = [];
            for (let item of this.serivsneOperacije)
                data["serivsneOperacije"].push(item.toJSON());
        }
        if (Array.isArray(this.sopstveniDelovi)) {
            data["sopstveniDelovi"] = [];
            for (let item of this.sopstveniDelovi)
                data["sopstveniDelovi"].push(item.toJSON());
        }
        if (Array.isArray(this.fakturisaniDelovi)) {
            data["fakturisaniDelovi"] = [];
            for (let item of this.fakturisaniDelovi)
                data["fakturisaniDelovi"].push(item.toJSON());
        }
        if (Array.isArray(this.troskovi)) {
            data["troskovi"] = [];
            for (let item of this.troskovi)
                data["troskovi"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IDokumentInfo {
    id: number;
    broj?: string | undefined;
    datum: Date;
    tip?: string | undefined;
    vozilo?: string | undefined;
    dokumentKreirao?: string | undefined;
    dobavljac?: string | undefined;
    osnovica: number;
    pdv: number;
    iznos: number;
    status: number;
    serviser?: string | undefined;
    skladiste?: string | undefined;
    deloveIzdao?: string | undefined;
    delovePrimio?: string | undefined;
    deloveVratio?: string | undefined;
    serivsneOperacije?: StavkaDokumenta[] | undefined;
    sopstveniDelovi?: StavkaDokumenta[] | undefined;
    fakturisaniDelovi?: StavkaDokumenta[] | undefined;
    troskovi?: StavkaDokumenta[] | undefined;
}

export class PovezaniDokument implements IPovezaniDokument {
    id!: number;
    broj?: string | undefined;
    tip?: string | undefined;
    datum!: Date;

    constructor(data?: IPovezaniDokument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.broj = _data["broj"];
            this.tip = _data["tip"];
            this.datum = _data["datum"] ? new Date(_data["datum"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PovezaniDokument {
        data = typeof data === 'object' ? data : {};
        let result = new PovezaniDokument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["broj"] = this.broj;
        data["tip"] = this.tip;
        data["datum"] = this.datum ? this.datum.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IPovezaniDokument {
    id: number;
    broj?: string | undefined;
    tip?: string | undefined;
    datum: Date;
}

export class Faktura extends Dokument implements IFaktura {
    datum!: Date;
    referenca?: string | undefined;
    dobavljacId?: number | undefined;
    dobavljac?: string | undefined;
    voziloId?: number | undefined;
    vozilo?: string | undefined;
    dokumentKreiraoId?: number | undefined;
    dokumentKreirao?: string | undefined;
    radniNalogId?: number | undefined;
    servisneOperacije?: StavkaDokumenta[] | undefined;
    sopstveniDelovi?: StavkaDokumenta[] | undefined;
    fakturisaniDelovi?: StavkaDokumenta[] | undefined;
    troskovi?: StavkaDokumenta[] | undefined;
    osnovica!: number;
    pdv!: number;
    iznos!: number;
    kilometraza!: number;
    brojZapisnikaStete?: string | undefined;

    constructor(data?: IFaktura) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.datum = _data["datum"] ? new Date(_data["datum"].toString()) : <any>undefined;
            this.referenca = _data["referenca"];
            this.dobavljacId = _data["dobavljacId"];
            this.dobavljac = _data["dobavljac"];
            this.voziloId = _data["voziloId"];
            this.vozilo = _data["vozilo"];
            this.dokumentKreiraoId = _data["dokumentKreiraoId"];
            this.dokumentKreirao = _data["dokumentKreirao"];
            this.radniNalogId = _data["radniNalogId"];
            if (Array.isArray(_data["servisneOperacije"])) {
                this.servisneOperacije = [] as any;
                for (let item of _data["servisneOperacije"])
                    this.servisneOperacije!.push(StavkaDokumenta.fromJS(item));
            }
            if (Array.isArray(_data["sopstveniDelovi"])) {
                this.sopstveniDelovi = [] as any;
                for (let item of _data["sopstveniDelovi"])
                    this.sopstveniDelovi!.push(StavkaDokumenta.fromJS(item));
            }
            if (Array.isArray(_data["fakturisaniDelovi"])) {
                this.fakturisaniDelovi = [] as any;
                for (let item of _data["fakturisaniDelovi"])
                    this.fakturisaniDelovi!.push(StavkaDokumenta.fromJS(item));
            }
            if (Array.isArray(_data["troskovi"])) {
                this.troskovi = [] as any;
                for (let item of _data["troskovi"])
                    this.troskovi!.push(StavkaDokumenta.fromJS(item));
            }
            this.osnovica = _data["osnovica"];
            this.pdv = _data["pdv"];
            this.iznos = _data["iznos"];
            this.kilometraza = _data["kilometraza"];
            this.brojZapisnikaStete = _data["brojZapisnikaStete"];
        }
    }

    static fromJS(data: any): Faktura {
        data = typeof data === 'object' ? data : {};
        let result = new Faktura();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["datum"] = this.datum ? this.datum.toISOString() : <any>undefined;
        data["referenca"] = this.referenca;
        data["dobavljacId"] = this.dobavljacId;
        data["dobavljac"] = this.dobavljac;
        data["voziloId"] = this.voziloId;
        data["vozilo"] = this.vozilo;
        data["dokumentKreiraoId"] = this.dokumentKreiraoId;
        data["dokumentKreirao"] = this.dokumentKreirao;
        data["radniNalogId"] = this.radniNalogId;
        if (Array.isArray(this.servisneOperacije)) {
            data["servisneOperacije"] = [];
            for (let item of this.servisneOperacije)
                data["servisneOperacije"].push(item.toJSON());
        }
        if (Array.isArray(this.sopstveniDelovi)) {
            data["sopstveniDelovi"] = [];
            for (let item of this.sopstveniDelovi)
                data["sopstveniDelovi"].push(item.toJSON());
        }
        if (Array.isArray(this.fakturisaniDelovi)) {
            data["fakturisaniDelovi"] = [];
            for (let item of this.fakturisaniDelovi)
                data["fakturisaniDelovi"].push(item.toJSON());
        }
        if (Array.isArray(this.troskovi)) {
            data["troskovi"] = [];
            for (let item of this.troskovi)
                data["troskovi"].push(item.toJSON());
        }
        data["osnovica"] = this.osnovica;
        data["pdv"] = this.pdv;
        data["iznos"] = this.iznos;
        data["kilometraza"] = this.kilometraza;
        data["brojZapisnikaStete"] = this.brojZapisnikaStete;
        super.toJSON(data);
        return data; 
    }
}

export interface IFaktura extends IDokument {
    datum: Date;
    referenca?: string | undefined;
    dobavljacId?: number | undefined;
    dobavljac?: string | undefined;
    voziloId?: number | undefined;
    vozilo?: string | undefined;
    dokumentKreiraoId?: number | undefined;
    dokumentKreirao?: string | undefined;
    radniNalogId?: number | undefined;
    servisneOperacije?: StavkaDokumenta[] | undefined;
    sopstveniDelovi?: StavkaDokumenta[] | undefined;
    fakturisaniDelovi?: StavkaDokumenta[] | undefined;
    troskovi?: StavkaDokumenta[] | undefined;
    osnovica: number;
    pdv: number;
    iznos: number;
    kilometraza: number;
    brojZapisnikaStete?: string | undefined;
}

export class GrupeDelovaVozila implements IGrupeDelovaVozila {
    id!: number;
    oznaka?: string | undefined;
    naziv?: string | undefined;
    preventivnoOdrzavanje?: string | undefined;
    preventivnoOdrzavanjeId?: number | undefined;
    korektivnoOdrzavanje?: string | undefined;
    korektivnoOdrzavanjeId?: number | undefined;

    constructor(data?: IGrupeDelovaVozila) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.oznaka = _data["oznaka"];
            this.naziv = _data["naziv"];
            this.preventivnoOdrzavanje = _data["preventivnoOdrzavanje"];
            this.preventivnoOdrzavanjeId = _data["preventivnoOdrzavanjeId"];
            this.korektivnoOdrzavanje = _data["korektivnoOdrzavanje"];
            this.korektivnoOdrzavanjeId = _data["korektivnoOdrzavanjeId"];
        }
    }

    static fromJS(data: any): GrupeDelovaVozila {
        data = typeof data === 'object' ? data : {};
        let result = new GrupeDelovaVozila();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["oznaka"] = this.oznaka;
        data["naziv"] = this.naziv;
        data["preventivnoOdrzavanje"] = this.preventivnoOdrzavanje;
        data["preventivnoOdrzavanjeId"] = this.preventivnoOdrzavanjeId;
        data["korektivnoOdrzavanje"] = this.korektivnoOdrzavanje;
        data["korektivnoOdrzavanjeId"] = this.korektivnoOdrzavanjeId;
        return data; 
    }
}

export interface IGrupeDelovaVozila {
    id: number;
    oznaka?: string | undefined;
    naziv?: string | undefined;
    preventivnoOdrzavanje?: string | undefined;
    preventivnoOdrzavanjeId?: number | undefined;
    korektivnoOdrzavanje?: string | undefined;
    korektivnoOdrzavanjeId?: number | undefined;
}

export class RadniNalog implements IRadniNalog {
    id!: number;
    broj?: string | undefined;
    datum!: Date;
    serviserId?: number | undefined;
    serviser?: string | undefined;
    voziloId!: number;
    vozilo?: string | undefined;
    prijavaKvaraId?: number | undefined;
    dokumentKreiraoId?: number | undefined;
    dokumentKreirao?: string | undefined;
    kilometraza!: number;
    servisneOperacije?: StavkaDokumenta[] | undefined;
    rezervniDelovi?: StavkaDokumenta[] | undefined;
    iznos!: number;

    constructor(data?: IRadniNalog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.broj = _data["broj"];
            this.datum = _data["datum"] ? new Date(_data["datum"].toString()) : <any>undefined;
            this.serviserId = _data["serviserId"];
            this.serviser = _data["serviser"];
            this.voziloId = _data["voziloId"];
            this.vozilo = _data["vozilo"];
            this.prijavaKvaraId = _data["prijavaKvaraId"];
            this.dokumentKreiraoId = _data["dokumentKreiraoId"];
            this.dokumentKreirao = _data["dokumentKreirao"];
            this.kilometraza = _data["kilometraza"];
            if (Array.isArray(_data["servisneOperacije"])) {
                this.servisneOperacije = [] as any;
                for (let item of _data["servisneOperacije"])
                    this.servisneOperacije!.push(StavkaDokumenta.fromJS(item));
            }
            if (Array.isArray(_data["rezervniDelovi"])) {
                this.rezervniDelovi = [] as any;
                for (let item of _data["rezervniDelovi"])
                    this.rezervniDelovi!.push(StavkaDokumenta.fromJS(item));
            }
            this.iznos = _data["iznos"];
        }
    }

    static fromJS(data: any): RadniNalog {
        data = typeof data === 'object' ? data : {};
        let result = new RadniNalog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["broj"] = this.broj;
        data["datum"] = this.datum ? this.datum.toISOString() : <any>undefined;
        data["serviserId"] = this.serviserId;
        data["serviser"] = this.serviser;
        data["voziloId"] = this.voziloId;
        data["vozilo"] = this.vozilo;
        data["prijavaKvaraId"] = this.prijavaKvaraId;
        data["dokumentKreiraoId"] = this.dokumentKreiraoId;
        data["dokumentKreirao"] = this.dokumentKreirao;
        data["kilometraza"] = this.kilometraza;
        if (Array.isArray(this.servisneOperacije)) {
            data["servisneOperacije"] = [];
            for (let item of this.servisneOperacije)
                data["servisneOperacije"].push(item.toJSON());
        }
        if (Array.isArray(this.rezervniDelovi)) {
            data["rezervniDelovi"] = [];
            for (let item of this.rezervniDelovi)
                data["rezervniDelovi"].push(item.toJSON());
        }
        data["iznos"] = this.iznos;
        return data; 
    }
}

export interface IRadniNalog {
    id: number;
    broj?: string | undefined;
    datum: Date;
    serviserId?: number | undefined;
    serviser?: string | undefined;
    voziloId: number;
    vozilo?: string | undefined;
    prijavaKvaraId?: number | undefined;
    dokumentKreiraoId?: number | undefined;
    dokumentKreirao?: string | undefined;
    kilometraza: number;
    servisneOperacije?: StavkaDokumenta[] | undefined;
    rezervniDelovi?: StavkaDokumenta[] | undefined;
    iznos: number;
}

export class Izdatnica implements IIzdatnica {
    id!: number;
    broj?: string | undefined;
    datum!: Date;
    trebovanjeId!: number;
    deloveIzdaoId!: number;
    deloveIzdao?: string | undefined;
    delovePrimioId!: number;
    delovePrimio?: string | undefined;
    dokumentKreiraoId?: number | undefined;
    dokumentKreirao?: string | undefined;
    skladisteId?: number | undefined;
    skladiste?: string | undefined;
    radniNalog?: string | undefined;
    delovi?: StavkaDokumenta[] | undefined;
    iznos!: number;

    constructor(data?: IIzdatnica) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.broj = _data["broj"];
            this.datum = _data["datum"] ? new Date(_data["datum"].toString()) : <any>undefined;
            this.trebovanjeId = _data["trebovanjeId"];
            this.deloveIzdaoId = _data["deloveIzdaoId"];
            this.deloveIzdao = _data["deloveIzdao"];
            this.delovePrimioId = _data["delovePrimioId"];
            this.delovePrimio = _data["delovePrimio"];
            this.dokumentKreiraoId = _data["dokumentKreiraoId"];
            this.dokumentKreirao = _data["dokumentKreirao"];
            this.skladisteId = _data["skladisteId"];
            this.skladiste = _data["skladiste"];
            this.radniNalog = _data["radniNalog"];
            if (Array.isArray(_data["delovi"])) {
                this.delovi = [] as any;
                for (let item of _data["delovi"])
                    this.delovi!.push(StavkaDokumenta.fromJS(item));
            }
            this.iznos = _data["iznos"];
        }
    }

    static fromJS(data: any): Izdatnica {
        data = typeof data === 'object' ? data : {};
        let result = new Izdatnica();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["broj"] = this.broj;
        data["datum"] = this.datum ? this.datum.toISOString() : <any>undefined;
        data["trebovanjeId"] = this.trebovanjeId;
        data["deloveIzdaoId"] = this.deloveIzdaoId;
        data["deloveIzdao"] = this.deloveIzdao;
        data["delovePrimioId"] = this.delovePrimioId;
        data["delovePrimio"] = this.delovePrimio;
        data["dokumentKreiraoId"] = this.dokumentKreiraoId;
        data["dokumentKreirao"] = this.dokumentKreirao;
        data["skladisteId"] = this.skladisteId;
        data["skladiste"] = this.skladiste;
        data["radniNalog"] = this.radniNalog;
        if (Array.isArray(this.delovi)) {
            data["delovi"] = [];
            for (let item of this.delovi)
                data["delovi"].push(item.toJSON());
        }
        data["iznos"] = this.iznos;
        return data; 
    }
}

export interface IIzdatnica {
    id: number;
    broj?: string | undefined;
    datum: Date;
    trebovanjeId: number;
    deloveIzdaoId: number;
    deloveIzdao?: string | undefined;
    delovePrimioId: number;
    delovePrimio?: string | undefined;
    dokumentKreiraoId?: number | undefined;
    dokumentKreirao?: string | undefined;
    skladisteId?: number | undefined;
    skladiste?: string | undefined;
    radniNalog?: string | undefined;
    delovi?: StavkaDokumenta[] | undefined;
    iznos: number;
}

export class F_AnalitikaTroskovaOdrzavanja implements IF_AnalitikaTroskovaOdrzavanja {
    opis?: string | undefined;
    tipDokumenta?: string | undefined;
    tipStavke?: string | undefined;
    broj?: string | undefined;
    datum!: Date;
    garazniBroj?: string | undefined;
    vozilo?: string | undefined;
    kilometraza?: number | undefined;
    dobavljac?: string | undefined;
    kolicina!: number;
    pdv!: number;
    odbitniPdv!: number;
    osnovica!: number;
    iznos!: number;
    iznosZaObracun!: number;
    vrstaOdrzavanja?: string | undefined;

    constructor(data?: IF_AnalitikaTroskovaOdrzavanja) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.opis = _data["opis"];
            this.tipDokumenta = _data["tipDokumenta"];
            this.tipStavke = _data["tipStavke"];
            this.broj = _data["broj"];
            this.datum = _data["datum"] ? new Date(_data["datum"].toString()) : <any>undefined;
            this.garazniBroj = _data["garazniBroj"];
            this.vozilo = _data["vozilo"];
            this.kilometraza = _data["kilometraza"];
            this.dobavljac = _data["dobavljac"];
            this.kolicina = _data["kolicina"];
            this.pdv = _data["pdv"];
            this.odbitniPdv = _data["odbitniPdv"];
            this.osnovica = _data["osnovica"];
            this.iznos = _data["iznos"];
            this.iznosZaObracun = _data["iznosZaObracun"];
            this.vrstaOdrzavanja = _data["vrstaOdrzavanja"];
        }
    }

    static fromJS(data: any): F_AnalitikaTroskovaOdrzavanja {
        data = typeof data === 'object' ? data : {};
        let result = new F_AnalitikaTroskovaOdrzavanja();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["opis"] = this.opis;
        data["tipDokumenta"] = this.tipDokumenta;
        data["tipStavke"] = this.tipStavke;
        data["broj"] = this.broj;
        data["datum"] = this.datum ? this.datum.toISOString() : <any>undefined;
        data["garazniBroj"] = this.garazniBroj;
        data["vozilo"] = this.vozilo;
        data["kilometraza"] = this.kilometraza;
        data["dobavljac"] = this.dobavljac;
        data["kolicina"] = this.kolicina;
        data["pdv"] = this.pdv;
        data["odbitniPdv"] = this.odbitniPdv;
        data["osnovica"] = this.osnovica;
        data["iznos"] = this.iznos;
        data["iznosZaObracun"] = this.iznosZaObracun;
        data["vrstaOdrzavanja"] = this.vrstaOdrzavanja;
        return data; 
    }
}

export interface IF_AnalitikaTroskovaOdrzavanja {
    opis?: string | undefined;
    tipDokumenta?: string | undefined;
    tipStavke?: string | undefined;
    broj?: string | undefined;
    datum: Date;
    garazniBroj?: string | undefined;
    vozilo?: string | undefined;
    kilometraza?: number | undefined;
    dobavljac?: string | undefined;
    kolicina: number;
    pdv: number;
    odbitniPdv: number;
    osnovica: number;
    iznos: number;
    iznosZaObracun: number;
    vrstaOdrzavanja?: string | undefined;
}

export class Povratnica extends Dokument implements IPovratnica {
    datum!: Date;
    skladisteId!: number;
    skladiste?: string | undefined;
    robuVratio?: string | undefined;
    robuVratioId!: number;
    dokumentKreiraoId!: number;
    dokumentKreirao?: string | undefined;
    stavke?: StavkaDokumenta[] | undefined;

    constructor(data?: IPovratnica) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.datum = _data["datum"] ? new Date(_data["datum"].toString()) : <any>undefined;
            this.skladisteId = _data["skladisteId"];
            this.skladiste = _data["skladiste"];
            this.robuVratio = _data["robuVratio"];
            this.robuVratioId = _data["robuVratioId"];
            this.dokumentKreiraoId = _data["dokumentKreiraoId"];
            this.dokumentKreirao = _data["dokumentKreirao"];
            if (Array.isArray(_data["stavke"])) {
                this.stavke = [] as any;
                for (let item of _data["stavke"])
                    this.stavke!.push(StavkaDokumenta.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Povratnica {
        data = typeof data === 'object' ? data : {};
        let result = new Povratnica();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["datum"] = this.datum ? this.datum.toISOString() : <any>undefined;
        data["skladisteId"] = this.skladisteId;
        data["skladiste"] = this.skladiste;
        data["robuVratio"] = this.robuVratio;
        data["robuVratioId"] = this.robuVratioId;
        data["dokumentKreiraoId"] = this.dokumentKreiraoId;
        data["dokumentKreirao"] = this.dokumentKreirao;
        if (Array.isArray(this.stavke)) {
            data["stavke"] = [];
            for (let item of this.stavke)
                data["stavke"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }
}

export interface IPovratnica extends IDokument {
    datum: Date;
    skladisteId: number;
    skladiste?: string | undefined;
    robuVratio?: string | undefined;
    robuVratioId: number;
    dokumentKreiraoId: number;
    dokumentKreirao?: string | undefined;
    stavke?: StavkaDokumenta[] | undefined;
}

export class PrijavaKvara implements IPrijavaKvara {
    id!: number;
    broj?: string | undefined;
    datum!: Date;
    kvarPrijavio?: string | undefined;
    kvarPrijavioId?: number | undefined;
    dokumentUneo?: string | undefined;
    dokumentUneoId!: number;
    vozilo?: string | undefined;
    voziloId!: number;
    status?: string | undefined;
    aktivan!: boolean;
    opis?: string | undefined;
    razlogOdbijanja?: string | undefined;
    dokumentObradio?: string | undefined;

    constructor(data?: IPrijavaKvara) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.broj = _data["broj"];
            this.datum = _data["datum"] ? new Date(_data["datum"].toString()) : <any>undefined;
            this.kvarPrijavio = _data["kvarPrijavio"];
            this.kvarPrijavioId = _data["kvarPrijavioId"];
            this.dokumentUneo = _data["dokumentUneo"];
            this.dokumentUneoId = _data["dokumentUneoId"];
            this.vozilo = _data["vozilo"];
            this.voziloId = _data["voziloId"];
            this.status = _data["status"];
            this.aktivan = _data["aktivan"];
            this.opis = _data["opis"];
            this.razlogOdbijanja = _data["razlogOdbijanja"];
            this.dokumentObradio = _data["dokumentObradio"];
        }
    }

    static fromJS(data: any): PrijavaKvara {
        data = typeof data === 'object' ? data : {};
        let result = new PrijavaKvara();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["broj"] = this.broj;
        data["datum"] = this.datum ? this.datum.toISOString() : <any>undefined;
        data["kvarPrijavio"] = this.kvarPrijavio;
        data["kvarPrijavioId"] = this.kvarPrijavioId;
        data["dokumentUneo"] = this.dokumentUneo;
        data["dokumentUneoId"] = this.dokumentUneoId;
        data["vozilo"] = this.vozilo;
        data["voziloId"] = this.voziloId;
        data["status"] = this.status;
        data["aktivan"] = this.aktivan;
        data["opis"] = this.opis;
        data["razlogOdbijanja"] = this.razlogOdbijanja;
        data["dokumentObradio"] = this.dokumentObradio;
        return data; 
    }
}

export interface IPrijavaKvara {
    id: number;
    broj?: string | undefined;
    datum: Date;
    kvarPrijavio?: string | undefined;
    kvarPrijavioId?: number | undefined;
    dokumentUneo?: string | undefined;
    dokumentUneoId: number;
    vozilo?: string | undefined;
    voziloId: number;
    status?: string | undefined;
    aktivan: boolean;
    opis?: string | undefined;
    razlogOdbijanja?: string | undefined;
    dokumentObradio?: string | undefined;
}

export class RazlogOdbijanjaPrijaveKvara implements IRazlogOdbijanjaPrijaveKvara {
    prijavaKvaraId!: number;
    razlog?: string | undefined;

    constructor(data?: IRazlogOdbijanjaPrijaveKvara) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prijavaKvaraId = _data["prijavaKvaraId"];
            this.razlog = _data["razlog"];
        }
    }

    static fromJS(data: any): RazlogOdbijanjaPrijaveKvara {
        data = typeof data === 'object' ? data : {};
        let result = new RazlogOdbijanjaPrijaveKvara();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prijavaKvaraId"] = this.prijavaKvaraId;
        data["razlog"] = this.razlog;
        return data; 
    }
}

export interface IRazlogOdbijanjaPrijaveKvara {
    prijavaKvaraId: number;
    razlog?: string | undefined;
}

export class Prijemnica extends Dokument implements IPrijemnica {
    referenca?: string | undefined;
    datum!: Date;
    skladiste?: string | undefined;
    skladisteId!: number;
    delovePrimio?: string | undefined;
    delovePrimioId!: number;
    dokumentKreirao?: string | undefined;
    dokumentKreiraoId!: number;
    dobavljac?: string | undefined;
    dobavljacId!: number;
    iznos!: number;
    stavke?: StavkaDokumenta[] | undefined;

    constructor(data?: IPrijemnica) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.referenca = _data["referenca"];
            this.datum = _data["datum"] ? new Date(_data["datum"].toString()) : <any>undefined;
            this.skladiste = _data["skladiste"];
            this.skladisteId = _data["skladisteId"];
            this.delovePrimio = _data["delovePrimio"];
            this.delovePrimioId = _data["delovePrimioId"];
            this.dokumentKreirao = _data["dokumentKreirao"];
            this.dokumentKreiraoId = _data["dokumentKreiraoId"];
            this.dobavljac = _data["dobavljac"];
            this.dobavljacId = _data["dobavljacId"];
            this.iznos = _data["iznos"];
            if (Array.isArray(_data["stavke"])) {
                this.stavke = [] as any;
                for (let item of _data["stavke"])
                    this.stavke!.push(StavkaDokumenta.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Prijemnica {
        data = typeof data === 'object' ? data : {};
        let result = new Prijemnica();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referenca"] = this.referenca;
        data["datum"] = this.datum ? this.datum.toISOString() : <any>undefined;
        data["skladiste"] = this.skladiste;
        data["skladisteId"] = this.skladisteId;
        data["delovePrimio"] = this.delovePrimio;
        data["delovePrimioId"] = this.delovePrimioId;
        data["dokumentKreirao"] = this.dokumentKreirao;
        data["dokumentKreiraoId"] = this.dokumentKreiraoId;
        data["dobavljac"] = this.dobavljac;
        data["dobavljacId"] = this.dobavljacId;
        data["iznos"] = this.iznos;
        if (Array.isArray(this.stavke)) {
            data["stavke"] = [];
            for (let item of this.stavke)
                data["stavke"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }
}

export interface IPrijemnica extends IDokument {
    referenca?: string | undefined;
    datum: Date;
    skladiste?: string | undefined;
    skladisteId: number;
    delovePrimio?: string | undefined;
    delovePrimioId: number;
    dokumentKreirao?: string | undefined;
    dokumentKreiraoId: number;
    dobavljac?: string | undefined;
    dobavljacId: number;
    iznos: number;
    stavke?: StavkaDokumenta[] | undefined;
}

export class RezervniDeo implements IRezervniDeo {
    id!: number;
    sifra?: string | undefined;
    oem?: string | undefined;
    naziv?: string | undefined;
    kataloskiBroj?: string | undefined;
    serijskiBroj?: string | undefined;
    stopaPdv!: number;
    grupaDelovaVozila?: string | undefined;
    grupaDelovaVozilaId?: number | undefined;
    vrstaOdrzavanja?: string | undefined;
    cena!: number;

    constructor(data?: IRezervniDeo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.oem = _data["oem"];
            this.naziv = _data["naziv"];
            this.kataloskiBroj = _data["kataloskiBroj"];
            this.serijskiBroj = _data["serijskiBroj"];
            this.stopaPdv = _data["stopaPdv"];
            this.grupaDelovaVozila = _data["grupaDelovaVozila"];
            this.grupaDelovaVozilaId = _data["grupaDelovaVozilaId"];
            this.vrstaOdrzavanja = _data["vrstaOdrzavanja"];
            this.cena = _data["cena"];
        }
    }

    static fromJS(data: any): RezervniDeo {
        data = typeof data === 'object' ? data : {};
        let result = new RezervniDeo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["oem"] = this.oem;
        data["naziv"] = this.naziv;
        data["kataloskiBroj"] = this.kataloskiBroj;
        data["serijskiBroj"] = this.serijskiBroj;
        data["stopaPdv"] = this.stopaPdv;
        data["grupaDelovaVozila"] = this.grupaDelovaVozila;
        data["grupaDelovaVozilaId"] = this.grupaDelovaVozilaId;
        data["vrstaOdrzavanja"] = this.vrstaOdrzavanja;
        data["cena"] = this.cena;
        return data; 
    }
}

export interface IRezervniDeo {
    id: number;
    sifra?: string | undefined;
    oem?: string | undefined;
    naziv?: string | undefined;
    kataloskiBroj?: string | undefined;
    serijskiBroj?: string | undefined;
    stopaPdv: number;
    grupaDelovaVozila?: string | undefined;
    grupaDelovaVozilaId?: number | undefined;
    vrstaOdrzavanja?: string | undefined;
    cena: number;
}

export class ZalihaRezervnogDela implements IZalihaRezervnogDela {
    rezervniDeoId!: number;
    kataloskiBroj?: string | undefined;
    naziv?: string | undefined;
    skladiste?: string | undefined;
    skladisteId!: number;
    nabavnaCena!: number;
    poslednjaNabavnaCena!: number;
    kolicina!: number;
    minimalnaZaliha!: number;
    maximalnaZaliha!: number;
    sifra?: string | undefined;
    oem?: string | undefined;
    cena!: number;
    serijskiBroj?: string | undefined;

    constructor(data?: IZalihaRezervnogDela) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rezervniDeoId = _data["rezervniDeoId"];
            this.kataloskiBroj = _data["kataloskiBroj"];
            this.naziv = _data["naziv"];
            this.skladiste = _data["skladiste"];
            this.skladisteId = _data["skladisteId"];
            this.nabavnaCena = _data["nabavnaCena"];
            this.poslednjaNabavnaCena = _data["poslednjaNabavnaCena"];
            this.kolicina = _data["kolicina"];
            this.minimalnaZaliha = _data["minimalnaZaliha"];
            this.maximalnaZaliha = _data["maximalnaZaliha"];
            this.sifra = _data["sifra"];
            this.oem = _data["oem"];
            this.cena = _data["cena"];
            this.serijskiBroj = _data["serijskiBroj"];
        }
    }

    static fromJS(data: any): ZalihaRezervnogDela {
        data = typeof data === 'object' ? data : {};
        let result = new ZalihaRezervnogDela();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rezervniDeoId"] = this.rezervniDeoId;
        data["kataloskiBroj"] = this.kataloskiBroj;
        data["naziv"] = this.naziv;
        data["skladiste"] = this.skladiste;
        data["skladisteId"] = this.skladisteId;
        data["nabavnaCena"] = this.nabavnaCena;
        data["poslednjaNabavnaCena"] = this.poslednjaNabavnaCena;
        data["kolicina"] = this.kolicina;
        data["minimalnaZaliha"] = this.minimalnaZaliha;
        data["maximalnaZaliha"] = this.maximalnaZaliha;
        data["sifra"] = this.sifra;
        data["oem"] = this.oem;
        data["cena"] = this.cena;
        data["serijskiBroj"] = this.serijskiBroj;
        return data; 
    }
}

export interface IZalihaRezervnogDela {
    rezervniDeoId: number;
    kataloskiBroj?: string | undefined;
    naziv?: string | undefined;
    skladiste?: string | undefined;
    skladisteId: number;
    nabavnaCena: number;
    poslednjaNabavnaCena: number;
    kolicina: number;
    minimalnaZaliha: number;
    maximalnaZaliha: number;
    sifra?: string | undefined;
    oem?: string | undefined;
    cena: number;
    serijskiBroj?: string | undefined;
}

export class ServisnaOperacija implements IServisnaOperacija {
    id!: number;
    naziv?: string | undefined;
    opis?: string | undefined;
    grupaDelovaVozila?: string | undefined;
    grupaDelovaVozilaId?: number | undefined;
    vrstaOdrzavanja?: string | undefined;
    vrstaOdrzavanjaId?: number | undefined;
    workUnits?: number | undefined;

    constructor(data?: IServisnaOperacija) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.opis = _data["opis"];
            this.grupaDelovaVozila = _data["grupaDelovaVozila"];
            this.grupaDelovaVozilaId = _data["grupaDelovaVozilaId"];
            this.vrstaOdrzavanja = _data["vrstaOdrzavanja"];
            this.vrstaOdrzavanjaId = _data["vrstaOdrzavanjaId"];
            this.workUnits = _data["workUnits"];
        }
    }

    static fromJS(data: any): ServisnaOperacija {
        data = typeof data === 'object' ? data : {};
        let result = new ServisnaOperacija();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["opis"] = this.opis;
        data["grupaDelovaVozila"] = this.grupaDelovaVozila;
        data["grupaDelovaVozilaId"] = this.grupaDelovaVozilaId;
        data["vrstaOdrzavanja"] = this.vrstaOdrzavanja;
        data["vrstaOdrzavanjaId"] = this.vrstaOdrzavanjaId;
        data["workUnits"] = this.workUnits;
        return data; 
    }
}

export interface IServisnaOperacija {
    id: number;
    naziv?: string | undefined;
    opis?: string | undefined;
    grupaDelovaVozila?: string | undefined;
    grupaDelovaVozilaId?: number | undefined;
    vrstaOdrzavanja?: string | undefined;
    vrstaOdrzavanjaId?: number | undefined;
    workUnits?: number | undefined;
}

export class Trebovanje implements ITrebovanje {
    id!: number;
    broj?: string | undefined;
    datum!: Date;
    radniNalogId?: number | undefined;
    radniNalog?: string | undefined;
    skladiste?: string | undefined;
    skladisteId?: number | undefined;
    dokumentKreiraoId?: number | undefined;
    dokumentKreirao?: string | undefined;
    stavke?: StavkaDokumenta[] | undefined;
    iznos!: number;

    constructor(data?: ITrebovanje) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.broj = _data["broj"];
            this.datum = _data["datum"] ? new Date(_data["datum"].toString()) : <any>undefined;
            this.radniNalogId = _data["radniNalogId"];
            this.radniNalog = _data["radniNalog"];
            this.skladiste = _data["skladiste"];
            this.skladisteId = _data["skladisteId"];
            this.dokumentKreiraoId = _data["dokumentKreiraoId"];
            this.dokumentKreirao = _data["dokumentKreirao"];
            if (Array.isArray(_data["stavke"])) {
                this.stavke = [] as any;
                for (let item of _data["stavke"])
                    this.stavke!.push(StavkaDokumenta.fromJS(item));
            }
            this.iznos = _data["iznos"];
        }
    }

    static fromJS(data: any): Trebovanje {
        data = typeof data === 'object' ? data : {};
        let result = new Trebovanje();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["broj"] = this.broj;
        data["datum"] = this.datum ? this.datum.toISOString() : <any>undefined;
        data["radniNalogId"] = this.radniNalogId;
        data["radniNalog"] = this.radniNalog;
        data["skladiste"] = this.skladiste;
        data["skladisteId"] = this.skladisteId;
        data["dokumentKreiraoId"] = this.dokumentKreiraoId;
        data["dokumentKreirao"] = this.dokumentKreirao;
        if (Array.isArray(this.stavke)) {
            data["stavke"] = [];
            for (let item of this.stavke)
                data["stavke"].push(item.toJSON());
        }
        data["iznos"] = this.iznos;
        return data; 
    }
}

export interface ITrebovanje {
    id: number;
    broj?: string | undefined;
    datum: Date;
    radniNalogId?: number | undefined;
    radniNalog?: string | undefined;
    skladiste?: string | undefined;
    skladisteId?: number | undefined;
    dokumentKreiraoId?: number | undefined;
    dokumentKreirao?: string | undefined;
    stavke?: StavkaDokumenta[] | undefined;
    iznos: number;
}

export class TrosakVozila implements ITrosakVozila {
    id!: number;
    naziv?: string | undefined;
    vrstaOdrzavanja?: string | undefined;
    vrstaOdrzavanjaId?: number | undefined;
    prikaziNaPutnomNalogu!: boolean;
    povratPdv!: boolean;
    trosakOdrzavanja!: boolean;
    ostaliTroskoviVozila!: boolean;
    trosakOsoblja!: boolean;
    dnevnica!: boolean;
    kazna!: boolean;
    putarina!: boolean;

    constructor(data?: ITrosakVozila) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.vrstaOdrzavanja = _data["vrstaOdrzavanja"];
            this.vrstaOdrzavanjaId = _data["vrstaOdrzavanjaId"];
            this.prikaziNaPutnomNalogu = _data["prikaziNaPutnomNalogu"];
            this.povratPdv = _data["povratPdv"];
            this.trosakOdrzavanja = _data["trosakOdrzavanja"];
            this.ostaliTroskoviVozila = _data["ostaliTroskoviVozila"];
            this.trosakOsoblja = _data["trosakOsoblja"];
            this.dnevnica = _data["dnevnica"];
            this.kazna = _data["kazna"];
            this.putarina = _data["putarina"];
        }
    }

    static fromJS(data: any): TrosakVozila {
        data = typeof data === 'object' ? data : {};
        let result = new TrosakVozila();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["vrstaOdrzavanja"] = this.vrstaOdrzavanja;
        data["vrstaOdrzavanjaId"] = this.vrstaOdrzavanjaId;
        data["prikaziNaPutnomNalogu"] = this.prikaziNaPutnomNalogu;
        data["povratPdv"] = this.povratPdv;
        data["trosakOdrzavanja"] = this.trosakOdrzavanja;
        data["ostaliTroskoviVozila"] = this.ostaliTroskoviVozila;
        data["trosakOsoblja"] = this.trosakOsoblja;
        data["dnevnica"] = this.dnevnica;
        data["kazna"] = this.kazna;
        data["putarina"] = this.putarina;
        return data; 
    }
}

export interface ITrosakVozila {
    id: number;
    naziv?: string | undefined;
    vrstaOdrzavanja?: string | undefined;
    vrstaOdrzavanjaId?: number | undefined;
    prikaziNaPutnomNalogu: boolean;
    povratPdv: boolean;
    trosakOdrzavanja: boolean;
    ostaliTroskoviVozila: boolean;
    trosakOsoblja: boolean;
    dnevnica: boolean;
    kazna: boolean;
    putarina: boolean;
}

export class VrstaOdrzavanja implements IVrstaOdrzavanja {
    id!: number;
    oznaka?: string | undefined;
    naziv?: string | undefined;
    preventivno!: boolean;
    redosledSortiranja!: number;
    steta!: boolean;

    constructor(data?: IVrstaOdrzavanja) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.oznaka = _data["oznaka"];
            this.naziv = _data["naziv"];
            this.preventivno = _data["preventivno"];
            this.redosledSortiranja = _data["redosledSortiranja"];
            this.steta = _data["steta"];
        }
    }

    static fromJS(data: any): VrstaOdrzavanja {
        data = typeof data === 'object' ? data : {};
        let result = new VrstaOdrzavanja();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["oznaka"] = this.oznaka;
        data["naziv"] = this.naziv;
        data["preventivno"] = this.preventivno;
        data["redosledSortiranja"] = this.redosledSortiranja;
        data["steta"] = this.steta;
        return data; 
    }
}

export interface IVrstaOdrzavanja {
    id: number;
    oznaka?: string | undefined;
    naziv?: string | undefined;
    preventivno: boolean;
    redosledSortiranja: number;
    steta: boolean;
}

export class OrganizacionaJedinica implements IOrganizacionaJedinica {
    id!: number;
    naziv?: string | undefined;
    mesto?: string | undefined;
    tip?: string | undefined;
    nadredjenaId?: number | undefined;

    constructor(data?: IOrganizacionaJedinica) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.mesto = _data["mesto"];
            this.tip = _data["tip"];
            this.nadredjenaId = _data["nadredjenaId"];
        }
    }

    static fromJS(data: any): OrganizacionaJedinica {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizacionaJedinica();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["mesto"] = this.mesto;
        data["tip"] = this.tip;
        data["nadredjenaId"] = this.nadredjenaId;
        return data; 
    }
}

export interface IOrganizacionaJedinica {
    id: number;
    naziv?: string | undefined;
    mesto?: string | undefined;
    tip?: string | undefined;
    nadredjenaId?: number | undefined;
}

export class Osoba implements IOsoba {
    id!: number;
    ime?: string | undefined;
    prezime?: string | undefined;
    slika?: string | undefined;
    adresa?: string | undefined;
    email?: string | undefined;
    telefon?: string | undefined;
    funkcija!: number;
    nazivFunkcije?: string | undefined;
    napomena?: string | undefined;
    brojVozackeDozvole?: string | undefined;
    datumIstekaVozackeDozvole?: Date | undefined;
    kategorijaVozackeDozvole?: string | undefined;
    datumRodjenja?: Date | undefined;
    mestoRodjenja?: string | undefined;
    datumZaposlenja?: Date | undefined;
    brojPasosa?: string | undefined;
    datumVazenjaPasosa?: Date | undefined;
    brojLicneKarte?: string | undefined;
    datumIstekaLicneKarte?: Date | undefined;
    jmbg?: string | undefined;
    radnoMestoId?: number | undefined;
    nazivRadnogMesta?: string | undefined;
    korisnickoIme?: string | undefined;
    lozinka?: string | undefined;
    aktivan!: boolean;
    aktivanNalog!: boolean;
    dozvoljenaVozilaId?: number | undefined;
    dozvoljenaVozila?: string | undefined;

    constructor(data?: IOsoba) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ime = _data["ime"];
            this.prezime = _data["prezime"];
            this.slika = _data["slika"];
            this.adresa = _data["adresa"];
            this.email = _data["email"];
            this.telefon = _data["telefon"];
            this.funkcija = _data["funkcija"];
            this.nazivFunkcije = _data["nazivFunkcije"];
            this.napomena = _data["napomena"];
            this.brojVozackeDozvole = _data["brojVozackeDozvole"];
            this.datumIstekaVozackeDozvole = _data["datumIstekaVozackeDozvole"] ? new Date(_data["datumIstekaVozackeDozvole"].toString()) : <any>undefined;
            this.kategorijaVozackeDozvole = _data["kategorijaVozackeDozvole"];
            this.datumRodjenja = _data["datumRodjenja"] ? new Date(_data["datumRodjenja"].toString()) : <any>undefined;
            this.mestoRodjenja = _data["mestoRodjenja"];
            this.datumZaposlenja = _data["datumZaposlenja"] ? new Date(_data["datumZaposlenja"].toString()) : <any>undefined;
            this.brojPasosa = _data["brojPasosa"];
            this.datumVazenjaPasosa = _data["datumVazenjaPasosa"] ? new Date(_data["datumVazenjaPasosa"].toString()) : <any>undefined;
            this.brojLicneKarte = _data["brojLicneKarte"];
            this.datumIstekaLicneKarte = _data["datumIstekaLicneKarte"] ? new Date(_data["datumIstekaLicneKarte"].toString()) : <any>undefined;
            this.jmbg = _data["jmbg"];
            this.radnoMestoId = _data["radnoMestoId"];
            this.nazivRadnogMesta = _data["nazivRadnogMesta"];
            this.korisnickoIme = _data["korisnickoIme"];
            this.lozinka = _data["lozinka"];
            this.aktivan = _data["aktivan"];
            this.aktivanNalog = _data["aktivanNalog"];
            this.dozvoljenaVozilaId = _data["dozvoljenaVozilaId"];
            this.dozvoljenaVozila = _data["dozvoljenaVozila"];
        }
    }

    static fromJS(data: any): Osoba {
        data = typeof data === 'object' ? data : {};
        let result = new Osoba();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ime"] = this.ime;
        data["prezime"] = this.prezime;
        data["slika"] = this.slika;
        data["adresa"] = this.adresa;
        data["email"] = this.email;
        data["telefon"] = this.telefon;
        data["funkcija"] = this.funkcija;
        data["nazivFunkcije"] = this.nazivFunkcije;
        data["napomena"] = this.napomena;
        data["brojVozackeDozvole"] = this.brojVozackeDozvole;
        data["datumIstekaVozackeDozvole"] = this.datumIstekaVozackeDozvole ? this.datumIstekaVozackeDozvole.toISOString() : <any>undefined;
        data["kategorijaVozackeDozvole"] = this.kategorijaVozackeDozvole;
        data["datumRodjenja"] = this.datumRodjenja ? this.datumRodjenja.toISOString() : <any>undefined;
        data["mestoRodjenja"] = this.mestoRodjenja;
        data["datumZaposlenja"] = this.datumZaposlenja ? this.datumZaposlenja.toISOString() : <any>undefined;
        data["brojPasosa"] = this.brojPasosa;
        data["datumVazenjaPasosa"] = this.datumVazenjaPasosa ? this.datumVazenjaPasosa.toISOString() : <any>undefined;
        data["brojLicneKarte"] = this.brojLicneKarte;
        data["datumIstekaLicneKarte"] = this.datumIstekaLicneKarte ? this.datumIstekaLicneKarte.toISOString() : <any>undefined;
        data["jmbg"] = this.jmbg;
        data["radnoMestoId"] = this.radnoMestoId;
        data["nazivRadnogMesta"] = this.nazivRadnogMesta;
        data["korisnickoIme"] = this.korisnickoIme;
        data["lozinka"] = this.lozinka;
        data["aktivan"] = this.aktivan;
        data["aktivanNalog"] = this.aktivanNalog;
        data["dozvoljenaVozilaId"] = this.dozvoljenaVozilaId;
        data["dozvoljenaVozila"] = this.dozvoljenaVozila;
        return data; 
    }
}

export interface IOsoba {
    id: number;
    ime?: string | undefined;
    prezime?: string | undefined;
    slika?: string | undefined;
    adresa?: string | undefined;
    email?: string | undefined;
    telefon?: string | undefined;
    funkcija: number;
    nazivFunkcije?: string | undefined;
    napomena?: string | undefined;
    brojVozackeDozvole?: string | undefined;
    datumIstekaVozackeDozvole?: Date | undefined;
    kategorijaVozackeDozvole?: string | undefined;
    datumRodjenja?: Date | undefined;
    mestoRodjenja?: string | undefined;
    datumZaposlenja?: Date | undefined;
    brojPasosa?: string | undefined;
    datumVazenjaPasosa?: Date | undefined;
    brojLicneKarte?: string | undefined;
    datumIstekaLicneKarte?: Date | undefined;
    jmbg?: string | undefined;
    radnoMestoId?: number | undefined;
    nazivRadnogMesta?: string | undefined;
    korisnickoIme?: string | undefined;
    lozinka?: string | undefined;
    aktivan: boolean;
    aktivanNalog: boolean;
    dozvoljenaVozilaId?: number | undefined;
    dozvoljenaVozila?: string | undefined;
}

export class NovaLozinka implements INovaLozinka {
    lozinka?: string | undefined;

    constructor(data?: INovaLozinka) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lozinka = _data["lozinka"];
        }
    }

    static fromJS(data: any): NovaLozinka {
        data = typeof data === 'object' ? data : {};
        let result = new NovaLozinka();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lozinka"] = this.lozinka;
        return data; 
    }
}

export interface INovaLozinka {
    lozinka?: string | undefined;
}

export class RadnoMesto implements IRadnoMesto {
    id!: number;
    naziv?: string | undefined;

    constructor(data?: IRadnoMesto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
        }
    }

    static fromJS(data: any): RadnoMesto {
        data = typeof data === 'object' ? data : {};
        let result = new RadnoMesto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        return data; 
    }
}

export interface IRadnoMesto {
    id: number;
    naziv?: string | undefined;
}

export class B2BPodatakOsobe implements IB2BPodatakOsobe {
    osobaId!: number;
    b2BProvajderId!: number;
    b2BProvajder?: string | undefined;
    tipProvajdera?: string | undefined;
    vrednost?: string | undefined;

    constructor(data?: IB2BPodatakOsobe) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.osobaId = _data["osobaId"];
            this.b2BProvajderId = _data["b2BProvajderId"];
            this.b2BProvajder = _data["b2BProvajder"];
            this.tipProvajdera = _data["tipProvajdera"];
            this.vrednost = _data["vrednost"];
        }
    }

    static fromJS(data: any): B2BPodatakOsobe {
        data = typeof data === 'object' ? data : {};
        let result = new B2BPodatakOsobe();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["osobaId"] = this.osobaId;
        data["b2BProvajderId"] = this.b2BProvajderId;
        data["b2BProvajder"] = this.b2BProvajder;
        data["tipProvajdera"] = this.tipProvajdera;
        data["vrednost"] = this.vrednost;
        return data; 
    }
}

export interface IB2BPodatakOsobe {
    osobaId: number;
    b2BProvajderId: number;
    b2BProvajder?: string | undefined;
    tipProvajdera?: string | undefined;
    vrednost?: string | undefined;
}

export class PoslovniPartner implements IPoslovniPartner {
    id!: number;
    naziv?: string | undefined;
    telefon?: string | undefined;
    webAdresa?: string | undefined;
    email?: string | undefined;
    adresa?: string | undefined;
    mesto?: string | undefined;
    pib?: string | undefined;
    tekuciRacun?: string | undefined;
    napomena?: string | undefined;
    kupac!: boolean;
    dobavljac!: boolean;
    delatnost!: number;
    nazivDelatnosti?: string | undefined;

    constructor(data?: IPoslovniPartner) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.telefon = _data["telefon"];
            this.webAdresa = _data["webAdresa"];
            this.email = _data["email"];
            this.adresa = _data["adresa"];
            this.mesto = _data["mesto"];
            this.pib = _data["pib"];
            this.tekuciRacun = _data["tekuciRacun"];
            this.napomena = _data["napomena"];
            this.kupac = _data["kupac"];
            this.dobavljac = _data["dobavljac"];
            this.delatnost = _data["delatnost"];
            this.nazivDelatnosti = _data["nazivDelatnosti"];
        }
    }

    static fromJS(data: any): PoslovniPartner {
        data = typeof data === 'object' ? data : {};
        let result = new PoslovniPartner();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["telefon"] = this.telefon;
        data["webAdresa"] = this.webAdresa;
        data["email"] = this.email;
        data["adresa"] = this.adresa;
        data["mesto"] = this.mesto;
        data["pib"] = this.pib;
        data["tekuciRacun"] = this.tekuciRacun;
        data["napomena"] = this.napomena;
        data["kupac"] = this.kupac;
        data["dobavljac"] = this.dobavljac;
        data["delatnost"] = this.delatnost;
        data["nazivDelatnosti"] = this.nazivDelatnosti;
        return data; 
    }
}

export interface IPoslovniPartner {
    id: number;
    naziv?: string | undefined;
    telefon?: string | undefined;
    webAdresa?: string | undefined;
    email?: string | undefined;
    adresa?: string | undefined;
    mesto?: string | undefined;
    pib?: string | undefined;
    tekuciRacun?: string | undefined;
    napomena?: string | undefined;
    kupac: boolean;
    dobavljac: boolean;
    delatnost: number;
    nazivDelatnosti?: string | undefined;
}

export class DelatnostiPoslovnihPartnera implements IDelatnostiPoslovnihPartnera {
    id!: number;
    naziv?: string | undefined;

    constructor(data?: IDelatnostiPoslovnihPartnera) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
        }
    }

    static fromJS(data: any): DelatnostiPoslovnihPartnera {
        data = typeof data === 'object' ? data : {};
        let result = new DelatnostiPoslovnihPartnera();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        return data; 
    }
}

export interface IDelatnostiPoslovnihPartnera {
    id: number;
    naziv?: string | undefined;
}

export class PutniNalog implements IPutniNalog {
    id!: number;
    datum!: Date;
    broj?: string | undefined;
    zadatak?: string | undefined;
    vozilo?: string | undefined;
    voziloId!: number;
    vozac?: string | undefined;
    vozacId!: number;
    clanPosade?: string | undefined;
    clanPosadeId?: number | undefined;
    relacija?: string | undefined;
    status!: StatusPutnogNaloga;
    kretanja?: KretanjeVozila[] | undefined;
    troskovi?: TrosakPuta[] | undefined;
    polaznaKilometraza!: number;
    krajnjaKilometraza!: number;
    ukupnoVreme!: number;
    predjenoKilometara!: number;
    nazivFirme?: string | undefined;
    adresaFirme?: string | undefined;
    snagaMotora!: number;
    brojSedista!: number;
    garazniBroj?: string | undefined;

    constructor(data?: IPutniNalog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.datum = _data["datum"] ? new Date(_data["datum"].toString()) : <any>undefined;
            this.broj = _data["broj"];
            this.zadatak = _data["zadatak"];
            this.vozilo = _data["vozilo"];
            this.voziloId = _data["voziloId"];
            this.vozac = _data["vozac"];
            this.vozacId = _data["vozacId"];
            this.clanPosade = _data["clanPosade"];
            this.clanPosadeId = _data["clanPosadeId"];
            this.relacija = _data["relacija"];
            this.status = _data["status"];
            if (Array.isArray(_data["kretanja"])) {
                this.kretanja = [] as any;
                for (let item of _data["kretanja"])
                    this.kretanja!.push(KretanjeVozila.fromJS(item));
            }
            if (Array.isArray(_data["troskovi"])) {
                this.troskovi = [] as any;
                for (let item of _data["troskovi"])
                    this.troskovi!.push(TrosakPuta.fromJS(item));
            }
            this.polaznaKilometraza = _data["polaznaKilometraza"];
            this.krajnjaKilometraza = _data["krajnjaKilometraza"];
            this.ukupnoVreme = _data["ukupnoVreme"];
            this.predjenoKilometara = _data["predjenoKilometara"];
            this.nazivFirme = _data["nazivFirme"];
            this.adresaFirme = _data["adresaFirme"];
            this.snagaMotora = _data["snagaMotora"];
            this.brojSedista = _data["brojSedista"];
            this.garazniBroj = _data["garazniBroj"];
        }
    }

    static fromJS(data: any): PutniNalog {
        data = typeof data === 'object' ? data : {};
        let result = new PutniNalog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["datum"] = this.datum ? this.datum.toISOString() : <any>undefined;
        data["broj"] = this.broj;
        data["zadatak"] = this.zadatak;
        data["vozilo"] = this.vozilo;
        data["voziloId"] = this.voziloId;
        data["vozac"] = this.vozac;
        data["vozacId"] = this.vozacId;
        data["clanPosade"] = this.clanPosade;
        data["clanPosadeId"] = this.clanPosadeId;
        data["relacija"] = this.relacija;
        data["status"] = this.status;
        if (Array.isArray(this.kretanja)) {
            data["kretanja"] = [];
            for (let item of this.kretanja)
                data["kretanja"].push(item.toJSON());
        }
        if (Array.isArray(this.troskovi)) {
            data["troskovi"] = [];
            for (let item of this.troskovi)
                data["troskovi"].push(item.toJSON());
        }
        data["polaznaKilometraza"] = this.polaznaKilometraza;
        data["krajnjaKilometraza"] = this.krajnjaKilometraza;
        data["ukupnoVreme"] = this.ukupnoVreme;
        data["predjenoKilometara"] = this.predjenoKilometara;
        data["nazivFirme"] = this.nazivFirme;
        data["adresaFirme"] = this.adresaFirme;
        data["snagaMotora"] = this.snagaMotora;
        data["brojSedista"] = this.brojSedista;
        data["garazniBroj"] = this.garazniBroj;
        return data; 
    }
}

export interface IPutniNalog {
    id: number;
    datum: Date;
    broj?: string | undefined;
    zadatak?: string | undefined;
    vozilo?: string | undefined;
    voziloId: number;
    vozac?: string | undefined;
    vozacId: number;
    clanPosade?: string | undefined;
    clanPosadeId?: number | undefined;
    relacija?: string | undefined;
    status: StatusPutnogNaloga;
    kretanja?: KretanjeVozila[] | undefined;
    troskovi?: TrosakPuta[] | undefined;
    polaznaKilometraza: number;
    krajnjaKilometraza: number;
    ukupnoVreme: number;
    predjenoKilometara: number;
    nazivFirme?: string | undefined;
    adresaFirme?: string | undefined;
    snagaMotora: number;
    brojSedista: number;
    garazniBroj?: string | undefined;
}

export enum StatusPutnogNaloga {
    Otvoren = 1,
    Zakljucen = 2,
}

export class KretanjeVozila implements IKretanjeVozila {
    id!: number;
    datumPolaska!: Date;
    vremePolaska!: string;
    mestoPolaska?: string | undefined;
    datumDolaska!: Date;
    vremeDolaska!: string;
    mestoDolaska?: string | undefined;
    vozilo?: number | undefined;
    vozac?: number | undefined;
    kilometrazaPolaska!: number;
    kilometrazaDolaska!: number;

    constructor(data?: IKretanjeVozila) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.datumPolaska = _data["datumPolaska"] ? new Date(_data["datumPolaska"].toString()) : <any>undefined;
            this.vremePolaska = _data["vremePolaska"];
            this.mestoPolaska = _data["mestoPolaska"];
            this.datumDolaska = _data["datumDolaska"] ? new Date(_data["datumDolaska"].toString()) : <any>undefined;
            this.vremeDolaska = _data["vremeDolaska"];
            this.mestoDolaska = _data["mestoDolaska"];
            this.vozilo = _data["vozilo"];
            this.vozac = _data["vozac"];
            this.kilometrazaPolaska = _data["kilometrazaPolaska"];
            this.kilometrazaDolaska = _data["kilometrazaDolaska"];
        }
    }

    static fromJS(data: any): KretanjeVozila {
        data = typeof data === 'object' ? data : {};
        let result = new KretanjeVozila();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["datumPolaska"] = this.datumPolaska ? this.datumPolaska.toISOString() : <any>undefined;
        data["vremePolaska"] = this.vremePolaska;
        data["mestoPolaska"] = this.mestoPolaska;
        data["datumDolaska"] = this.datumDolaska ? this.datumDolaska.toISOString() : <any>undefined;
        data["vremeDolaska"] = this.vremeDolaska;
        data["mestoDolaska"] = this.mestoDolaska;
        data["vozilo"] = this.vozilo;
        data["vozac"] = this.vozac;
        data["kilometrazaPolaska"] = this.kilometrazaPolaska;
        data["kilometrazaDolaska"] = this.kilometrazaDolaska;
        return data; 
    }
}

export interface IKretanjeVozila {
    id: number;
    datumPolaska: Date;
    vremePolaska: string;
    mestoPolaska?: string | undefined;
    datumDolaska: Date;
    vremeDolaska: string;
    mestoDolaska?: string | undefined;
    vozilo?: number | undefined;
    vozac?: number | undefined;
    kilometrazaPolaska: number;
    kilometrazaDolaska: number;
}

export class TrosakPuta implements ITrosakPuta {
    id!: number;
    datum!: Date;
    dobavljac?: string | undefined;
    dobavljacId?: number | undefined;
    naziv?: string | undefined;
    iznos!: number;
    trosakVozilaId!: number;
    opis?: string | undefined;

    constructor(data?: ITrosakPuta) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.datum = _data["datum"] ? new Date(_data["datum"].toString()) : <any>undefined;
            this.dobavljac = _data["dobavljac"];
            this.dobavljacId = _data["dobavljacId"];
            this.naziv = _data["naziv"];
            this.iznos = _data["iznos"];
            this.trosakVozilaId = _data["trosakVozilaId"];
            this.opis = _data["opis"];
        }
    }

    static fromJS(data: any): TrosakPuta {
        data = typeof data === 'object' ? data : {};
        let result = new TrosakPuta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["datum"] = this.datum ? this.datum.toISOString() : <any>undefined;
        data["dobavljac"] = this.dobavljac;
        data["dobavljacId"] = this.dobavljacId;
        data["naziv"] = this.naziv;
        data["iznos"] = this.iznos;
        data["trosakVozilaId"] = this.trosakVozilaId;
        data["opis"] = this.opis;
        return data; 
    }
}

export interface ITrosakPuta {
    id: number;
    datum: Date;
    dobavljac?: string | undefined;
    dobavljacId?: number | undefined;
    naziv?: string | undefined;
    iznos: number;
    trosakVozilaId: number;
    opis?: string | undefined;
}

export class NalogZaSluzbenoPutovanje implements INalogZaSluzbenoPutovanje {
    id!: number;
    nazivFirme?: string | undefined;
    sedisteFirme?: string | undefined;
    datum!: Date;
    zadatak?: string | undefined;
    mestoIzdavanja?: string | undefined;
    broj?: string | undefined;
    vozilo?: string | undefined;
    vozac?: string | undefined;
    adresaPrebivalista?: string | undefined;
    radnoMesto?: string | undefined;
    zanimanje?: string | undefined;
    relacija?: string | undefined;
    vrstaPrevoza?: string | undefined;
    datumPolaska!: Date;
    datumZavrsetka!: Date;
    provedenoVreme!: number;
    brojDnevnica!: number;
    iznosDnevnica!: number;
    ukupno!: number;
    predjenoKilometara!: number;
    troskoviPuta?: TrosakPuta[] | undefined;

    constructor(data?: INalogZaSluzbenoPutovanje) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nazivFirme = _data["nazivFirme"];
            this.sedisteFirme = _data["sedisteFirme"];
            this.datum = _data["datum"] ? new Date(_data["datum"].toString()) : <any>undefined;
            this.zadatak = _data["zadatak"];
            this.mestoIzdavanja = _data["mestoIzdavanja"];
            this.broj = _data["broj"];
            this.vozilo = _data["vozilo"];
            this.vozac = _data["vozac"];
            this.adresaPrebivalista = _data["adresaPrebivalista"];
            this.radnoMesto = _data["radnoMesto"];
            this.zanimanje = _data["zanimanje"];
            this.relacija = _data["relacija"];
            this.vrstaPrevoza = _data["vrstaPrevoza"];
            this.datumPolaska = _data["datumPolaska"] ? new Date(_data["datumPolaska"].toString()) : <any>undefined;
            this.datumZavrsetka = _data["datumZavrsetka"] ? new Date(_data["datumZavrsetka"].toString()) : <any>undefined;
            this.provedenoVreme = _data["provedenoVreme"];
            this.brojDnevnica = _data["brojDnevnica"];
            this.iznosDnevnica = _data["iznosDnevnica"];
            this.ukupno = _data["ukupno"];
            this.predjenoKilometara = _data["predjenoKilometara"];
            if (Array.isArray(_data["troskoviPuta"])) {
                this.troskoviPuta = [] as any;
                for (let item of _data["troskoviPuta"])
                    this.troskoviPuta!.push(TrosakPuta.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NalogZaSluzbenoPutovanje {
        data = typeof data === 'object' ? data : {};
        let result = new NalogZaSluzbenoPutovanje();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nazivFirme"] = this.nazivFirme;
        data["sedisteFirme"] = this.sedisteFirme;
        data["datum"] = this.datum ? this.datum.toISOString() : <any>undefined;
        data["zadatak"] = this.zadatak;
        data["mestoIzdavanja"] = this.mestoIzdavanja;
        data["broj"] = this.broj;
        data["vozilo"] = this.vozilo;
        data["vozac"] = this.vozac;
        data["adresaPrebivalista"] = this.adresaPrebivalista;
        data["radnoMesto"] = this.radnoMesto;
        data["zanimanje"] = this.zanimanje;
        data["relacija"] = this.relacija;
        data["vrstaPrevoza"] = this.vrstaPrevoza;
        data["datumPolaska"] = this.datumPolaska ? this.datumPolaska.toISOString() : <any>undefined;
        data["datumZavrsetka"] = this.datumZavrsetka ? this.datumZavrsetka.toISOString() : <any>undefined;
        data["provedenoVreme"] = this.provedenoVreme;
        data["brojDnevnica"] = this.brojDnevnica;
        data["iznosDnevnica"] = this.iznosDnevnica;
        data["ukupno"] = this.ukupno;
        data["predjenoKilometara"] = this.predjenoKilometara;
        if (Array.isArray(this.troskoviPuta)) {
            data["troskoviPuta"] = [];
            for (let item of this.troskoviPuta)
                data["troskoviPuta"].push(item.toJSON());
        }
        return data; 
    }
}

export interface INalogZaSluzbenoPutovanje {
    id: number;
    nazivFirme?: string | undefined;
    sedisteFirme?: string | undefined;
    datum: Date;
    zadatak?: string | undefined;
    mestoIzdavanja?: string | undefined;
    broj?: string | undefined;
    vozilo?: string | undefined;
    vozac?: string | undefined;
    adresaPrebivalista?: string | undefined;
    radnoMesto?: string | undefined;
    zanimanje?: string | undefined;
    relacija?: string | undefined;
    vrstaPrevoza?: string | undefined;
    datumPolaska: Date;
    datumZavrsetka: Date;
    provedenoVreme: number;
    brojDnevnica: number;
    iznosDnevnica: number;
    ukupno: number;
    predjenoKilometara: number;
    troskoviPuta?: TrosakPuta[] | undefined;
}

export class Aktivnost implements IAktivnost {
    id!: number;
    naziv?: string | undefined;

    constructor(data?: IAktivnost) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
        }
    }

    static fromJS(data: any): Aktivnost {
        data = typeof data === 'object' ? data : {};
        let result = new Aktivnost();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        return data; 
    }
}

export interface IAktivnost {
    id: number;
    naziv?: string | undefined;
}

export class Datoteka implements IDatoteka {
    datum!: Date;
    naziv?: string | undefined;

    constructor(data?: IDatoteka) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.datum = _data["datum"] ? new Date(_data["datum"].toString()) : <any>undefined;
            this.naziv = _data["naziv"];
        }
    }

    static fromJS(data: any): Datoteka {
        data = typeof data === 'object' ? data : {};
        let result = new Datoteka();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["datum"] = this.datum ? this.datum.toISOString() : <any>undefined;
        data["naziv"] = this.naziv;
        return data; 
    }
}

export interface IDatoteka {
    datum: Date;
    naziv?: string | undefined;
}

export class DnevnoRadnoVreme implements IDnevnoRadnoVreme {
    osobaId!: number;
    imeIPrezime?: string | undefined;
    datum!: Date;
    pocetakRV?: Date | undefined;
    krajRV?: Date | undefined;
    trajanjeRV!: number;
    trajanjeRV2?: number | undefined;
    trajanjeRVFormatted?: string | undefined;
    trajanjeRV2Formatted?: string | undefined;
    vremeVoznje!: number;
    vremeVoznjeFormatted?: string | undefined;
    ostaloRV!: number;
    ostaloRVFormatted?: string | undefined;
    raspolozivoVreme!: number;
    raspolozivoVremeFormatted?: string | undefined;
    odmorURV!: number;
    odmorURVFormatted?: string | undefined;
    danUNedelji?: string | undefined;
    nocnoRadnoVreme!: number;
    nocnoRadnoVremeFormatted?: string | undefined;
    brojNedelje!: number;
    placenoOsustvo!: number;
    placenoOsustvoFormatted?: string | undefined;
    trajanjeRadnogDana!: number;
    trajanjeRadnogDanaFormatted?: string | undefined;

    constructor(data?: IDnevnoRadnoVreme) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.osobaId = _data["osobaId"];
            this.imeIPrezime = _data["imeIPrezime"];
            this.datum = _data["datum"] ? new Date(_data["datum"].toString()) : <any>undefined;
            this.pocetakRV = _data["pocetakRV"] ? new Date(_data["pocetakRV"].toString()) : <any>undefined;
            this.krajRV = _data["krajRV"] ? new Date(_data["krajRV"].toString()) : <any>undefined;
            this.trajanjeRV = _data["trajanjeRV"];
            this.trajanjeRV2 = _data["trajanjeRV2"];
            this.trajanjeRVFormatted = _data["trajanjeRVFormatted"];
            this.trajanjeRV2Formatted = _data["trajanjeRV2Formatted"];
            this.vremeVoznje = _data["vremeVoznje"];
            this.vremeVoznjeFormatted = _data["vremeVoznjeFormatted"];
            this.ostaloRV = _data["ostaloRV"];
            this.ostaloRVFormatted = _data["ostaloRVFormatted"];
            this.raspolozivoVreme = _data["raspolozivoVreme"];
            this.raspolozivoVremeFormatted = _data["raspolozivoVremeFormatted"];
            this.odmorURV = _data["odmorURV"];
            this.odmorURVFormatted = _data["odmorURVFormatted"];
            this.danUNedelji = _data["danUNedelji"];
            this.nocnoRadnoVreme = _data["nocnoRadnoVreme"];
            this.nocnoRadnoVremeFormatted = _data["nocnoRadnoVremeFormatted"];
            this.brojNedelje = _data["brojNedelje"];
            this.placenoOsustvo = _data["placenoOsustvo"];
            this.placenoOsustvoFormatted = _data["placenoOsustvoFormatted"];
            this.trajanjeRadnogDana = _data["trajanjeRadnogDana"];
            this.trajanjeRadnogDanaFormatted = _data["trajanjeRadnogDanaFormatted"];
        }
    }

    static fromJS(data: any): DnevnoRadnoVreme {
        data = typeof data === 'object' ? data : {};
        let result = new DnevnoRadnoVreme();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["osobaId"] = this.osobaId;
        data["imeIPrezime"] = this.imeIPrezime;
        data["datum"] = this.datum ? this.datum.toISOString() : <any>undefined;
        data["pocetakRV"] = this.pocetakRV ? this.pocetakRV.toISOString() : <any>undefined;
        data["krajRV"] = this.krajRV ? this.krajRV.toISOString() : <any>undefined;
        data["trajanjeRV"] = this.trajanjeRV;
        data["trajanjeRV2"] = this.trajanjeRV2;
        data["trajanjeRVFormatted"] = this.trajanjeRVFormatted;
        data["trajanjeRV2Formatted"] = this.trajanjeRV2Formatted;
        data["vremeVoznje"] = this.vremeVoznje;
        data["vremeVoznjeFormatted"] = this.vremeVoznjeFormatted;
        data["ostaloRV"] = this.ostaloRV;
        data["ostaloRVFormatted"] = this.ostaloRVFormatted;
        data["raspolozivoVreme"] = this.raspolozivoVreme;
        data["raspolozivoVremeFormatted"] = this.raspolozivoVremeFormatted;
        data["odmorURV"] = this.odmorURV;
        data["odmorURVFormatted"] = this.odmorURVFormatted;
        data["danUNedelji"] = this.danUNedelji;
        data["nocnoRadnoVreme"] = this.nocnoRadnoVreme;
        data["nocnoRadnoVremeFormatted"] = this.nocnoRadnoVremeFormatted;
        data["brojNedelje"] = this.brojNedelje;
        data["placenoOsustvo"] = this.placenoOsustvo;
        data["placenoOsustvoFormatted"] = this.placenoOsustvoFormatted;
        data["trajanjeRadnogDana"] = this.trajanjeRadnogDana;
        data["trajanjeRadnogDanaFormatted"] = this.trajanjeRadnogDanaFormatted;
        return data; 
    }
}

export interface IDnevnoRadnoVreme {
    osobaId: number;
    imeIPrezime?: string | undefined;
    datum: Date;
    pocetakRV?: Date | undefined;
    krajRV?: Date | undefined;
    trajanjeRV: number;
    trajanjeRV2?: number | undefined;
    trajanjeRVFormatted?: string | undefined;
    trajanjeRV2Formatted?: string | undefined;
    vremeVoznje: number;
    vremeVoznjeFormatted?: string | undefined;
    ostaloRV: number;
    ostaloRVFormatted?: string | undefined;
    raspolozivoVreme: number;
    raspolozivoVremeFormatted?: string | undefined;
    odmorURV: number;
    odmorURVFormatted?: string | undefined;
    danUNedelji?: string | undefined;
    nocnoRadnoVreme: number;
    nocnoRadnoVremeFormatted?: string | undefined;
    brojNedelje: number;
    placenoOsustvo: number;
    placenoOsustvoFormatted?: string | undefined;
    trajanjeRadnogDana: number;
    trajanjeRadnogDanaFormatted?: string | undefined;
}

export class Period implements IPeriod {
    id!: number;
    naziv?: string | undefined;
    pocetak!: Date;
    kraj!: Date;
    poslednjiMesec?: string | undefined;

    constructor(data?: IPeriod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.pocetak = _data["pocetak"] ? new Date(_data["pocetak"].toString()) : <any>undefined;
            this.kraj = _data["kraj"] ? new Date(_data["kraj"].toString()) : <any>undefined;
            this.poslednjiMesec = _data["poslednjiMesec"];
        }
    }

    static fromJS(data: any): Period {
        data = typeof data === 'object' ? data : {};
        let result = new Period();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["pocetak"] = this.pocetak ? this.pocetak.toISOString() : <any>undefined;
        data["kraj"] = this.kraj ? this.kraj.toISOString() : <any>undefined;
        data["poslednjiMesec"] = this.poslednjiMesec;
        return data; 
    }
}

export interface IPeriod {
    id: number;
    naziv?: string | undefined;
    pocetak: Date;
    kraj: Date;
    poslednjiMesec?: string | undefined;
}

export class MesecnoRadnoVreme implements IMesecnoRadnoVreme {
    osoba?: string | undefined;
    period?: string | undefined;
    mesec?: string | undefined;
    prosecnoVreme!: number;
    ukunoVremeRada?: string | undefined;
    prosecnoVremeSaProduzenjem?: string | undefined;
    nedelja1?: Nedelja | undefined;
    nedelja2?: Nedelja | undefined;
    nedelja3?: Nedelja | undefined;
    nedelja4?: Nedelja | undefined;
    nedelja5?: Nedelja | undefined;

    constructor(data?: IMesecnoRadnoVreme) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.osoba = _data["osoba"];
            this.period = _data["period"];
            this.mesec = _data["mesec"];
            this.prosecnoVreme = _data["prosecnoVreme"];
            this.ukunoVremeRada = _data["ukunoVremeRada"];
            this.prosecnoVremeSaProduzenjem = _data["prosecnoVremeSaProduzenjem"];
            this.nedelja1 = _data["nedelja1"] ? Nedelja.fromJS(_data["nedelja1"]) : <any>undefined;
            this.nedelja2 = _data["nedelja2"] ? Nedelja.fromJS(_data["nedelja2"]) : <any>undefined;
            this.nedelja3 = _data["nedelja3"] ? Nedelja.fromJS(_data["nedelja3"]) : <any>undefined;
            this.nedelja4 = _data["nedelja4"] ? Nedelja.fromJS(_data["nedelja4"]) : <any>undefined;
            this.nedelja5 = _data["nedelja5"] ? Nedelja.fromJS(_data["nedelja5"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MesecnoRadnoVreme {
        data = typeof data === 'object' ? data : {};
        let result = new MesecnoRadnoVreme();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["osoba"] = this.osoba;
        data["period"] = this.period;
        data["mesec"] = this.mesec;
        data["prosecnoVreme"] = this.prosecnoVreme;
        data["ukunoVremeRada"] = this.ukunoVremeRada;
        data["prosecnoVremeSaProduzenjem"] = this.prosecnoVremeSaProduzenjem;
        data["nedelja1"] = this.nedelja1 ? this.nedelja1.toJSON() : <any>undefined;
        data["nedelja2"] = this.nedelja2 ? this.nedelja2.toJSON() : <any>undefined;
        data["nedelja3"] = this.nedelja3 ? this.nedelja3.toJSON() : <any>undefined;
        data["nedelja4"] = this.nedelja4 ? this.nedelja4.toJSON() : <any>undefined;
        data["nedelja5"] = this.nedelja5 ? this.nedelja5.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IMesecnoRadnoVreme {
    osoba?: string | undefined;
    period?: string | undefined;
    mesec?: string | undefined;
    prosecnoVreme: number;
    ukunoVremeRada?: string | undefined;
    prosecnoVremeSaProduzenjem?: string | undefined;
    nedelja1?: Nedelja | undefined;
    nedelja2?: Nedelja | undefined;
    nedelja3?: Nedelja | undefined;
    nedelja4?: Nedelja | undefined;
    nedelja5?: Nedelja | undefined;
}

export class Nedelja implements INedelja {
    datumPocetka!: Date;
    vremeRada?: string | undefined;

    constructor(data?: INedelja) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.datumPocetka = _data["datumPocetka"] ? new Date(_data["datumPocetka"].toString()) : <any>undefined;
            this.vremeRada = _data["vremeRada"];
        }
    }

    static fromJS(data: any): Nedelja {
        data = typeof data === 'object' ? data : {};
        let result = new Nedelja();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["datumPocetka"] = this.datumPocetka ? this.datumPocetka.toISOString() : <any>undefined;
        data["vremeRada"] = this.vremeRada;
        return data; 
    }
}

export interface INedelja {
    datumPocetka: Date;
    vremeRada?: string | undefined;
}

export class PreostaloRadnoVreme implements IPreostaloRadnoVreme {
    osoba?: string | undefined;
    radnoVremeNedelja?: string | undefined;
    preostaloVremeDanas?: string | undefined;
    preostaloVremeSutra?: string | undefined;
    preostaloVremeNedelja?: string | undefined;
    preostaloVremePeriod?: string | undefined;
    prosecnoVremeUPeriodu?: string | undefined;
    radnoVremeDanas?: string | undefined;

    constructor(data?: IPreostaloRadnoVreme) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.osoba = _data["osoba"];
            this.radnoVremeNedelja = _data["radnoVremeNedelja"];
            this.preostaloVremeDanas = _data["preostaloVremeDanas"];
            this.preostaloVremeSutra = _data["preostaloVremeSutra"];
            this.preostaloVremeNedelja = _data["preostaloVremeNedelja"];
            this.preostaloVremePeriod = _data["preostaloVremePeriod"];
            this.prosecnoVremeUPeriodu = _data["prosecnoVremeUPeriodu"];
            this.radnoVremeDanas = _data["radnoVremeDanas"];
        }
    }

    static fromJS(data: any): PreostaloRadnoVreme {
        data = typeof data === 'object' ? data : {};
        let result = new PreostaloRadnoVreme();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["osoba"] = this.osoba;
        data["radnoVremeNedelja"] = this.radnoVremeNedelja;
        data["preostaloVremeDanas"] = this.preostaloVremeDanas;
        data["preostaloVremeSutra"] = this.preostaloVremeSutra;
        data["preostaloVremeNedelja"] = this.preostaloVremeNedelja;
        data["preostaloVremePeriod"] = this.preostaloVremePeriod;
        data["prosecnoVremeUPeriodu"] = this.prosecnoVremeUPeriodu;
        data["radnoVremeDanas"] = this.radnoVremeDanas;
        return data; 
    }
}

export interface IPreostaloRadnoVreme {
    osoba?: string | undefined;
    radnoVremeNedelja?: string | undefined;
    preostaloVremeDanas?: string | undefined;
    preostaloVremeSutra?: string | undefined;
    preostaloVremeNedelja?: string | undefined;
    preostaloVremePeriod?: string | undefined;
    prosecnoVremeUPeriodu?: string | undefined;
    radnoVremeDanas?: string | undefined;
}

export class EvidencijaAktivnostiVozaca implements IEvidencijaAktivnostiVozaca {
    id!: number;
    aktivnostId!: number;
    nazivAktivnosti?: string | undefined;
    vozacId?: number | undefined;
    vozac?: string | undefined;
    voziloId?: number | undefined;
    vozilo?: string | undefined;
    pocetak!: Date;
    kraj!: Date;
    pocetnaLokacija?: string | undefined;
    krajnjaLokacija?: string | undefined;
    izvor?: string | undefined;
    kilometrazaPolaska!: number;
    kilometrazaDolaska!: number;
    predjenoKilometara!: number;

    constructor(data?: IEvidencijaAktivnostiVozaca) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.aktivnostId = _data["aktivnostId"];
            this.nazivAktivnosti = _data["nazivAktivnosti"];
            this.vozacId = _data["vozacId"];
            this.vozac = _data["vozac"];
            this.voziloId = _data["voziloId"];
            this.vozilo = _data["vozilo"];
            this.pocetak = _data["pocetak"] ? new Date(_data["pocetak"].toString()) : <any>undefined;
            this.kraj = _data["kraj"] ? new Date(_data["kraj"].toString()) : <any>undefined;
            this.pocetnaLokacija = _data["pocetnaLokacija"];
            this.krajnjaLokacija = _data["krajnjaLokacija"];
            this.izvor = _data["izvor"];
            this.kilometrazaPolaska = _data["kilometrazaPolaska"];
            this.kilometrazaDolaska = _data["kilometrazaDolaska"];
            this.predjenoKilometara = _data["predjenoKilometara"];
        }
    }

    static fromJS(data: any): EvidencijaAktivnostiVozaca {
        data = typeof data === 'object' ? data : {};
        let result = new EvidencijaAktivnostiVozaca();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["aktivnostId"] = this.aktivnostId;
        data["nazivAktivnosti"] = this.nazivAktivnosti;
        data["vozacId"] = this.vozacId;
        data["vozac"] = this.vozac;
        data["voziloId"] = this.voziloId;
        data["vozilo"] = this.vozilo;
        data["pocetak"] = this.pocetak ? this.pocetak.toISOString() : <any>undefined;
        data["kraj"] = this.kraj ? this.kraj.toISOString() : <any>undefined;
        data["pocetnaLokacija"] = this.pocetnaLokacija;
        data["krajnjaLokacija"] = this.krajnjaLokacija;
        data["izvor"] = this.izvor;
        data["kilometrazaPolaska"] = this.kilometrazaPolaska;
        data["kilometrazaDolaska"] = this.kilometrazaDolaska;
        data["predjenoKilometara"] = this.predjenoKilometara;
        return data; 
    }
}

export interface IEvidencijaAktivnostiVozaca {
    id: number;
    aktivnostId: number;
    nazivAktivnosti?: string | undefined;
    vozacId?: number | undefined;
    vozac?: string | undefined;
    voziloId?: number | undefined;
    vozilo?: string | undefined;
    pocetak: Date;
    kraj: Date;
    pocetnaLokacija?: string | undefined;
    krajnjaLokacija?: string | undefined;
    izvor?: string | undefined;
    kilometrazaPolaska: number;
    kilometrazaDolaska: number;
    predjenoKilometara: number;
}

export class NaloziZaSluzbenaPutovanja implements INaloziZaSluzbenaPutovanja {
    iznosDnevnice!: number;
    dodatnoVreme!: number;
    vremena?: DnevnoAktivnoVreme[] | undefined;

    constructor(data?: INaloziZaSluzbenaPutovanja) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.iznosDnevnice = _data["iznosDnevnice"];
            this.dodatnoVreme = _data["dodatnoVreme"];
            if (Array.isArray(_data["vremena"])) {
                this.vremena = [] as any;
                for (let item of _data["vremena"])
                    this.vremena!.push(DnevnoAktivnoVreme.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NaloziZaSluzbenaPutovanja {
        data = typeof data === 'object' ? data : {};
        let result = new NaloziZaSluzbenaPutovanja();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["iznosDnevnice"] = this.iznosDnevnice;
        data["dodatnoVreme"] = this.dodatnoVreme;
        if (Array.isArray(this.vremena)) {
            data["vremena"] = [];
            for (let item of this.vremena)
                data["vremena"].push(item.toJSON());
        }
        return data; 
    }
}

export interface INaloziZaSluzbenaPutovanja {
    iznosDnevnice: number;
    dodatnoVreme: number;
    vremena?: DnevnoAktivnoVreme[] | undefined;
}

export class DnevnoAktivnoVreme implements IDnevnoAktivnoVreme {
    broj?: string | undefined;
    vozacId!: number;
    vozac?: string | undefined;
    pocetakRadnogDana!: Date;
    krajRadnoDana?: Date | undefined;
    trajanjeRadnogDana!: number;
    povezanaVremena?: DnevnoAktivnoVreme[] | undefined;
    troskoviSluzbenogPuta?: TrosakSluzbenogPuta | undefined;
    relacija?: string | undefined;

    constructor(data?: IDnevnoAktivnoVreme) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.broj = _data["broj"];
            this.vozacId = _data["vozacId"];
            this.vozac = _data["vozac"];
            this.pocetakRadnogDana = _data["pocetakRadnogDana"] ? new Date(_data["pocetakRadnogDana"].toString()) : <any>undefined;
            this.krajRadnoDana = _data["krajRadnoDana"] ? new Date(_data["krajRadnoDana"].toString()) : <any>undefined;
            this.trajanjeRadnogDana = _data["trajanjeRadnogDana"];
            if (Array.isArray(_data["povezanaVremena"])) {
                this.povezanaVremena = [] as any;
                for (let item of _data["povezanaVremena"])
                    this.povezanaVremena!.push(DnevnoAktivnoVreme.fromJS(item));
            }
            this.troskoviSluzbenogPuta = _data["troskoviSluzbenogPuta"] ? TrosakSluzbenogPuta.fromJS(_data["troskoviSluzbenogPuta"]) : <any>undefined;
            this.relacija = _data["relacija"];
        }
    }

    static fromJS(data: any): DnevnoAktivnoVreme {
        data = typeof data === 'object' ? data : {};
        let result = new DnevnoAktivnoVreme();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["broj"] = this.broj;
        data["vozacId"] = this.vozacId;
        data["vozac"] = this.vozac;
        data["pocetakRadnogDana"] = this.pocetakRadnogDana ? this.pocetakRadnogDana.toISOString() : <any>undefined;
        data["krajRadnoDana"] = this.krajRadnoDana ? this.krajRadnoDana.toISOString() : <any>undefined;
        data["trajanjeRadnogDana"] = this.trajanjeRadnogDana;
        if (Array.isArray(this.povezanaVremena)) {
            data["povezanaVremena"] = [];
            for (let item of this.povezanaVremena)
                data["povezanaVremena"].push(item.toJSON());
        }
        data["troskoviSluzbenogPuta"] = this.troskoviSluzbenogPuta ? this.troskoviSluzbenogPuta.toJSON() : <any>undefined;
        data["relacija"] = this.relacija;
        return data; 
    }
}

export interface IDnevnoAktivnoVreme {
    broj?: string | undefined;
    vozacId: number;
    vozac?: string | undefined;
    pocetakRadnogDana: Date;
    krajRadnoDana?: Date | undefined;
    trajanjeRadnogDana: number;
    povezanaVremena?: DnevnoAktivnoVreme[] | undefined;
    troskoviSluzbenogPuta?: TrosakSluzbenogPuta | undefined;
    relacija?: string | undefined;
}

export class TrosakSluzbenogPuta implements ITrosakSluzbenogPuta {
    opis?: string | undefined;
    iznos!: number;

    constructor(data?: ITrosakSluzbenogPuta) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.opis = _data["opis"];
            this.iznos = _data["iznos"];
        }
    }

    static fromJS(data: any): TrosakSluzbenogPuta {
        data = typeof data === 'object' ? data : {};
        let result = new TrosakSluzbenogPuta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["opis"] = this.opis;
        data["iznos"] = this.iznos;
        return data; 
    }
}

export interface ITrosakSluzbenogPuta {
    opis?: string | undefined;
    iznos: number;
}

export class Odsustvo implements IOdsustvo {
    id!: number;
    vrstaOdsustva?: string | undefined;
    vrstaOdsustvaId!: number;
    osoba?: string | undefined;
    osobaId!: number;
    datumOd!: Date;
    datumDo!: Date;

    constructor(data?: IOdsustvo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.vrstaOdsustva = _data["vrstaOdsustva"];
            this.vrstaOdsustvaId = _data["vrstaOdsustvaId"];
            this.osoba = _data["osoba"];
            this.osobaId = _data["osobaId"];
            this.datumOd = _data["datumOd"] ? new Date(_data["datumOd"].toString()) : <any>undefined;
            this.datumDo = _data["datumDo"] ? new Date(_data["datumDo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Odsustvo {
        data = typeof data === 'object' ? data : {};
        let result = new Odsustvo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["vrstaOdsustva"] = this.vrstaOdsustva;
        data["vrstaOdsustvaId"] = this.vrstaOdsustvaId;
        data["osoba"] = this.osoba;
        data["osobaId"] = this.osobaId;
        data["datumOd"] = this.datumOd ? this.datumOd.toISOString() : <any>undefined;
        data["datumDo"] = this.datumDo ? this.datumDo.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IOdsustvo {
    id: number;
    vrstaOdsustva?: string | undefined;
    vrstaOdsustvaId: number;
    osoba?: string | undefined;
    osobaId: number;
    datumOd: Date;
    datumDo: Date;
}

export class VrstaOdsustva implements IVrstaOdsustva {
    id!: number;
    naziv?: string | undefined;
    godisnjiOdmor!: boolean;
    bolovanje!: boolean;
    placenoOdsustvo!: boolean;

    constructor(data?: IVrstaOdsustva) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.godisnjiOdmor = _data["godisnjiOdmor"];
            this.bolovanje = _data["bolovanje"];
            this.placenoOdsustvo = _data["placenoOdsustvo"];
        }
    }

    static fromJS(data: any): VrstaOdsustva {
        data = typeof data === 'object' ? data : {};
        let result = new VrstaOdsustva();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["godisnjiOdmor"] = this.godisnjiOdmor;
        data["bolovanje"] = this.bolovanje;
        data["placenoOdsustvo"] = this.placenoOdsustvo;
        return data; 
    }
}

export interface IVrstaOdsustva {
    id: number;
    naziv?: string | undefined;
    godisnjiOdmor: boolean;
    bolovanje: boolean;
    placenoOdsustvo: boolean;
}

export class StavkaIzvestajaSipanjaIPotrosnjeGoriva implements IStavkaIzvestajaSipanjaIPotrosnjeGoriva {
    id!: number;
    datum!: Date;
    voziloId!: number;
    vozilo?: string | undefined;
    gorivo?: string | undefined;
    stanjeKilometrazePriSipanju!: number;
    predjenoKilometaraNakonPrethodnogSipanja!: number;
    sipanaKolicina!: number;
    vrednostSipanogGoriva!: number;
    prosecnaPotrosnjaGoriva!: number;
    normiranaPotrosnja!: number;
    prekoracenjeNorme!: number;
    prekoracenjeULitrama!: number;
    prekoracenjeUVrednosti!: number;

    constructor(data?: IStavkaIzvestajaSipanjaIPotrosnjeGoriva) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.datum = _data["datum"] ? new Date(_data["datum"].toString()) : <any>undefined;
            this.voziloId = _data["voziloId"];
            this.vozilo = _data["vozilo"];
            this.gorivo = _data["gorivo"];
            this.stanjeKilometrazePriSipanju = _data["stanjeKilometrazePriSipanju"];
            this.predjenoKilometaraNakonPrethodnogSipanja = _data["predjenoKilometaraNakonPrethodnogSipanja"];
            this.sipanaKolicina = _data["sipanaKolicina"];
            this.vrednostSipanogGoriva = _data["vrednostSipanogGoriva"];
            this.prosecnaPotrosnjaGoriva = _data["prosecnaPotrosnjaGoriva"];
            this.normiranaPotrosnja = _data["normiranaPotrosnja"];
            this.prekoracenjeNorme = _data["prekoracenjeNorme"];
            this.prekoracenjeULitrama = _data["prekoracenjeULitrama"];
            this.prekoracenjeUVrednosti = _data["prekoracenjeUVrednosti"];
        }
    }

    static fromJS(data: any): StavkaIzvestajaSipanjaIPotrosnjeGoriva {
        data = typeof data === 'object' ? data : {};
        let result = new StavkaIzvestajaSipanjaIPotrosnjeGoriva();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["datum"] = this.datum ? this.datum.toISOString() : <any>undefined;
        data["voziloId"] = this.voziloId;
        data["vozilo"] = this.vozilo;
        data["gorivo"] = this.gorivo;
        data["stanjeKilometrazePriSipanju"] = this.stanjeKilometrazePriSipanju;
        data["predjenoKilometaraNakonPrethodnogSipanja"] = this.predjenoKilometaraNakonPrethodnogSipanja;
        data["sipanaKolicina"] = this.sipanaKolicina;
        data["vrednostSipanogGoriva"] = this.vrednostSipanogGoriva;
        data["prosecnaPotrosnjaGoriva"] = this.prosecnaPotrosnjaGoriva;
        data["normiranaPotrosnja"] = this.normiranaPotrosnja;
        data["prekoracenjeNorme"] = this.prekoracenjeNorme;
        data["prekoracenjeULitrama"] = this.prekoracenjeULitrama;
        data["prekoracenjeUVrednosti"] = this.prekoracenjeUVrednosti;
        return data; 
    }
}

export interface IStavkaIzvestajaSipanjaIPotrosnjeGoriva {
    id: number;
    datum: Date;
    voziloId: number;
    vozilo?: string | undefined;
    gorivo?: string | undefined;
    stanjeKilometrazePriSipanju: number;
    predjenoKilometaraNakonPrethodnogSipanja: number;
    sipanaKolicina: number;
    vrednostSipanogGoriva: number;
    prosecnaPotrosnjaGoriva: number;
    normiranaPotrosnja: number;
    prekoracenjeNorme: number;
    prekoracenjeULitrama: number;
    prekoracenjeUVrednosti: number;
}

export class StetniDogadjaj implements IStetniDogadjaj {
    id!: number;
    broj?: string | undefined;
    vozilo?: string | undefined;
    voziloId!: number;
    vozac?: string | undefined;
    vozacId!: number;
    datum!: Date;
    mesto?: string | undefined;
    brojZapisnikaUvidjaja?: string | undefined;
    krivicaVozaca!: boolean;
    brojZapisnikaOsiguranja?: string | undefined;
    brojSteteSaZapisnika?: string | undefined;
    kaskoId?: number | undefined;
    brojPoliseOdOdgovornosti?: string | undefined;
    osiguranjePriznalo!: number;
    procenatUcescaUSteti!: number;
    ukupno!: number;
    isplacenIznos!: number;
    iznosUcesca!: number;
    naplacenoOdVozaca!: number;
    datumZakljucenja?: Date | undefined;
    zakljucen!: boolean;
    pdv!: number;
    osnovica!: number;

    constructor(data?: IStetniDogadjaj) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.broj = _data["broj"];
            this.vozilo = _data["vozilo"];
            this.voziloId = _data["voziloId"];
            this.vozac = _data["vozac"];
            this.vozacId = _data["vozacId"];
            this.datum = _data["datum"] ? new Date(_data["datum"].toString()) : <any>undefined;
            this.mesto = _data["mesto"];
            this.brojZapisnikaUvidjaja = _data["brojZapisnikaUvidjaja"];
            this.krivicaVozaca = _data["krivicaVozaca"];
            this.brojZapisnikaOsiguranja = _data["brojZapisnikaOsiguranja"];
            this.brojSteteSaZapisnika = _data["brojSteteSaZapisnika"];
            this.kaskoId = _data["kaskoId"];
            this.brojPoliseOdOdgovornosti = _data["brojPoliseOdOdgovornosti"];
            this.osiguranjePriznalo = _data["osiguranjePriznalo"];
            this.procenatUcescaUSteti = _data["procenatUcescaUSteti"];
            this.ukupno = _data["ukupno"];
            this.isplacenIznos = _data["isplacenIznos"];
            this.iznosUcesca = _data["iznosUcesca"];
            this.naplacenoOdVozaca = _data["naplacenoOdVozaca"];
            this.datumZakljucenja = _data["datumZakljucenja"] ? new Date(_data["datumZakljucenja"].toString()) : <any>undefined;
            this.zakljucen = _data["zakljucen"];
            this.pdv = _data["pdv"];
            this.osnovica = _data["osnovica"];
        }
    }

    static fromJS(data: any): StetniDogadjaj {
        data = typeof data === 'object' ? data : {};
        let result = new StetniDogadjaj();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["broj"] = this.broj;
        data["vozilo"] = this.vozilo;
        data["voziloId"] = this.voziloId;
        data["vozac"] = this.vozac;
        data["vozacId"] = this.vozacId;
        data["datum"] = this.datum ? this.datum.toISOString() : <any>undefined;
        data["mesto"] = this.mesto;
        data["brojZapisnikaUvidjaja"] = this.brojZapisnikaUvidjaja;
        data["krivicaVozaca"] = this.krivicaVozaca;
        data["brojZapisnikaOsiguranja"] = this.brojZapisnikaOsiguranja;
        data["brojSteteSaZapisnika"] = this.brojSteteSaZapisnika;
        data["kaskoId"] = this.kaskoId;
        data["brojPoliseOdOdgovornosti"] = this.brojPoliseOdOdgovornosti;
        data["osiguranjePriznalo"] = this.osiguranjePriznalo;
        data["procenatUcescaUSteti"] = this.procenatUcescaUSteti;
        data["ukupno"] = this.ukupno;
        data["isplacenIznos"] = this.isplacenIznos;
        data["iznosUcesca"] = this.iznosUcesca;
        data["naplacenoOdVozaca"] = this.naplacenoOdVozaca;
        data["datumZakljucenja"] = this.datumZakljucenja ? this.datumZakljucenja.toISOString() : <any>undefined;
        data["zakljucen"] = this.zakljucen;
        data["pdv"] = this.pdv;
        data["osnovica"] = this.osnovica;
        return data; 
    }
}

export interface IStetniDogadjaj {
    id: number;
    broj?: string | undefined;
    vozilo?: string | undefined;
    voziloId: number;
    vozac?: string | undefined;
    vozacId: number;
    datum: Date;
    mesto?: string | undefined;
    brojZapisnikaUvidjaja?: string | undefined;
    krivicaVozaca: boolean;
    brojZapisnikaOsiguranja?: string | undefined;
    brojSteteSaZapisnika?: string | undefined;
    kaskoId?: number | undefined;
    brojPoliseOdOdgovornosti?: string | undefined;
    osiguranjePriznalo: number;
    procenatUcescaUSteti: number;
    ukupno: number;
    isplacenIznos: number;
    iznosUcesca: number;
    naplacenoOdVozaca: number;
    datumZakljucenja?: Date | undefined;
    zakljucen: boolean;
    pdv: number;
    osnovica: number;
}

export class GrupaVozila implements IGrupaVozila {
    id!: number;
    naziv?: string | undefined;
    podgrupeVozila?: PodgrupaVozila[] | undefined;

    constructor(data?: IGrupaVozila) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            if (Array.isArray(_data["podgrupeVozila"])) {
                this.podgrupeVozila = [] as any;
                for (let item of _data["podgrupeVozila"])
                    this.podgrupeVozila!.push(PodgrupaVozila.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GrupaVozila {
        data = typeof data === 'object' ? data : {};
        let result = new GrupaVozila();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        if (Array.isArray(this.podgrupeVozila)) {
            data["podgrupeVozila"] = [];
            for (let item of this.podgrupeVozila)
                data["podgrupeVozila"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGrupaVozila {
    id: number;
    naziv?: string | undefined;
    podgrupeVozila?: PodgrupaVozila[] | undefined;
}

export class PodgrupaVozila implements IPodgrupaVozila {
    id!: number;
    idGrupe!: number;
    naziv?: string | undefined;

    constructor(data?: IPodgrupaVozila) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.idGrupe = _data["idGrupe"];
            this.naziv = _data["naziv"];
        }
    }

    static fromJS(data: any): PodgrupaVozila {
        data = typeof data === 'object' ? data : {};
        let result = new PodgrupaVozila();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["idGrupe"] = this.idGrupe;
        data["naziv"] = this.naziv;
        return data; 
    }
}

export interface IPodgrupaVozila {
    id: number;
    idGrupe: number;
    naziv?: string | undefined;
}

export class MarkaVozila implements IMarkaVozila {
    id!: number;
    naziv?: string | undefined;
    modeliVozila?: ModelVozila[] | undefined;

    constructor(data?: IMarkaVozila) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            if (Array.isArray(_data["modeliVozila"])) {
                this.modeliVozila = [] as any;
                for (let item of _data["modeliVozila"])
                    this.modeliVozila!.push(ModelVozila.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MarkaVozila {
        data = typeof data === 'object' ? data : {};
        let result = new MarkaVozila();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        if (Array.isArray(this.modeliVozila)) {
            data["modeliVozila"] = [];
            for (let item of this.modeliVozila)
                data["modeliVozila"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IMarkaVozila {
    id: number;
    naziv?: string | undefined;
    modeliVozila?: ModelVozila[] | undefined;
}

export class ModelVozila implements IModelVozila {
    id!: number;
    naziv?: string | undefined;
    markaVozilaId!: number;

    constructor(data?: IModelVozila) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.markaVozilaId = _data["markaVozilaId"];
        }
    }

    static fromJS(data: any): ModelVozila {
        data = typeof data === 'object' ? data : {};
        let result = new ModelVozila();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["markaVozilaId"] = this.markaVozilaId;
        return data; 
    }
}

export interface IModelVozila {
    id: number;
    naziv?: string | undefined;
    markaVozilaId: number;
}

export class Oprema extends Entity implements IOprema {
    naziv?: string | undefined;
    proizvodjac?: string | undefined;
    serijskiBroj?: string | undefined;
    slika?: string | undefined;
    istekGarancije?: Date | undefined;
    opis?: string | undefined;

    constructor(data?: IOprema) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.naziv = _data["naziv"];
            this.proizvodjac = _data["proizvodjac"];
            this.serijskiBroj = _data["serijskiBroj"];
            this.slika = _data["slika"];
            this.istekGarancije = _data["istekGarancije"] ? new Date(_data["istekGarancije"].toString()) : <any>undefined;
            this.opis = _data["opis"];
        }
    }

    static fromJS(data: any): Oprema {
        data = typeof data === 'object' ? data : {};
        let result = new Oprema();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["naziv"] = this.naziv;
        data["proizvodjac"] = this.proizvodjac;
        data["serijskiBroj"] = this.serijskiBroj;
        data["slika"] = this.slika;
        data["istekGarancije"] = this.istekGarancije ? this.istekGarancije.toISOString() : <any>undefined;
        data["opis"] = this.opis;
        super.toJSON(data);
        return data; 
    }
}

export interface IOprema extends IEntity {
    naziv?: string | undefined;
    proizvodjac?: string | undefined;
    serijskiBroj?: string | undefined;
    slika?: string | undefined;
    istekGarancije?: Date | undefined;
    opis?: string | undefined;
}

export class StatusVozila implements IStatusVozila {
    id!: number;
    naziv?: string | undefined;
    podrazumevan!: boolean;
    aktivan!: boolean;
    inventarskiVozniPark!: boolean;

    constructor(data?: IStatusVozila) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.podrazumevan = _data["podrazumevan"];
            this.aktivan = _data["aktivan"];
            this.inventarskiVozniPark = _data["inventarskiVozniPark"];
        }
    }

    static fromJS(data: any): StatusVozila {
        data = typeof data === 'object' ? data : {};
        let result = new StatusVozila();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["podrazumevan"] = this.podrazumevan;
        data["aktivan"] = this.aktivan;
        data["inventarskiVozniPark"] = this.inventarskiVozniPark;
        return data; 
    }
}

export interface IStatusVozila {
    id: number;
    naziv?: string | undefined;
    podrazumevan: boolean;
    aktivan: boolean;
    inventarskiVozniPark: boolean;
}

export class Vozilo implements IVozilo {
    id!: number;
    registarskaOznaka?: string | undefined;
    garazniBroj?: string | undefined;
    godinaProizvodnje!: number;
    brojSasije?: string | undefined;
    brojMotora?: string | undefined;
    slika?: string | undefined;
    boja?: string | undefined;
    zapreminaMotora?: number | undefined;
    snagaMotora?: number | undefined;
    nosivost?: number | undefined;
    masaVozila?: number | undefined;
    ukupnaMasa?: number | undefined;
    datumPrveRegistracije?: Date | undefined;
    posedujeTahograf!: boolean;
    markaVozila?: string | undefined;
    markaVozilaId?: number | undefined;
    modelVozila?: string | undefined;
    modelVozilaId?: number | undefined;
    tipVozila?: string | undefined;
    tipVozilaId?: number | undefined;
    statusVozila?: string | undefined;
    statusVozilaId?: number | undefined;
    pripadnostId?: number | undefined;
    pripadnost?: string | undefined;
    grupaVozila?: string | undefined;
    grupaVozilaId?: number | undefined;
    podgrupaVozila?: string | undefined;
    podgrupaVozilaId?: number | undefined;
    tipMotoraVozilaId?: number | undefined;
    tipMotoraVozila?: string | undefined;
    kategorijaVozila?: string | undefined;
    kategorijaVozilaId?: number | undefined;
    aktivno!: boolean;
    brojSedista!: number;
    brojOsovina!: number;
    brojMestaZaStajanje!: number;
    primarnoGorivo?: string | undefined;
    normiranaPotrosnja?: number | undefined;

    constructor(data?: IVozilo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.registarskaOznaka = _data["registarskaOznaka"];
            this.garazniBroj = _data["garazniBroj"];
            this.godinaProizvodnje = _data["godinaProizvodnje"];
            this.brojSasije = _data["brojSasije"];
            this.brojMotora = _data["brojMotora"];
            this.slika = _data["slika"];
            this.boja = _data["boja"];
            this.zapreminaMotora = _data["zapreminaMotora"];
            this.snagaMotora = _data["snagaMotora"];
            this.nosivost = _data["nosivost"];
            this.masaVozila = _data["masaVozila"];
            this.ukupnaMasa = _data["ukupnaMasa"];
            this.datumPrveRegistracije = _data["datumPrveRegistracije"] ? new Date(_data["datumPrveRegistracije"].toString()) : <any>undefined;
            this.posedujeTahograf = _data["posedujeTahograf"];
            this.markaVozila = _data["markaVozila"];
            this.markaVozilaId = _data["markaVozilaId"];
            this.modelVozila = _data["modelVozila"];
            this.modelVozilaId = _data["modelVozilaId"];
            this.tipVozila = _data["tipVozila"];
            this.tipVozilaId = _data["tipVozilaId"];
            this.statusVozila = _data["statusVozila"];
            this.statusVozilaId = _data["statusVozilaId"];
            this.pripadnostId = _data["pripadnostId"];
            this.pripadnost = _data["pripadnost"];
            this.grupaVozila = _data["grupaVozila"];
            this.grupaVozilaId = _data["grupaVozilaId"];
            this.podgrupaVozila = _data["podgrupaVozila"];
            this.podgrupaVozilaId = _data["podgrupaVozilaId"];
            this.tipMotoraVozilaId = _data["tipMotoraVozilaId"];
            this.tipMotoraVozila = _data["tipMotoraVozila"];
            this.kategorijaVozila = _data["kategorijaVozila"];
            this.kategorijaVozilaId = _data["kategorijaVozilaId"];
            this.aktivno = _data["aktivno"];
            this.brojSedista = _data["brojSedista"];
            this.brojOsovina = _data["brojOsovina"];
            this.brojMestaZaStajanje = _data["brojMestaZaStajanje"];
            this.primarnoGorivo = _data["primarnoGorivo"];
            this.normiranaPotrosnja = _data["normiranaPotrosnja"];
        }
    }

    static fromJS(data: any): Vozilo {
        data = typeof data === 'object' ? data : {};
        let result = new Vozilo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["registarskaOznaka"] = this.registarskaOznaka;
        data["garazniBroj"] = this.garazniBroj;
        data["godinaProizvodnje"] = this.godinaProizvodnje;
        data["brojSasije"] = this.brojSasije;
        data["brojMotora"] = this.brojMotora;
        data["slika"] = this.slika;
        data["boja"] = this.boja;
        data["zapreminaMotora"] = this.zapreminaMotora;
        data["snagaMotora"] = this.snagaMotora;
        data["nosivost"] = this.nosivost;
        data["masaVozila"] = this.masaVozila;
        data["ukupnaMasa"] = this.ukupnaMasa;
        data["datumPrveRegistracije"] = this.datumPrveRegistracije ? this.datumPrveRegistracije.toISOString() : <any>undefined;
        data["posedujeTahograf"] = this.posedujeTahograf;
        data["markaVozila"] = this.markaVozila;
        data["markaVozilaId"] = this.markaVozilaId;
        data["modelVozila"] = this.modelVozila;
        data["modelVozilaId"] = this.modelVozilaId;
        data["tipVozila"] = this.tipVozila;
        data["tipVozilaId"] = this.tipVozilaId;
        data["statusVozila"] = this.statusVozila;
        data["statusVozilaId"] = this.statusVozilaId;
        data["pripadnostId"] = this.pripadnostId;
        data["pripadnost"] = this.pripadnost;
        data["grupaVozila"] = this.grupaVozila;
        data["grupaVozilaId"] = this.grupaVozilaId;
        data["podgrupaVozila"] = this.podgrupaVozila;
        data["podgrupaVozilaId"] = this.podgrupaVozilaId;
        data["tipMotoraVozilaId"] = this.tipMotoraVozilaId;
        data["tipMotoraVozila"] = this.tipMotoraVozila;
        data["kategorijaVozila"] = this.kategorijaVozila;
        data["kategorijaVozilaId"] = this.kategorijaVozilaId;
        data["aktivno"] = this.aktivno;
        data["brojSedista"] = this.brojSedista;
        data["brojOsovina"] = this.brojOsovina;
        data["brojMestaZaStajanje"] = this.brojMestaZaStajanje;
        data["primarnoGorivo"] = this.primarnoGorivo;
        data["normiranaPotrosnja"] = this.normiranaPotrosnja;
        return data; 
    }
}

export interface IVozilo {
    id: number;
    registarskaOznaka?: string | undefined;
    garazniBroj?: string | undefined;
    godinaProizvodnje: number;
    brojSasije?: string | undefined;
    brojMotora?: string | undefined;
    slika?: string | undefined;
    boja?: string | undefined;
    zapreminaMotora?: number | undefined;
    snagaMotora?: number | undefined;
    nosivost?: number | undefined;
    masaVozila?: number | undefined;
    ukupnaMasa?: number | undefined;
    datumPrveRegistracije?: Date | undefined;
    posedujeTahograf: boolean;
    markaVozila?: string | undefined;
    markaVozilaId?: number | undefined;
    modelVozila?: string | undefined;
    modelVozilaId?: number | undefined;
    tipVozila?: string | undefined;
    tipVozilaId?: number | undefined;
    statusVozila?: string | undefined;
    statusVozilaId?: number | undefined;
    pripadnostId?: number | undefined;
    pripadnost?: string | undefined;
    grupaVozila?: string | undefined;
    grupaVozilaId?: number | undefined;
    podgrupaVozila?: string | undefined;
    podgrupaVozilaId?: number | undefined;
    tipMotoraVozilaId?: number | undefined;
    tipMotoraVozila?: string | undefined;
    kategorijaVozila?: string | undefined;
    kategorijaVozilaId?: number | undefined;
    aktivno: boolean;
    brojSedista: number;
    brojOsovina: number;
    brojMestaZaStajanje: number;
    primarnoGorivo?: string | undefined;
    normiranaPotrosnja?: number | undefined;
}

export class NormativPotrosnjeGoriva implements INormativPotrosnjeGoriva {
    voziloId!: number;
    vrstaGorivaId!: number;
    vrstaGoriva?: string | undefined;
    normiranaPotrosnja!: number;
    dozvoljenoOdstupanje!: number;

    constructor(data?: INormativPotrosnjeGoriva) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.voziloId = _data["voziloId"];
            this.vrstaGorivaId = _data["vrstaGorivaId"];
            this.vrstaGoriva = _data["vrstaGoriva"];
            this.normiranaPotrosnja = _data["normiranaPotrosnja"];
            this.dozvoljenoOdstupanje = _data["dozvoljenoOdstupanje"];
        }
    }

    static fromJS(data: any): NormativPotrosnjeGoriva {
        data = typeof data === 'object' ? data : {};
        let result = new NormativPotrosnjeGoriva();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voziloId"] = this.voziloId;
        data["vrstaGorivaId"] = this.vrstaGorivaId;
        data["vrstaGoriva"] = this.vrstaGoriva;
        data["normiranaPotrosnja"] = this.normiranaPotrosnja;
        data["dozvoljenoOdstupanje"] = this.dozvoljenoOdstupanje;
        return data; 
    }
}

export interface INormativPotrosnjeGoriva {
    voziloId: number;
    vrstaGorivaId: number;
    vrstaGoriva?: string | undefined;
    normiranaPotrosnja: number;
    dozvoljenoOdstupanje: number;
}

export class TipVozila implements ITipVozila {
    id!: number;
    naziv?: string | undefined;
    grupaVozilaId?: number | undefined;

    constructor(data?: ITipVozila) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.grupaVozilaId = _data["grupaVozilaId"];
        }
    }

    static fromJS(data: any): TipVozila {
        data = typeof data === 'object' ? data : {};
        let result = new TipVozila();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["grupaVozilaId"] = this.grupaVozilaId;
        return data; 
    }
}

export interface ITipVozila {
    id: number;
    naziv?: string | undefined;
    grupaVozilaId?: number | undefined;
}

export class KategorijaVozila implements IKategorijaVozila {
    id!: number;
    naziv?: string | undefined;

    constructor(data?: IKategorijaVozila) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
        }
    }

    static fromJS(data: any): KategorijaVozila {
        data = typeof data === 'object' ? data : {};
        let result = new KategorijaVozila();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        return data; 
    }
}

export interface IKategorijaVozila {
    id: number;
    naziv?: string | undefined;
}

export class TipMotora implements ITipMotora {
    id!: number;
    naziv?: string | undefined;

    constructor(data?: ITipMotora) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
        }
    }

    static fromJS(data: any): TipMotora {
        data = typeof data === 'object' ? data : {};
        let result = new TipMotora();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        return data; 
    }
}

export interface ITipMotora {
    id: number;
    naziv?: string | undefined;
}

export class NacinNabavkeVozila implements INacinNabavkeVozila {
    id!: number;
    naziv?: string | undefined;

    constructor(data?: INacinNabavkeVozila) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
        }
    }

    static fromJS(data: any): NacinNabavkeVozila {
        data = typeof data === 'object' ? data : {};
        let result = new NacinNabavkeVozila();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        return data; 
    }
}

export interface INacinNabavkeVozila {
    id: number;
    naziv?: string | undefined;
}

export class NabavkaVozila implements INabavkaVozila {
    voziloId!: number;
    nacinNabavkeId!: number;
    nacinNabavke?: string | undefined;
    datumNabavke?: Date | undefined;
    nabavnaCena!: number;
    stanjeKilometraze!: number;
    brojMeseciOtplate!: number;
    mesecnaRata!: number;
    ucesce!: number;
    datumIstekaZakupa?: Date | undefined;
    napomena?: string | undefined;

    constructor(data?: INabavkaVozila) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.voziloId = _data["voziloId"];
            this.nacinNabavkeId = _data["nacinNabavkeId"];
            this.nacinNabavke = _data["nacinNabavke"];
            this.datumNabavke = _data["datumNabavke"] ? new Date(_data["datumNabavke"].toString()) : <any>undefined;
            this.nabavnaCena = _data["nabavnaCena"];
            this.stanjeKilometraze = _data["stanjeKilometraze"];
            this.brojMeseciOtplate = _data["brojMeseciOtplate"];
            this.mesecnaRata = _data["mesecnaRata"];
            this.ucesce = _data["ucesce"];
            this.datumIstekaZakupa = _data["datumIstekaZakupa"] ? new Date(_data["datumIstekaZakupa"].toString()) : <any>undefined;
            this.napomena = _data["napomena"];
        }
    }

    static fromJS(data: any): NabavkaVozila {
        data = typeof data === 'object' ? data : {};
        let result = new NabavkaVozila();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voziloId"] = this.voziloId;
        data["nacinNabavkeId"] = this.nacinNabavkeId;
        data["nacinNabavke"] = this.nacinNabavke;
        data["datumNabavke"] = this.datumNabavke ? this.datumNabavke.toISOString() : <any>undefined;
        data["nabavnaCena"] = this.nabavnaCena;
        data["stanjeKilometraze"] = this.stanjeKilometraze;
        data["brojMeseciOtplate"] = this.brojMeseciOtplate;
        data["mesecnaRata"] = this.mesecnaRata;
        data["ucesce"] = this.ucesce;
        data["datumIstekaZakupa"] = this.datumIstekaZakupa ? this.datumIstekaZakupa.toISOString() : <any>undefined;
        data["napomena"] = this.napomena;
        return data; 
    }
}

export interface INabavkaVozila {
    voziloId: number;
    nacinNabavkeId: number;
    nacinNabavke?: string | undefined;
    datumNabavke?: Date | undefined;
    nabavnaCena: number;
    stanjeKilometraze: number;
    brojMeseciOtplate: number;
    mesecnaRata: number;
    ucesce: number;
    datumIstekaZakupa?: Date | undefined;
    napomena?: string | undefined;
}

export class PolisaOsiguranja implements IPolisaOsiguranja {
    id!: number;
    vrsta?: string | undefined;
    voziloId!: number;
    osiguravajucaKucaId!: number;
    osiguravajucaKuca?: string | undefined;
    brojPolise?: string | undefined;
    vaziOd!: Date;
    vaziDo!: Date;
    osiguranaSuma!: number;
    premija!: number;
    porezNaPremiju!: number;
    ucesceUSteti!: number;
    minimalnoUcesce!: number;
    mesecnaRata!: number;
    premijskiStepen!: number;
    taksePriRegistraciji!: number;
    ukupno!: number;

    constructor(data?: IPolisaOsiguranja) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.vrsta = _data["vrsta"];
            this.voziloId = _data["voziloId"];
            this.osiguravajucaKucaId = _data["osiguravajucaKucaId"];
            this.osiguravajucaKuca = _data["osiguravajucaKuca"];
            this.brojPolise = _data["brojPolise"];
            this.vaziOd = _data["vaziOd"] ? new Date(_data["vaziOd"].toString()) : <any>undefined;
            this.vaziDo = _data["vaziDo"] ? new Date(_data["vaziDo"].toString()) : <any>undefined;
            this.osiguranaSuma = _data["osiguranaSuma"];
            this.premija = _data["premija"];
            this.porezNaPremiju = _data["porezNaPremiju"];
            this.ucesceUSteti = _data["ucesceUSteti"];
            this.minimalnoUcesce = _data["minimalnoUcesce"];
            this.mesecnaRata = _data["mesecnaRata"];
            this.premijskiStepen = _data["premijskiStepen"];
            this.taksePriRegistraciji = _data["taksePriRegistraciji"];
            this.ukupno = _data["ukupno"];
        }
    }

    static fromJS(data: any): PolisaOsiguranja {
        data = typeof data === 'object' ? data : {};
        let result = new PolisaOsiguranja();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["vrsta"] = this.vrsta;
        data["voziloId"] = this.voziloId;
        data["osiguravajucaKucaId"] = this.osiguravajucaKucaId;
        data["osiguravajucaKuca"] = this.osiguravajucaKuca;
        data["brojPolise"] = this.brojPolise;
        data["vaziOd"] = this.vaziOd ? this.vaziOd.toISOString() : <any>undefined;
        data["vaziDo"] = this.vaziDo ? this.vaziDo.toISOString() : <any>undefined;
        data["osiguranaSuma"] = this.osiguranaSuma;
        data["premija"] = this.premija;
        data["porezNaPremiju"] = this.porezNaPremiju;
        data["ucesceUSteti"] = this.ucesceUSteti;
        data["minimalnoUcesce"] = this.minimalnoUcesce;
        data["mesecnaRata"] = this.mesecnaRata;
        data["premijskiStepen"] = this.premijskiStepen;
        data["taksePriRegistraciji"] = this.taksePriRegistraciji;
        data["ukupno"] = this.ukupno;
        return data; 
    }
}

export interface IPolisaOsiguranja {
    id: number;
    vrsta?: string | undefined;
    voziloId: number;
    osiguravajucaKucaId: number;
    osiguravajucaKuca?: string | undefined;
    brojPolise?: string | undefined;
    vaziOd: Date;
    vaziDo: Date;
    osiguranaSuma: number;
    premija: number;
    porezNaPremiju: number;
    ucesceUSteti: number;
    minimalnoUcesce: number;
    mesecnaRata: number;
    premijskiStepen: number;
    taksePriRegistraciji: number;
    ukupno: number;
}

export class B2BPodatakVozila implements IB2BPodatakVozila {
    voziloId!: number;
    b2BProvajderId!: number;
    b2BProvajder?: string | undefined;
    tipProvajdera?: string | undefined;
    vrednost?: string | undefined;

    constructor(data?: IB2BPodatakVozila) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.voziloId = _data["voziloId"];
            this.b2BProvajderId = _data["b2BProvajderId"];
            this.b2BProvajder = _data["b2BProvajder"];
            this.tipProvajdera = _data["tipProvajdera"];
            this.vrednost = _data["vrednost"];
        }
    }

    static fromJS(data: any): B2BPodatakVozila {
        data = typeof data === 'object' ? data : {};
        let result = new B2BPodatakVozila();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voziloId"] = this.voziloId;
        data["b2BProvajderId"] = this.b2BProvajderId;
        data["b2BProvajder"] = this.b2BProvajder;
        data["tipProvajdera"] = this.tipProvajdera;
        data["vrednost"] = this.vrednost;
        return data; 
    }
}

export interface IB2BPodatakVozila {
    voziloId: number;
    b2BProvajderId: number;
    b2BProvajder?: string | undefined;
    tipProvajdera?: string | undefined;
    vrednost?: string | undefined;
}

export class GpsPozicija implements IGpsPozicija {
    voziloId!: number;
    vozilo?: string | undefined;
    longituda!: number;
    latituda!: number;
    ugao!: number;
    dodatniPodaci?: { [key: string]: any; } | undefined;

    constructor(data?: IGpsPozicija) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.voziloId = _data["voziloId"];
            this.vozilo = _data["vozilo"];
            this.longituda = _data["longituda"];
            this.latituda = _data["latituda"];
            this.ugao = _data["ugao"];
            if (_data["dodatniPodaci"]) {
                this.dodatniPodaci = {} as any;
                for (let key in _data["dodatniPodaci"]) {
                    if (_data["dodatniPodaci"].hasOwnProperty(key))
                        this.dodatniPodaci![key] = _data["dodatniPodaci"][key];
                }
            }
        }
    }

    static fromJS(data: any): GpsPozicija {
        data = typeof data === 'object' ? data : {};
        let result = new GpsPozicija();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voziloId"] = this.voziloId;
        data["vozilo"] = this.vozilo;
        data["longituda"] = this.longituda;
        data["latituda"] = this.latituda;
        data["ugao"] = this.ugao;
        if (this.dodatniPodaci) {
            data["dodatniPodaci"] = {};
            for (let key in this.dodatniPodaci) {
                if (this.dodatniPodaci.hasOwnProperty(key))
                    data["dodatniPodaci"][key] = this.dodatniPodaci[key];
            }
        }
        return data; 
    }
}

export interface IGpsPozicija {
    voziloId: number;
    vozilo?: string | undefined;
    longituda: number;
    latituda: number;
    ugao: number;
    dodatniPodaci?: { [key: string]: any; } | undefined;
}

export class TroskoviVozila implements ITroskoviVozila {
    troskoviOdrzavanja?: F_voz_TroskoviOdrzavanjaVozila[] | undefined;
    amortizacija?: Amortizacija[] | undefined;

    constructor(data?: ITroskoviVozila) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["troskoviOdrzavanja"])) {
                this.troskoviOdrzavanja = [] as any;
                for (let item of _data["troskoviOdrzavanja"])
                    this.troskoviOdrzavanja!.push(F_voz_TroskoviOdrzavanjaVozila.fromJS(item));
            }
            if (Array.isArray(_data["amortizacija"])) {
                this.amortizacija = [] as any;
                for (let item of _data["amortizacija"])
                    this.amortizacija!.push(Amortizacija.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TroskoviVozila {
        data = typeof data === 'object' ? data : {};
        let result = new TroskoviVozila();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.troskoviOdrzavanja)) {
            data["troskoviOdrzavanja"] = [];
            for (let item of this.troskoviOdrzavanja)
                data["troskoviOdrzavanja"].push(item.toJSON());
        }
        if (Array.isArray(this.amortizacija)) {
            data["amortizacija"] = [];
            for (let item of this.amortizacija)
                data["amortizacija"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ITroskoviVozila {
    troskoviOdrzavanja?: F_voz_TroskoviOdrzavanjaVozila[] | undefined;
    amortizacija?: Amortizacija[] | undefined;
}

export class F_voz_TroskoviOdrzavanjaVozila implements IF_voz_TroskoviOdrzavanjaVozila {
    datum!: Date;
    tipDokumenta?: string | undefined;
    broj?: string | undefined;
    dobavljac?: string | undefined;
    iznos!: number;

    constructor(data?: IF_voz_TroskoviOdrzavanjaVozila) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.datum = _data["datum"] ? new Date(_data["datum"].toString()) : <any>undefined;
            this.tipDokumenta = _data["tipDokumenta"];
            this.broj = _data["broj"];
            this.dobavljac = _data["dobavljac"];
            this.iznos = _data["iznos"];
        }
    }

    static fromJS(data: any): F_voz_TroskoviOdrzavanjaVozila {
        data = typeof data === 'object' ? data : {};
        let result = new F_voz_TroskoviOdrzavanjaVozila();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["datum"] = this.datum ? this.datum.toISOString() : <any>undefined;
        data["tipDokumenta"] = this.tipDokumenta;
        data["broj"] = this.broj;
        data["dobavljac"] = this.dobavljac;
        data["iznos"] = this.iznos;
        return data; 
    }
}

export interface IF_voz_TroskoviOdrzavanjaVozila {
    datum: Date;
    tipDokumenta?: string | undefined;
    broj?: string | undefined;
    dobavljac?: string | undefined;
    iznos: number;
}

export class Amortizacija implements IAmortizacija {
    godina!: number;
    mesec!: number;
    iznosAmortizacije!: number;
    preostaliIznos!: number;

    constructor(data?: IAmortizacija) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.godina = _data["godina"];
            this.mesec = _data["mesec"];
            this.iznosAmortizacije = _data["iznosAmortizacije"];
            this.preostaliIznos = _data["preostaliIznos"];
        }
    }

    static fromJS(data: any): Amortizacija {
        data = typeof data === 'object' ? data : {};
        let result = new Amortizacija();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["godina"] = this.godina;
        data["mesec"] = this.mesec;
        data["iznosAmortizacije"] = this.iznosAmortizacije;
        data["preostaliIznos"] = this.preostaliIznos;
        return data; 
    }
}

export interface IAmortizacija {
    godina: number;
    mesec: number;
    iznosAmortizacije: number;
    preostaliIznos: number;
}

export class F_voz_ZaglavljePregledaVozila implements IF_voz_ZaglavljePregledaVozila {
    troskoviGoriva!: number;
    troskoviOdrzavanja!: number;
    kilometraza!: number;

    constructor(data?: IF_voz_ZaglavljePregledaVozila) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.troskoviGoriva = _data["troskoviGoriva"];
            this.troskoviOdrzavanja = _data["troskoviOdrzavanja"];
            this.kilometraza = _data["kilometraza"];
        }
    }

    static fromJS(data: any): F_voz_ZaglavljePregledaVozila {
        data = typeof data === 'object' ? data : {};
        let result = new F_voz_ZaglavljePregledaVozila();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["troskoviGoriva"] = this.troskoviGoriva;
        data["troskoviOdrzavanja"] = this.troskoviOdrzavanja;
        data["kilometraza"] = this.kilometraza;
        return data; 
    }
}

export interface IF_voz_ZaglavljePregledaVozila {
    troskoviGoriva: number;
    troskoviOdrzavanja: number;
    kilometraza: number;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}